/* RideRow chat diagnosis (GT-20261022-204048-d749ff r1, cc13, 2026-10-23). Section: sections/rr-diag-chat.liquid.
   Looks like a chat, one question per screen, answers are picture cards (our own inline SVG drawings, no logo photos).
   The deterministic engine decides everything: POST <api_base>/diag2 with all answers (same Worker as diagnosis v2 + buy gate
   GT-20261022-203435-cb2aa2; this file does not change the engine). It sends the questions, the next question, the count of parts,
   per-option counts, the funnel and the gate. This page only shows them with short words.
   Typed text and photos: a rule parser (no AI, no paid API) turns text like "48v julet 5pin" into structured values. Each value shows
   as a confirm card. Only "Yes" writes it into the answers that go to the engine; "No" goes back to the picture cards. The parser
   gives only question ids, option values and our own labels: never part names, SKUs, prices or "fits" words (filterAI() enforces the
   same for the AI branch). AI parse is a switch (data-ai-parse, section setting ai_parse, default off). AI off: photos go to the hand-off
   screen and the cb2aa2 diagnosis request (POST /diag2/upload + /diag2/request, Shopify metaobject, report page); a person checks them.
   Answers stay in localStorage "rr-diag2-v1" (same shape as rr-diag2.js), so /pages/diagnosis-request still reads them.
   Buy gate: parts, prices and "Add to cart" show only when the engine says status "results", gate.open, and every required question
   is answered (checked again here, same as rr-diag2.js). Languages: window.RR_DIAG_CHAT_I18N (assets/rr-diag-chat-i18n.js).
   Fixes after the customer test (GT-20261023-084423-d648fa r1, cc13): (1) a new part = a new branch: answers of the old part's questions
   are cleared (questions ids are shared, e.g. motor plug and power for motor and controller), stale options too; (2) counter: status words on
   the summary and hand-off, "0 parts fit" at once, "up to N" before the part is known; (3) typed plug shape and pin count become confirm
   cards and go to the plug questions of the part the customer picks; (4) 24 / 60 / 72 V cards; (5) "Continue / Start again" after a reload
   or a language change, "Start again" on every screen; (6) part card: product photo, 3 "why" rows + "Show all", max 2 notes, one ship-check
   line; (7) tire width: OPTIONAL for motors (must_optional.json), a note only.
   Customer test round 1 (F1023-1357dd, cc26): typed values the catalog does not have go to 0 parts at once (engine r2-typed0); part card:
   every check row shows (no "Show all" for checks), "N of N checks pass", the two rows of one plug are one row, an axle row with a photo
   mark (axle is a recorded question, the catalog has no axle data), the 135 / 138 mm reason under the dropout row, "Request fit check"
   with one line on what happens; hand-off: all answers in a fold-out list, the answer that stopped the search marked; protocol question:
   pictures of where the label is and a label photo button; wheel cards: big numbers; an earlier "Not sure" shows as "Chip: Not sure" in
   grey; smaller footer headings on this page (css).
   Customer test round 3 (F1023-1752fx, cc27): (1) part photos: our product photos show the part small in a big grey area, so a card
   looked like an empty grey frame; the photo is cropped to the part (pixels read on a canvas, cdn.shopify.com allows CORS), and while
   it loads or when it fails the card shows our drawing, never an empty frame; (2) hand-off "Your answers (N)": the list is open at
   once with a fold arrow, the answer that stopped the search first and marked; (3) summary "Are your answers right?": tapping an answer
   opens only that question, "Back to answers" returns without a change, a new answer returns to the summary (questions it changes are
   asked again); "Problem" asks "Change problem? Your answers will reset." first; (4) controller card: when the controller's rated
   power is lower than the motor power, one line says why it still fits.
   Customer test round 4 (F1024-1120ob, cc27): (1) summary row -> that question alone: no earlier question and answer above it; (2) tapping
   the answer that is already chosen goes back to the summary at once (nothing to ask the engine); (3) controller card "Motor power" row:
   "x" -> "×", "limit 750 W" -> "max allowed 750 W" (display only; the engine text is unchanged); (4) card photo: the photo address and the
   picture are fetched while the customer answers the last questions (cards with few parts left), and the photo fades in over our drawing.
   chat-7 (F1024-1831yl, cc28 sub-agent): (1) the final result screen tells the delivery time once: the slowest part sets the overall time and each
   part gets its own rough time (numbers come from the engine, resp.eta; no question, card, product page or list shows days); (2) brake cut-off
   lever questions K1-K5 (cable or hydraulic, bar size, plug pins and shape, reed 2-wire or Hall 3-wire, normally open or closed): every size
   must be answered and equal before the engine shows a lever.
   chat-8 (F1025-1112lw, cc26; Riderow manager desktop customer retest 2026-10-25, items 1-4): (1) "Part broken" asks the part first; the part list
   has two levels: electric parts + one "Mechanical part" card that opens 13 mechanical parts (seat post clamp, seat post, brake rotor, headset,
   bottom bracket, pedals, tire, inner tube, kickstand, fender, brake or gear cable, torque arm, axle nuts); each asks its sizes (engine r7-mech2,
   mechanical handbook ch. k); with no part in stock the engine still asks every size, then the hand-off screen sends the sizes with the request;
   typed part names ("seat post clamp") and a typed size before the part ("31.8 mm") are kept and answer the right question; (2) the hand-off
   screen asks for photos that fit the part (brake lever: lever, plug, controller label, bar; mechanical: part on the bike, old part, size marks,
   part and ruler); the engine drops motor / battery / wheel questions for these parts, so they are not in the answer list; (3) brake levers ask
   K1-K5 before the hand-off; (4) bike and label questions get a "Type it" card with a text box (no supplier brand cards: public pages name no
   supplier brands, entry.SUPPLIER_RE). With 0 parts and questions left, the counter says "We find it for you · N questions left".
   chat-9 (F1025-1907uf, cc26; Chris 10-25 decision card 54 = A: "大小螺纹" means the freewheel thread, about 35 mm vs 30 mm): a 14th
   mechanical part "Screw-on freewheel" (engine r8-thread1) asks J1 the hub thread (big 35 mm = 1.375 in x 24, small 30 mm = 30 x 1 mm) and
   J2 the sprocket count; typed "大小螺纹" / "大螺纹" / "飞轮" / "freewheel" / "rueda libre" / "roda livre" picks it (a cassette does not).
   chat-10 (F1026-0951fl, cc26; Riderow manager desktop customer retest 2026-10-26, items 1-5; engine unchanged): (1) "Part broken" goes to the part
   list at once; the code question comes after an electric part (or "Not sure"), never after a mechanical part, so mechanical hand-offs carry no
   "Code" answer; (2) a required answer given as "Not sure" (e.g. the protocol) no longer ends in "1 answer missing" + "Get help": the counter says
   "1 part may fit", the summary says a person checks the unsure answers on photos and offers "Request fit check" (all answers go with it) and, for
   the protocol, "Find the protocol"; (3) the lever sensor question says the switch cuts the motor power when you brake (the wire counts stay on
   the cards); (4) "Start again" shows the first screen at once (the engine call follows); (5) each result card has a "View part" link to the
   product page (new tab; /variants/<id>, so this page names no product handle); the button stays "Request fit check".
   chat-11 (F1026-1354jo, cc29; Riderow manager retest of chat-10, two copy fixes only, no rule / price / title / handle change): (1) the top bar of the
   summary screen says "1 part may fit" (same words as the text under the answers) when only "Not sure" answers keep the gate closed, instead of
   "We check the fit for you"; (2) the card note for a controller rated under the motor power reads "Rated 350 W (672 W peak). Your 500 W motor runs
   fine, with a little less top power." instead of "...The motor runs, with less top power."
   chat-12 (F1029-1307sz, cc27; Riderow manager order after Chris picked "list the harness and the programming cable" on 10-29): two electric parts
   for mid-drive kits, "Mid-drive main cable" and "Programming cable" (engine r9-mid1, questions Z1-Z8: motor type, protocol, plug pins, the plugs
   at the other end, length; display plug). They show in the electric part list on "Part broken", on "Motor dead" / "Power cuts out" (both) and
   "Display dark" (main cable) when the motor is at the pedals; never for a hub motor. Like the brake levers, only their own questions and the
   optional bike question are asked. The engine shows them with "We check before we ship" (protocol and plugs on the customer's photos), so the
   card button is "Request fit check". Typed "programming cable" / "编程线" / "1-to-4 cable" / "中置主线" pick them.
   chat-13 (F1030-1152lf, cc27; Riderow manager acceptance of the delivery-time order): (1) the cards on one result screen are choices for one part
   (engine r11-resfix1, eta.need "one"), so the delivery line no longer uses the slowest card: "You need only one of these parts. The fastest one
   arrives in about 5 to 6 days." (or "Each one arrives in about N days." when every card has the same time, then no list under it); the slowest-part
   line stays for parts bought together (need "all"; no result screen sends it today) and for an older engine; (2) cards with the same name show one
   short line with how they differ (engine results[].tell: screen, USB port, button pad, bar size, battery voltage; never a model code). */
(function () {
  "use strict";
  var VERSION = "chat-15";

  /* ================================================================ words (English source; every string has a role for the checker) */
  var UI = {
    start_q: ["What is wrong? Tap one.", "q"],
    code_q: ["Does the screen show a code?", "q"],
    code_hint: ["Type the code, for example 21.", "hint"],
    no_code: ["No code", "btn"],
    confirm_q: ["Is this right?", "q"],
    yes: ["Yes", "btn"],
    no: ["No", "btn"],
    not_sure: ["Not sure", "btn"],
    skip: ["Skip", "btn"],
    back: ["Back", "btn"],
    send: ["Send", "btn"],
    type_here: ["Type here", "ph"],
    note_ph: ["Note (optional)", "ph"],
    add_note: ["Add a note", "aria"],
    add_photo: ["Add a photo", "aria"],
    checks_q: ["Try these quick checks first.", "q"],                 /* r3 fix 3: one checklist screen */
    works_now: ["It works now", "btn"],
    works_t: ["Good. The bike works now.", "title"],
    find_part: ["Find a part", "btn"],
    start_again: ["Start again", "btn"],
    photo_hint: ["We check this photo by hand.", "hint"],
    use_photo: ["Use photo", "btn"],
    pick_card: ["Pick a card", "btn"],
    sum_q: ["Are your answers right?", "q"],
    sum_hint: ["Tap an answer to change it.", "hint"],
    all_set: ["All set ✔", "label"],
    need_one: ["{n} answer missing", "label"],
    need_many: ["{n} answers missing", "label"],
    see_parts: ["See parts", "btn"],
    get_help: ["Get help", "btn"],
    res_one: ["This part fits your bike.", "title"],
    res_many: ["These parts fit your bike.", "title"],
    fits_badge: ["Fits your bike", "label"],
    why: ["Why it fits", "btn"],
    check_ship: ["We check before we ship", "label"],
    sell: ["We help you fix most e-bikes on the market.", "sell"],
    add_cart: ["Add to cart", "btn"],
    added: ["Added", "btn"],
    go_cart: ["Go to cart", "btn"],
    try_again: ["Try again", "btn"],
    check_fit: ["Request fit check", "btn"],
    fit_line: ["We check your photos and email you. You do not pay before you approve.", "label"],
    checks_ok: ["{n} of {m} checks pass", "label"],
    axle_check: ["We check it on your photo before we ship.", "data"],
    old_note: ["A 138 mm motor fits a 135 mm frame. The frame opens 1.5 mm on each side.", "data"],
    ans_n: ["Your answers ({n})", "label"],
    proto_where: ["Find the protocol on a label:", "label"],
    proto_disp: ["Display back", "label"],
    proto_cable: ["Cable sticker", "label"],
    proto_ctl: ["Controller label", "label"],
    proto_look: ["Look for CAN or UART.", "label"],
    proto_photo: ["Add label photo", "btn"],
    more_parts: ["More parts that fit", "label"],
    change: ["Change answers", "btn"],
    help_t: ["We check the fit for you.", "title"],
    help_hint: ["Send 4 photos and your email.", "hint"],
    source_t: ["We find this part for you.", "title"],
    source_hint: ["We send a quote before you pay.", "hint"],
    fit_t: ["We check this part for you.", "title"],
    still_need: ["Still needed", "label"],
    slot_bike: ["Whole bike", "label"],
    slot_plug: ["Plug close-up", "label"],
    slot_display: ["Display", "label"],
    slot_dropout: ["Dropout", "label"],
    chat_photos: ["Your photos", "label"],
    email: ["Email", "label"],
    consent: ["You can use my photos and email for this request.", "consent"],
    send_req: ["Send request", "btn"],
    full_form: ["Open full form", "btn"],
    sending: ["We send your request.", "hint"],
    sent: ["We got your request: {ref}.", "title"],
    err_net: ["Check your connection.", "hint"],
    err_send: ["Your request did not go out.", "hint"],
    err_photo: ["Use JPEG, PNG or WEBP under 10 MB.", "hint"],
    err_email: ["Type your email and tick the box.", "hint"],
    drawer_t: ["Your answers", "title"],
    close: ["Close", "aria"],
    remove: ["Remove", "aria"],
    find_it: ["We find it for you", "counter"],
    parts_one: ["{n} part fits", "counter"],
    parts_many: ["{n} parts fit", "counter"],
    left_one: ["{n} question left", "counter"],
    left_many: ["{n} questions left", "counter"],
    loading: ["Loading", "counter"],
    skipped: ["Skipped", "chip"],
    unsure_chip: ["Not sure", "chip"],
    code_chip: ["Code", "chip"],
    resume_q: ["Continue where you left off?", "q"],
    resume: ["Continue", "btn"],
    check_c: ["We check the fit for you", "counter"],
    upto_many: ["up to {n} questions left", "counter"],
    zero_pre: ["0 parts fit", "counter"],
    show_all: ["Show all", "btn"],
    other: ["Other", "btn"],                                          /* r3 fix 5: an Other card on the voltage question */
    sum_back: ["Back to answers", "btn"],                             /* r4 fix 3: edit one answer from the summary */
    reset_q: ["Change problem? Your answers will reset.", "q"],
    reset_yes: ["Change problem", "btn"],
    cancel: ["Cancel", "btn"],
    max_allowed: ["max allowed {n} W", "data"],                       /* r5 fix 3: the engine says "limit 750 W" */
    pw_note: ["Rated {pw} W ({peak} W peak). Your {mw} W motor runs fine, with a little less top power.", "data"],
    other_v: ["Type the voltage on the battery label.", "label"],
    other_ph: ["Example: 62", "ph"],
    tire_note: ["Tire width: {w}. We keep it as a note. It does not change the fit.", "label"],
    eta_title: ["Delivery time", "title"],                            /* chat-7: shown on the final result screen only */
    eta_p_range: ["This part arrives in about {a} to {b} days.", "label"],
    eta_p_one: ["This part arrives in about {n} days.", "label"],
    eta_a_range: ["All parts arrive in about {a} to {b} days. The slowest part sets the time.", "label"],
    eta_a_one: ["All parts arrive in about {n} days. The slowest part sets the time.", "label"],
    eta_c_range: ["You need only one of these parts. The fastest one arrives in about {a} to {b} days.", "label"],   /* chat-13: the cards are choices */
    eta_c_one: ["You need only one of these parts. The fastest one arrives in about {n} days.", "label"],
    eta_c_same_range: ["You need only one of these parts. Each one arrives in about {a} to {b} days.", "label"],
    eta_c_same_one: ["You need only one of these parts. Each one arrives in about {n} days.", "label"],
    eta_least_one: ["At least {n} days. We confirm the time for {u} part.", "label"],
    eta_least_many: ["At least {n} days. We confirm the time for {u} parts.", "label"],
    eta_none: ["We confirm the delivery time when we process your order.", "label"],
    eta_t_range: ["About {a} to {b} days", "label"],
    eta_t_one: ["About {n} days", "label"],
    eta_t_unk: ["We confirm later", "label"],
    eta_more: ["+{n} more", "label"],
    mech_part: ["Mechanical part", "btn"],                            /* chat-8: the part list has two levels */
    elec_parts: ["Electric parts", "btn"],
    mech_hint: ["We ask for the sizes and find the part for you.", "hint"],
    type_it: ["Type it", "btn"],                                      /* chat-8: a text box on the bike and label questions */
    box_b7: ["Type the brand or the text on the label.", "label"],
    box_b6: ["Type the brand and model of the bike.", "label"],
    ph_b7: ["Brand or text", "ph"],
    ph_b6: ["Brand and model", "ph"],
    slot_lever: ["Brake lever", "label"],                             /* chat-8: hand-off photos that fit the part */
    slot_lplug: ["Lever plug", "label"],
    slot_ctl: ["Controller label", "label"],
    slot_bar: ["Bar and ruler", "label"],
    slot_onbike: ["Part on the bike", "label"],
    slot_old: ["Old part", "label"],
    slot_marks: ["Size marks", "label"],
    slot_ruler: ["Part and ruler", "label"],
    maybe_one: ["{n} part may fit", "counter"],                       /* chat-10: a required answer is "Not sure" */
    maybe_many: ["{n} parts may fit", "counter"],
    idk_st_one: ["{n} part may fit. We check the unsure answers on your photos.", "label"],
    idk_st_many: ["{n} parts may fit. We check the unsure answers on your photos.", "label"],
    find_proto: ["Find the protocol", "btn"],
    we_check: ["We check", "label"],
    rq_t: ["Tell us 3 things first.", "label"],                       /* F1103-1916ga item 1: Get help needs part, battery voltage, bike */
    rq_hint: ["Not sure? Select Not sure.", "label"],
    rq_pick: ["Select", "ph"],
    rq_bike_ph: ["Brand and model", "ph"],
    err_req: ["Answer the 3 questions first.", "hint"],
    ph_tips_t: ["Photos that help us most:", "label"],                 /* F1103-1916ga item 4: photo guide */
    ph_tip1: ["The broken part, close up.", "label"],
    ph_tip2: ["Its plug, straight on, so we can count the pins.", "label"],
    ph_tip3: ["Any label: on the battery, the controller, the motor or the back of the display.", "label"],
    ph_tip4: ["The whole bike from the side.", "label"],
    slot_part: ["Broken part", "label"],
    slot_labels: ["Labels", "label"],
    view_part: ["View part", "btn"],                                  /* chat-10: result card link to the product page */
    h1: ["Diagnose your e-bike", "title"],
    legal: ["RideRow sells replacement parts and gives installation information. We do not perform repairs.", "legal"]
  };
  /* six symptom cards on the first screen (engine question B1; the sixth = "I do not know") */
  var SYM = [["motor_off", "Motor dead", "sym_motor"], ["display_off", "Display dark", "sym_display"],
             ["cuts_out", "Power cuts out", "sym_cut"], ["no_charge", "No charging", "sym_charge"],
             ["broken", "Part broken", "sym_broken"], [null, "Not sure", "unsure"]];
  /* free checks: up to 3 quick checks on one screen, one picture + one short line each (no parts, no engine).
     r3 fix 3 (customer round 2): one checklist screen + one button, was one screen per check with Fixed / Not fixed. */
  var CHECKS = {
    motor_off: [["Release both brake levers.", "chk_brake"], ["Push each plug in fully.", "chk_plug"], ["Charge the battery fully.", "chk_charge"]],
    display_off: [["Charge the battery fully.", "chk_charge"], ["Turn on the battery switch.", "chk_switch"], ["Push the display plug in fully.", "chk_dplug"]],
    cuts_out: [["Charge the battery fully.", "chk_charge"], ["Push each plug in fully.", "chk_plug"], ["Release both brake levers.", "chk_brake"]],
    no_charge: [["Push the charger plug in fully.", "chk_cplug"], ["Turn on the battery switch.", "chk_switch"], ["Use a different wall outlet.", "chk_outlet"]],
    broken: [],
    idk: [["Charge the battery fully.", "chk_charge"], ["Push each plug in fully.", "chk_plug"], ["Release both brake levers.", "chk_brake"]]
  };
  var STILL = { motor_off: "I did these. Still dead.", display_off: "I did these. Still dark.", cuts_out: "I did these. Still cuts out.",
                no_charge: "I did these. Still not charging.", idk: "I did these. Still not working." };   /* wording dictated by the customer test */
  /* engine questions: short question, one hint, chip name (engine ids from site/api/src/rrdiag2.py QS) */
  var QC = {
    B1: ["What is wrong? Tap one.", null, "Problem"],
    B2: ["Where is the motor?", "A hub motor sits in the wheel center.", "Motor"],
    B3: ["What voltage is on the battery label?", "Do not use the number on the charger.", "Battery"],
    B4: ["What wheel size is on the tire?", "The first tire number is the wheel size.", "Wheel"],
    B5: ["What tire width is on the tire?", "The second tire number is the width.", "Tire width"],
    B6: ["What bike do you have?", "Type the brand and model if you know it.", "Bike"],
    B7: ["Is there a label on the motor or controller?", "Type the text on the label.", "Label"],
    P0: ["Which part do you want to replace?", null, "Part"],
    M3: ["How wide is the dropout?", "Measure from inside face to inside face.", "Dropout"],
    M4: ["What axle does the wheel use?", "Look at the ends of the axle.", "Axle"],
    M6a: ["How many pins are in the motor plug?", "Count the pins, not the wires.", "Plug pins"],
    M6b: ["Tap the motor plug that looks like yours.", null, "Motor plug"],
    M7: ["Does the motor cable have Hall sensor wires?", "In the cable from the motor to the controller, Hall wires are the thin wires beside the 3 thick wires.", "Hall wires"],
    M8: ["What watts are on the motor label?", "Read the label on the motor.", "Power"],
    M9: ["What brake is on this wheel?", null, "Brake"],
    MG: ["What gears are on the rear wheel?", "Count the gears on the rear wheel.", "Gears"],
    C1: ["Where is the controller?", "Follow the motor cable to a metal box.", "Controller place"],
    C2b: ["What max amps are on the battery label?", "Look for max discharge or BMS on the label.", "Battery amps"],
    C2: ["What amps are on the old controller?", "Read the label on the old controller.", "Old controller"],
    C4: ["How many cables leave the controller?", "Count the cables that leave the box.", "Cables"],
    D1: ["What does the display show?", null, "Display shows"],
    D2: ["Does the screen show a code?", "Type the code, for example 21.", "Code"],
    D3: ["What protocol is on the label?", "Do not guess the protocol.", "Protocol"],
    D4: ["How many pins are in the display plug?", "Count the pins, not the wires.", "Display pins"],
    D5: ["Tap the display plug that looks like yours.", null, "Display plug"],
    D6: ["What is the handlebar size at the display?", "Measure the bar next to the display.", "Bar size"],
    W2: ["Which cable do you need?", "Follow the cable to the part at its end.", "Cable"],
    W3a: ["Tap the cable plug that looks like yours.", null, "Cable plug"],
    W3b: ["How many pins are in the plug?", "Count the pins, not the wires.", "Cable pins"],
    W3c: ["Which plug ends do you need?", "A male plug has pins.", "Cable ends"],
    W4: ["How long is the old cable?", "Measure the old cable from plug to plug.", "Length"],
    T1: ["What throttle do you have?", null, "Throttle"],
    T2: ["Which side is the throttle on?", null, "Side"],
    T3: ["Where does the throttle cable go?", null, "Throttle cable"],
    T4a: ["Tap the throttle plug that looks like yours.", null, "Throttle plug"],
    T4: ["How many pins are in the throttle plug?", "Count the pins, not the wires.", "Throttle pins"],
    K1: ["What brake lever do you have?", "Look at what goes to the brake: a thin wire or a thick hose.", "Brake type"],
    K2: ["What is the handlebar size at the lever?", "Measure the bar next to the lever.", "Lever bar"],
    K3: ["How many pins are in the lever plug?", "Count the pins, not the wires.", "Lever pins"],
    K3a: ["Tap the lever plug that looks like yours.", null, "Lever plug"],
    K4: ["What sensor is in the lever?", "This switch cuts the motor power when you brake.", "Lever sensor"],   /* chat-10 item 3; wire counts are on the cards */
    K5: ["Is the lever switch normally open or closed?", "Read NO or NC on the old lever or the controller label.", "Switch type"],
    G1: ["What is the seat tube diameter?", "Measure the frame tube under the clamp.", "Seat tube"],          /* chat-8: mechanical parts */
    G2: ["How does the clamp close?", "A lever opens without tools.", "Clamp type"],
    S1: ["What is the seat post diameter?", "Read the size printed on the old post.", "Post diameter"],
    S2: ["How long must the seat post be?", "Measure the old post from end to end.", "Post length"],
    R1: ["How does the rotor attach to the hub?", "Look at the center of the rotor.", "Rotor mount"],
    R2: ["What is the rotor diameter?", "Measure edge to edge through the center.", "Rotor size"],
    R3: ["How thick is the rotor?", "Measure the braking surface with a caliper.", "Rotor thickness"],
    N1: ["What size is the fork steerer tube?", "The steerer is the fork tube inside the frame.", "Steerer"],
    N2: ["Does the steerer have a thread at the top?", "A threaded headset has a large nut under the stem.", "Steerer thread"],
    N3: ["What is the head tube diameter at the top?", "Measure inside the frame tube without the fork.", "Head tube top"],
    N4: ["What is the head tube diameter at the bottom?", "Measure inside the frame tube without the fork.", "Head tube bottom"],
    O1: ["What bottom bracket shell does the frame have?", "Read the text on the old cups.", "Shell type"],
    O2: ["How wide is the bottom bracket shell?", "Measure the frame shell, not the cups.", "Shell width"],
    O3: ["What axle does the crank use?", "Look at the axle end under the crank bolt.", "Crank axle"],
    O4: ["How long is the bottom bracket axle?", "Read the length on the old bottom bracket.", "Axle length"],
    E1: ["What pedal thread does the crank use?", "Most cranks use 9/16 in.", "Pedal thread"],
    F1: ["What is the ISO size on the tire?", "Use the second number, for example 559 in 50-559.", "Tire ISO size"],
    F2: ["What tire width is on the tire?", "The second tire number is the width.", "Tire width"],
    U1: ["What is the ISO size on the tire?", "Use the second number, for example 559 in 50-559.", "Tire ISO size"],
    U2: ["What tire width is on the tire?", "The second tire number is the width.", "Tire width"],
    U3: ["Which valve does the tube need?", "Look at the valve on the old tube.", "Valve"],
    V1: ["Where does the kickstand mount?", "Look behind the pedals and at the rear axle.", "Stand mount"],
    V2: ["What wheel size is on the tire?", "The first tire number is the wheel size.", "Wheel"],
    X1: ["Which fender do you need?", null, "Fender"],
    X2: ["What wheel size is on the tire?", "The first tire number is the wheel size.", "Wheel"],
    X3: ["What tire width must the fender fit?", "The second tire number is the width.", "Tire width"],
    Y1: ["Which cable do you need?", null, "Cable use"],
    Y2: ["What handlebar does the bike have?", "A drop handlebar curves down at the ends.", "Handlebar"],
    Y3: ["How long must the cable be?", "Measure the old inner wire from end to end.", "Cable length"],
    H1: ["What is the motor axle diameter?", "Measure the round part of the axle.", "Axle diameter"],
    H2: ["How wide are the axle flats?", "Measure from one flat side to the other.", "Axle flats"],
    H3: ["How wide is the dropout slot?", "Measure the slot where the axle sits.", "Dropout slot"],
    A1: ["What is the axle thread size?", "Read the size on the axle end or the old nut.", "Axle thread"],
    A2: ["Does the axle have flat sides?", null, "Axle flats"],
    J1: ["Which thread is on the hub?", "Measure the hub thread with a caliper.", "Freewheel thread"],     /* chat-9: screw-on freewheel */
    J2: ["How many sprockets does the freewheel have?", "Count the sprockets on the old freewheel.", "Sprockets"],
    Z1: ["What motor do you have?", "A kit motor is a box under the pedals.", "Motor type"],        /* chat-12: mid-drive kit parts */
    Z2: ["What protocol is on the motor label?", "Do not guess the protocol.", "Protocol"],
    Z3: ["How many pins at the motor end?", "Unplug the main cable at the motor.", "Motor plug pins"],
    Z4: ["Which plugs are at the other end?", "Follow the main cable to the handlebar.", "Cable plugs"],
    Z5: ["How long is the old main cable?", "Measure from the motor plug to the longest branch.", "Length"],
    Z6: ["What motor do you have?", "A kit motor is a box under the pedals.", "Motor type"],
    Z7: ["What protocol is on the motor label?", "Do not guess the protocol.", "Protocol"],
    Z8: ["Which plug does the display use?", "Unplug the display to see its plug.", "Display plug"],
    "@conn": [null, null, "Plug"],            /* typed plug shape / pin count before the part is known (fix 3): kept, then answers */
    "@pins": [null, null, "Plug pins"],       /* the plug questions of the part the customer picks (CARRY_Q) */
    "@mm": [null, null, "Size"]               /* chat-8: a typed size in mm before the part is known (CARRY_Q, one question only) */
  };
  var MM = function (xs) { var o = {}; xs.forEach(function (x) { o[x] = x + " mm"; }); return o; };
  var ISO = { "406": "20 in (406)", "507": "24 in (507)", "559": "26 in (559)", "584": "27.5 in (584)", "622": "29 / 700C (622)" };   /* chat-8 */
  var TW = { "1.75": "1.75 in", "1.95": "1.95 in", "2.125": "2.125 in", "2.4": "2.4 in", "2.6": "2.6 in", "3": "3.0 in", "4": "4.0 in" };
  var WHL = { "20": "20 in", "24": "24 in", "26": "26 in", "27.5": "27.5 in", "29": "29 in / 700C" };
  var OPT = {
    B1: { motor_off: "Motor dead", display_off: "Display dark", cuts_out: "Power cuts out", broken: "Part broken", no_charge: "No charging" },
    B2: { front: "Front wheel", rear: "Rear wheel", mid: "At the pedals" },
    B3: { "24": "24 V", "36": "36 V", "48": "48 V", "52": "52 V", "60": "60 V", "72": "72 V" },
    B4: { "20": "20 in", "24": "24 in", "26": "26 in", "27.5": "27.5 in", "29": "29 in / 700C" },
    B5: { "lt2.5": "Under 2.5 in", "2.5-3": "2.5–3 in", "4": "4 in fat" },
    B6: { kit: "Kit build", factory: "Factory e-bike" },
    B7: { no_label: "No label", unclear: "Not clear" },
    P0: { motor: "Hub motor", controller: "Controller", display: "Display", cable: "Cable", throttle: "Throttle",
          brake_lever: "Brake levers", pas_sensor: "Pedal sensor", charger: "Charger", battery: "Battery",
          clamp: "Seat post clamp", seatpost: "Seat post", rotor: "Brake rotor", headset: "Headset", bottom_bracket: "Bottom bracket",
          pedals: "Pedals", tire: "Tire", tube: "Inner tube", kickstand: "Kickstand", fender: "Fender", mech_cable: "Brake/gear cable",
          torque_arm: "Torque arm", axle_hardware: "Axle nuts", freewheel: "Freewheel",
          mid_harness: "Mid-drive main cable", prog_cable: "Programming cable" },
    M3: MM(["100", "135", "138", "142", "148", "170", "175", "190"]),
    M4: { nut: "Nut axle", qr: "Quick release", thru12: "12 mm thru-axle" },
    M6a: { "9": "9 pins", "10": "10 pins", "11": "11 pins" },
    M6b: { kit: "Kit-brand round", arrow9: "Higo-style arrows" },
    M7: { yes: "Yes", no: "No" },
    M8: { "250": "250 W", "350": "350 W", "500": "500 W", "750": "750 W", "1000": "1000 W", "1500": "1500 W" },
    M9: { disc: "Disc brake", rim: "Rim brake" },
    MG: { threaded_freewheel: "Screw-on, 6–7 speed", cassette: "Cassette, 8–11 speed", single: "Single speed" },
    C1: { box: "Box on frame", battery: "In battery mount", motor: "In the motor" },
    C2b: { "15": "15 A", "20": "20 A", "25": "25 A", "30": "30 A", "30plus": "Over 30 A" },
    C2: { "15": "15 A", "18-22": "18–22 A", "25-30": "25–30 A", gt30: "Over 30 A" },
    C4: { one: "1 main cable", several: "4–6 cables" },
    D1: { nothing: "Nothing", error: "Error code", off_again: "On, then off", works: "It works" },
    D2: { none: "No code" },
    D3: { can_kit: "CAN bus", uart_kit: "UART kit-brand", uart_generic: "UART generic", uart_sine: "UART sine-wave" },
    D4: { "5": "5 pins", "6": "6 pins" },
    D5: { kit: "Kit-brand round", sm: "SM / JST" },
    D6: MM(["22.2", "25.4", "31.8", "35"]),
    W2: { motor_cable: "Motor cable", display_cable: "Display cable", harness: "Main cable", cable: "Signal cable" },
    W3a: { kit: "Kit-brand round", round: "Julet-style round", sm: "SM / JST" },
    W3b: { "2": "2 pins", "3": "3 pins", "5": "5 pins", "9": "9 pins", "10": "10 pins", "11": "11 pins" },
    W3c: { "female+male": "Male + female", "female+female": "Two female", "bare_leads+male": "Male + bare wires",
           "bare_leads+female": "Female + bare wires" },
    W4: { "20": "20 cm +", "50": "50 cm +", "80": "80 cm +", "130": "130 cm +" },
    T1: { thumb: "Thumb", half_twist: "Half twist", full_twist: "Full twist" },
    T2: { right: "Right", left: "Left" },
    T3: { controller: "To controller", display: "To display", main: "To main cable" },
    T4a: { kit: "Kit-brand round", round: "Julet-style round", sm: "SM / JST" },
    T4: { "3": "3 pins", "6": "6 pins" },
    K1: { mechanical: "Cable brake", hydraulic: "Hydraulic brake" },
    K2: MM(["22.2", "25.4", "31.8", "35"]),
    K3: { "2": "2 pins", "3": "3 pins" },
    K3a: { kit: "Kit-brand round", round: "Julet-style round", sm: "SM / JST" },
    K4: { reed: "Reed, 2 wires", hall: "Hall, 3 wires" },
    K5: { no: "Normally open (NO)", nc: "Normally closed (NC)" },
    G1: MM(["28.6", "31.8", "34.9"]),                                 /* chat-8: mechanical parts */
    G2: { qr: "Quick release", bolt: "Bolt" },
    S1: MM(["25.4", "27.2", "30.4", "30.9", "31.6", "31.8", "33.9"]),
    S2: { "300": "300 mm +", "350": "350 mm +", "400": "400 mm +", "450": "450 mm +", "580": "580 mm +" },
    R1: { "6bolt": "6 bolts", centerlock: "Center Lock" },
    R2: MM(["160", "180", "203"]),
    R3: MM(["1.8", "2", "2.3"]),
    N1: { "1in": "1 in", "1_1_8": "1-1/8 in", tapered: "Tapered", "1_5": "1.5 in" },
    N2: { threadless: "Threadless", threaded: "Threaded" },
    N3: MM(["34", "41", "44", "49"]),
    N4: MM(["34", "41", "44", "47", "49", "56"]),
    O1: { english: "English thread", italian: "Italian thread", pf41: "Press-fit 41 mm", pf42: "Press-fit 42 mm", pf46: "Press-fit 46 mm" },
    O2: MM(["68", "73", "83", "86.5", "91.5", "100"]),
    O3: { square: "Square taper", hollow24: "24 mm hollow", splined: "Splined" },
    O4: MM(["110", "113", "118", "122.5", "127"]),
    E1: { "9_16": "9/16 in", "1_2": "1/2 in" },
    F1: ISO, U1: ISO, F2: TW, U2: TW, X3: TW,
    U3: { schrader: "Schrader (car)", presta: "Presta (thin)" },
    V1: { hole18: "18 mm plate", hole40: "40 mm plate", rear: "Rear axle", clamp: "Frame clamp" },
    V2: WHL, X2: WHL,
    X1: { front: "Front", rear: "Rear", pair: "Front + rear" },
    Y1: { brake: "Brake cable", gear: "Gear cable" },
    Y2: { flat: "Flat bar", drop: "Drop bar" },
    Y3: { "170": "170 cm +", "200": "200 cm +", "230": "230 cm +", "300": "300 cm +" },
    H1: MM(["12", "14", "15"]), H2: MM(["10", "11", "12"]), H3: MM(["9", "10", "12"]), A1: MM(["8", "10", "12", "14"]),
    A2: { flat: "Flat sides", round: "Round" },
    J1: { iso35: "Big · 35 mm", m30: "Small · 30 mm" },
    J2: { "1": "Single speed", "5": "5 speed", "6": "6 speed", "7": "7 speed", "8": "8 speed" },
    Z1: { bb_kit: "Kit under pedals", frame_built: "Built into frame", hub: "Hub motor" },           /* chat-12 */
    Z6: { bb_kit: "Kit under pedals", frame_built: "Built into frame", hub: "Hub motor" },
    Z2: { uart_kit: "UART kit-brand", can_kit: "CAN bus" }, Z7: { uart_kit: "UART kit-brand", can_kit: "CAN bus" },
    Z3: { "8": "8 pins", "6": "6 pins", "9": "9 pins" },
    Z4: { d1_t1_b2: "Display, throttle, brakes", d1_b2: "Display, brakes", other: "Other plugs" },
    Z5: { "80": "80 cm +", "100": "100 cm +", "130": "130 cm +" },
    Z8: { kit5: "Round 5-pin", kit_other: "Round, other pins", sm: "SM / JST" },
    "@conn": { kit: "Kit-brand round", round: "Julet-style round", arrow9: "Higo-style arrows", sm: "SM / JST" }
  };
  var UNIT = { B3: " V", B4: " in", B5: " in", M3: " mm", M8: " W", C2b: " A", C2: " A", D6: " mm", W4: " cm", M6a: " pins", D4: " pins",
               W3b: " pins", T4: " pins", K2: " mm", K3: " pins", "@pins": " pins", "@mm": " mm",
               G1: " mm", S1: " mm", S2: " mm", R2: " mm", R3: " mm", N3: " mm", N4: " mm", O2: " mm", O4: " mm", H1: " mm", H2: " mm",
               H3: " mm", A1: " mm", F2: " in", U2: " in", X3: " in", V2: " in", X2: " in", Y3: " cm", Z3: " pins", Z5: " cm" };
  var MEASURE = { B4: 1, B5: 1, M3: 1, D6: 1, W4: 1, K2: 1,       /* S6 = measuring / reading question with a big picture on top */
                  G1: 1, S1: 1, S2: 1, R2: 1, R3: 1, N3: 1, N4: 1, O2: 1, O4: 1, F1: 1, F2: 1, U1: 1, U2: 1, V2: 1, X2: 1, X3: 1, Y3: 1,
                  H1: 1, H2: 1, H3: 1, A1: 1 };
  /* chat-8: mechanical parts in the part list (engine rrdiag2.MECH_PARTS); they show behind one "Mechanical part" card */
  var MECHP = { clamp: 1, seatpost: 1, rotor: 1, headset: 1, bottom_bracket: 1, pedals: 1, tire: 1, tube: 1, kickstand: 1, fender: 1,
                mech_cable: 1, torque_arm: 1, axle_hardware: 1, freewheel: 1 };
  /* fix 4: battery cards the engine does not list (it lists 36 / 48 / 52). The catalog has 24 V and 60 V displays and 72 V
     controllers / displays (kb compat_attrs); a tap sends {other: "72"}, the same as typing 72 (exact match, 72 V never matches 60 V). */
  var EXTRA_V = ["24", "60", "72"];
  /* fix 3: a typed plug shape / pin count with no plug question on the list yet (the part is not known) waits here and answers the plug
     questions of the part the customer picks; one plug pair per part path (engine rrdiag2.PATH). */
  var CARRY_Q = { "@conn": ["M6b", "D5", "W3a", "T4a", "K3a"], "@pins": ["M6a", "D4", "W3b", "T4", "K3"],
                  "@mm": ["G1", "S1", "R2", "R3", "N3", "N4", "O2", "O4", "H1", "H2", "H3", "A1", "S2"] };
  /* chat-8: a carried size goes to the first size question of the part whose usual range holds it (once, then it is gone) */
  var MMR = { G1: [20, 40], S1: [20, 40], S2: [200, 700], R2: [120, 260], R3: [1, 4], N3: [25, 60], N4: [25, 60], O2: [60, 130], O4: [100, 140],
              H1: [8, 20], H2: [8, 14], H3: [8, 14], A1: [6, 20] };
  /* fix 2c: questions per part (engine rrdiag2.PATH; motor without MG on a front wheel); before the part is known the counter says "up to" */
  var PATH_N = { motor: 8, controller: 8, display: 6, cable: 5, throttle: 5, brake_lever: 6,    /* r3 fix 2: the controller path has no M7 (was 9) */
                 clamp: 2, seatpost: 2, rotor: 3, headset: 4, bottom_bracket: 4, pedals: 1, tire: 2, tube: 3, kickstand: 2, fender: 3,
                 mech_cable: 3, torque_arm: 3, axle_hardware: 2, freewheel: 2, mid_harness: 5, prog_cable: 3 };   /* chat-12 */
  var MIDP = { mid_harness: 1, prog_cable: 1 };   /* chat-12: electric parts that, like the brake levers, ask only their own questions + the bike */   /* chat-8: size questions; the optional bike question comes on top */
  var LAYER0 = ["B1", "B2", "B3", "B4", "B5", "B6", "B7", "P0"];
  var TEXTQ = { B6: 1, B7: 1, D2: 1 };        /* "type the text" questions: the typed text itself is always the first card */

  /* ================================================================ language */
  var LANGS = { "zh-CN": "zh", "zh-TW": "zh", zh: "zh", es: "es", "pt-BR": "pt", "pt-PT": "pt", pt: "pt" };
  var LOC = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || "en");
  var LANG = LANGS[LOC] || LANGS[LOC.split("-")[0]] || null;
  var DICT = (LANG && window.RR_DIAG_CHAT_I18N && window.RR_DIAG_CHAT_I18N[LANG]) || null;
  function L(s, vars) {
    var t = (DICT && DICT[s]) || s;
    return vars ? t.replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null ? String(vars[k]) : m; }) : t;
  }
  function U(k, vars) { return L(UI[k][0], vars); }
  function UN(n, one, many) { return L(UI[n === 1 ? one : many][0], { n: n }); }
  function strings() {                                       /* every English string and its role (ui_rules_check.py reads this) */
    var out = [], add = function (key, en, role) { if (en) out.push({ key: key, en: en, role: role }); };
    Object.keys(UI).forEach(function (k) { add("ui." + k, UI[k][0], UI[k][1]); });
    SYM.forEach(function (s) { add("sym." + s[0], s[1], "btn"); });
    Object.keys(CHECKS).forEach(function (k) { CHECKS[k].forEach(function (c, i) { add("check." + k + "." + i, c[0], "label"); }); });
    Object.keys(STILL).forEach(function (k) { add("still." + k, STILL[k], "btn"); });
    Object.keys(QC).forEach(function (q) { add("q." + q, QC[q][0], "q"); add("hint." + q, QC[q][1], "hint"); add("chip." + q, QC[q][2], "chip"); });
    Object.keys(OPT).forEach(function (q) { Object.keys(OPT[q]).forEach(function (v) { add("opt." + q + "." + v, OPT[q][v], "btn"); }); });
    Object.keys(UNIT).forEach(function (q) { add("unit." + q, UNIT[q], "unit"); });
    return out;
  }

  /* ================================================================ pictures (own drawings; numbers only, no words, no logos) */
  var K = "#23303A", A = "#0E8A8A", G = "#C9D3DC", P = "#F6F8FA", W = "#FFFFFF", H = "#F5A623";
  function svg(inner, vb) {
    return '<svg class="rrc__svg" viewBox="' + (vb || "0 0 96 72") + '" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' + inner + "</svg>";
  }
  function tx(x, y, s, size, fill) {
    return '<text x="' + x + '" y="' + y + '" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="' + (size || 14) +
      '" text-anchor="middle" fill="' + (fill || K) + '">' + s + "</text>";
  }
  function pinsAt(cx, cy, n, r, pr) {
    var o = "", pts = [];
    if (n <= 1) pts.push([cx, cy]);
    else if (n <= 6) { for (var i = 0; i < n; i++) { var a = -Math.PI / 2 + 2 * Math.PI * i / n; pts.push([cx + r * Math.cos(a), cy + r * Math.sin(a)]); } }
    else { pts.push([cx, cy]); for (var j = 0; j < n - 1; j++) { var b = -Math.PI / 2 + 2 * Math.PI * j / (n - 1); pts.push([cx + r * Math.cos(b), cy + r * Math.sin(b)]); } }
    pts.forEach(function (p) { o += '<circle cx="' + p[0].toFixed(1) + '" cy="' + p[1].toFixed(1) + '" r="' + (pr || 2.6) + '" fill="' + K + '"/>'; });
    return o;
  }
  function face(shape, n) {                                     /* plug seen from the front */
    n = n || 0;
    if (shape === "sm") {
      var o = '<rect x="20" y="22" width="56" height="30" rx="5" fill="' + G + '" stroke="' + K + '" stroke-width="2"/>' +
        '<rect x="40" y="13" width="16" height="10" rx="2" fill="' + A + '"/>';
      var k = n || 5;
      for (var i = 0; i < k; i++) o += '<rect x="' + (27 + i * (42 / Math.max(1, k - 1)) - 2).toFixed(1) + '" y="33" width="4" height="9" fill="' + K + '"/>';
      return svg(o);
    }
    var ring = shape === "kit" ? '<rect x="44" y="5" width="8" height="8" rx="1" fill="' + A + '"/>' :
      shape === "arrow9" ? '<path d="M14 36l7-6v12zM82 36l-7-6v12z" fill="' + A + '"/>' : '<path d="M48 4l5 7h-10z" fill="' + A + '"/>';
    return svg('<circle cx="48" cy="38" r="27" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><circle cx="48" cy="38" r="20" fill="' + W +
      '" stroke="' + K + '" stroke-width="1.5"/>' + ring + pinsAt(48, 38, n || (shape === "arrow9" ? 9 : 5), n > 6 ? 11 : 9, 2.6));
  }
  function bike(h) {
    var o = '<g fill="none" stroke="' + K + '" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="22" cy="50" r="16"/><circle cx="74" cy="50" r="16"/><path d="M22 50L38 28h26L74 50M38 28l8 22H22M46 50l18-22M38 28l-3-8M30 20h10M64 28l2-10h7"/></g>';
    var hl = { front: '<circle cx="74" cy="50" r="7" fill="' + A + '"/>', rear: '<circle cx="22" cy="50" r="7" fill="' + A + '"/>',
               mid: '<circle cx="46" cy="50" r="7" fill="' + A + '"/>', box: '<rect x="26" y="33" width="11" height="9" rx="2" fill="' + A + '"/>',
               battery: '<rect x="46" y="32" width="20" height="7" rx="2" fill="' + A + '" transform="rotate(-50 56 36)"/>',
               motor: '<circle cx="46" cy="50" r="7" fill="' + A + '"/><rect x="42" y="47" width="8" height="6" fill="' + W + '"/>' };
    return svg(o + (hl[h] || ""));
  }
  function label(s, kind) {                                     /* a sticker with a value: battery, motor, controller */
    var body = kind === "battery" ? '<rect x="8" y="14" width="80" height="46" rx="8" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><rect x="88" y="30" width="5" height="14" fill="' + K + '"/>'
      : kind === "motor" ? '<circle cx="48" cy="38" r="31" fill="' + G + '" stroke="' + K + '" stroke-width="2"/>'
      : '<rect x="10" y="12" width="76" height="50" rx="4" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><path d="M18 62v8M34 62v8M50 62v8M66 62v8" stroke="' + K + '" stroke-width="2"/>';
    return svg(body + '<rect x="22" y="24" width="52" height="26" rx="3" fill="' + W + '" stroke="' + H + '" stroke-width="2.5"/>' + tx(48, 43, s, 15));
  }
  function wheelNum(s) {                                        /* r2: the size in big digits in the wheel center (was a 12 px label) */
    var t = String(s).split(" / "), big = t[0], small = t[1] || "";
    /* r3 fix 4 (customer round 2): digits about 1.3x bigger (2 digits 23 -> 30, "27.5" 18 -> 22) on a thinner tire ring; the card picture
       is bigger too (CSS: 96 px, 88 px on phones), so a 2-digit size is about 27 px high on screen */
    return svg('<circle cx="48" cy="36" r="35" fill="' + K + '"/><circle cx="48" cy="36" r="29" fill="' + P + '"/>' +
      tx(48, small ? 38 : 46, big, big.length > 3 ? 22 : big.length > 2 ? 25 : 30) + (small ? tx(48, 56, small, 13, A) : ""));
  }
  function sticker(x, y, w, word) {                             /* a label with grey text lines and one word in a box (protocol help) */
    return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="26" rx="3" fill="' + W + '" stroke="' + H + '" stroke-width="2"/>' +
      '<path d="M' + (x + 5) + ' ' + (y + 8) + 'h' + (w - 10) + '" stroke="' + G + '" stroke-width="3"/>' + tx(x + w / 2, y + 22, word, 11);
  }
  function protoPic(where) {                                    /* r2 fix 5: where the protocol word is written */
    if (where === "display") return svg('<rect x="14" y="6" width="68" height="46" rx="7" fill="' + K + '"/><rect x="6" y="56" width="84" height="7" rx="3" fill="' + G + '"/>' +
      '<path d="M48 52v4" stroke="' + K + '" stroke-width="4"/>' + sticker(26, 16, 44, "CAN"));
    if (where === "cable") return svg('<path d="M4 40c16-2 24-2 40 0s26 2 48 0" fill="none" stroke="' + K + '" stroke-width="6" stroke-linecap="round"/>' +
      sticker(28, 26, 40, "UART"));
    return svg('<rect x="12" y="10" width="72" height="50" rx="5" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><path d="M84 22h10M84 34h10M84 46h10M2 28h10M2 42h10" stroke="' + K + '" stroke-width="2.4"/>' +
      sticker(24, 22, 48, "CAN"));
  }
  function tireW(w) {
    var rx = { n: 7, m: 12, f: 20 }[w];
    return svg('<ellipse cx="48" cy="36" rx="' + rx + '" ry="30" fill="' + K + '"/><ellipse cx="48" cy="36" rx="' + Math.max(2, rx - 5) + '" ry="22" fill="' + P + '"/>' +
      '<path d="M' + (48 - rx) + ' 68h' + (2 * rx) + '" stroke="' + H + '" stroke-width="3"/>');
  }
  function screen(kind) {                                       /* display on the handlebar */
    var base = '<rect x="6" y="56" width="84" height="7" rx="3" fill="' + G + '"/><rect x="18" y="10" width="60" height="42" rx="6" fill="' + K + '"/>';
    var s = { off: '<rect x="23" y="15" width="50" height="32" rx="3" fill="#3A4652"/>',
              code: '<rect x="23" y="15" width="50" height="32" rx="3" fill="#E6F4F1"/>' + tx(48, 38, "21", 16, K) + '<rect x="33" y="22" width="30" height="21" rx="3" fill="none" stroke="' + H + '" stroke-width="2.5"/>',
              flash: '<rect x="23" y="15" width="50" height="32" rx="3" fill="#3A4652"/><path d="M48 21v10M42 24a9 9 0 1 0 12 0" fill="none" stroke="' + W + '" stroke-width="2.5" stroke-linecap="round"/>',
              on: '<rect x="23" y="15" width="50" height="32" rx="3" fill="#E6F4F1"/>' + tx(42, 38, "25", 16, K) + '<path d="M60 40v-4M64 40v-8M68 40v-12" stroke="' + A + '" stroke-width="3"/>' };
    return svg(base + (s[kind] || s.on));
  }
  function bar(d) {
    return svg('<rect x="4" y="22" width="88" height="28" rx="14" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><path d="M84 18v36" stroke="' + H + '" stroke-width="3"/>' +
      '<path d="M78 18h12M78 54h12" stroke="' + H + '" stroke-width="2"/>' + (d ? tx(42, 41, d, 14) : ""));
  }
  function tape(n) {
    return svg('<rect x="6" y="40" width="84" height="16" rx="2" fill="#F4D35E" stroke="' + K + '" stroke-width="1.5"/><path d="M14 40v6M22 40v9M30 40v6M38 40v9M46 40v6M54 40v9M62 40v6M70 40v9M78 40v6" stroke="' + K + '" stroke-width="1.5"/>' +
      '<path d="M8 26c20-14 60-14 80 0" fill="none" stroke="' + K + '" stroke-width="3"/>' + (n ? tx(48, 24, n, 14) : ""));
  }
  function partIcon(c) {
    var g = '<g fill="none" stroke="' + K + '" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">';
    var d = {
      motor: g + '<circle cx="48" cy="36" r="28"/><circle cx="48" cy="36" r="13" fill="' + A + '" stroke="' + K + '"/><path d="M48 8v15M48 49v15M20 36h15M61 36h15M28 16l10 10M58 46l10 10M68 16L58 26M38 46L28 56"/></g>',
      controller: g + '<rect x="22" y="18" width="52" height="36" rx="4" fill="' + G + '"/><path d="M22 26H8M22 36H6M22 46H10M74 30h14M74 42h12"/></g>',
      display: '<rect x="4" y="54" width="88" height="7" rx="3" fill="' + G + '"/><rect x="20" y="10" width="56" height="40" rx="6" fill="' + K + '"/><rect x="25" y="15" width="46" height="30" rx="3" fill="#E6F4F1"/>' + tx(44, 36, "25", 14),
      cable: g + '<path d="M16 36c18-26 46 26 64 0"/><rect x="4" y="30" width="12" height="12" rx="3" fill="' + A + '"/><rect x="80" y="30" width="12" height="12" rx="3" fill="' + A + '"/></g>',
      throttle: g + '<rect x="6" y="40" width="64" height="12" rx="6" fill="' + G + '"/><path d="M58 40l14-18" stroke-width="7" stroke="' + A + '"/></g>',
      brake_lever: g + '<rect x="6" y="20" width="40" height="12" rx="6" fill="' + G + '"/><path d="M40 30c16 4 34 14 48 30" stroke-width="6" stroke="' + A + '"/></g>',
      pas_sensor: g + '<circle cx="48" cy="36" r="26"/></g>' + pinsAt(48, 36, 8, 20, 4).replace(/fill="#23303A"/g, 'fill="' + A + '"') + '<circle cx="48" cy="36" r="7" fill="' + K + '"/>',
      charger: g + '<rect x="12" y="20" width="44" height="32" rx="5" fill="' + G + '"/><path d="M56 36h18c8 0 8-14 16-14"/></g><path d="M32 26l-6 11h7l-3 10 9-13h-7l3-8z" fill="' + A + '"/>',
      battery: '<rect x="10" y="18" width="70" height="36" rx="6" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/><rect x="80" y="29" width="7" height="14" fill="' + K + '"/><rect x="16" y="24" width="40" height="24" rx="3" fill="' + A + '"/>',
      /* chat-8: mechanical parts and the two list cards */
      clamp: '<rect x="38" y="4" width="20" height="64" rx="3" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><rect x="30" y="28" width="36" height="14" rx="5" fill="' + A + '" stroke="' + K + '" stroke-width="2"/><path d="M66 35c10 0 18-4 24-14" fill="none" stroke="' + K + '" stroke-width="5" stroke-linecap="round"/>',
      seatpost: '<path d="M14 16c12-8 56-8 68 0c-4 7-22 9-34 9s-30-2-34-9z" fill="' + K + '"/><rect x="41" y="24" width="14" height="44" rx="3" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><path d="M41 54h14M41 60h14" stroke="' + A + '" stroke-width="2"/>',
      rotor: '<circle cx="48" cy="36" r="30" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/>' + pinsAt(48, 36, 6, 23, 2.6).replace(/fill="#23303A"/g, 'fill="' + W + '"') + '<circle cx="48" cy="36" r="14" fill="' + W + '" stroke="' + K + '" stroke-width="2"/>' + pinsAt(48, 36, 6, 9, 2.2) + '<circle cx="48" cy="36" r="3" fill="' + A + '"/>',
      headset: '<rect x="40" y="2" width="16" height="68" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><rect x="26" y="12" width="44" height="12" rx="4" fill="' + A + '" stroke="' + K + '" stroke-width="2"/><rect x="26" y="48" width="44" height="12" rx="4" fill="' + A + '" stroke="' + K + '" stroke-width="2"/>',
      bottom_bracket: '<rect x="4" y="32" width="88" height="8" rx="2" fill="' + K + '"/><rect x="24" y="22" width="48" height="28" rx="4" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/><rect x="14" y="18" width="12" height="36" rx="3" fill="' + A + '"/><rect x="70" y="18" width="12" height="36" rx="3" fill="' + A + '"/>',
      pedals: '<rect x="14" y="20" width="52" height="32" rx="6" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/><path d="M66 36h24" stroke="' + K + '" stroke-width="6" stroke-linecap="round"/><path d="M24 26v20M34 26v20M44 26v20M54 26v20" stroke="' + A + '" stroke-width="2.5"/>',
      tire: '<circle cx="48" cy="36" r="31" fill="' + K + '"/><circle cx="48" cy="36" r="20" fill="' + P + '"/><path d="M48 5v7M48 60v7M17 36h7M72 36h7M26 14l5 5M65 53l5 5M70 14l-5 5M31 53l-5 5" stroke="' + G + '" stroke-width="3"/>',
      tube: '<circle cx="48" cy="33" r="25" fill="none" stroke="' + A + '" stroke-width="10"/><rect x="45" y="57" width="6" height="13" rx="2" fill="' + K + '"/>',
      kickstand: '<rect x="30" y="4" width="36" height="10" rx="3" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><path d="M48 14L30 64" stroke="' + K + '" stroke-width="6" stroke-linecap="round"/><path d="M20 66h20" stroke="' + A + '" stroke-width="6" stroke-linecap="round"/>',
      fender: '<circle cx="48" cy="46" r="21" fill="none" stroke="' + K + '" stroke-width="6"/><path d="M14 46a34 34 0 0 1 68 0" fill="none" stroke="' + A + '" stroke-width="7" stroke-linecap="round"/>',
      mech_cable: '<path d="M12 58c8-40 58-46 72-20" fill="none" stroke="' + K + '" stroke-width="6" stroke-linecap="round"/><path d="M84 38l8-8" stroke="' + A + '" stroke-width="2.5"/><circle cx="12" cy="60" r="6" fill="' + A + '"/>',
      torque_arm: '<path d="M10 28h60a14 14 0 0 1 0 28H10z" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/><rect x="60" y="37" width="14" height="10" rx="2" fill="' + W + '" stroke="' + K + '" stroke-width="1.5"/><circle cx="20" cy="42" r="5" fill="' + A + '"/>',
      axle_hardware: '<circle cx="32" cy="36" r="22" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/><circle cx="32" cy="36" r="9" fill="' + W + '" stroke="' + K + '" stroke-width="2"/><path d="M62 22h16l8 14-8 14H62l-8-14z" fill="' + A + '" stroke="' + K + '" stroke-width="2"/><circle cx="70" cy="36" r="6" fill="' + W + '"/>',
      freewheel: '<circle cx="48" cy="36" r="29" fill="' + G + '" stroke="' + K + '" stroke-width="2.4" stroke-dasharray="5 3"/><circle cx="48" cy="36" r="17" fill="' + W + '" stroke="' + K + '" stroke-width="2"/><path d="M38 28h20M36 34h24M36 40h24M38 46h20" stroke="' + A + '" stroke-width="2.5"/>',
      "@mech": '<rect x="14" y="31" width="58" height="12" rx="6" fill="' + K + '" transform="rotate(-35 43 37)"/><circle cx="70" cy="18" r="14" fill="' + A + '"/><rect x="65" y="2" width="10" height="16" fill="' + W + '" transform="rotate(-35 70 18)"/>',
      "@elec": '<path d="M52 4L28 40h16L36 68l30-40H50z" fill="' + A + '"/>',
      /* chat-12: mid-drive main cable (one plug, four branches) and programming cable (USB plug, adapter, round plug) */
      mid_harness: g + '<path d="M18 36h22M40 36l34-24M40 36l34-8M40 36l34 8M40 36l34 24"/><rect x="4" y="30" width="14" height="12" rx="3" fill="' + G + '"/></g>' +
        '<circle cx="78" cy="12" r="5" fill="' + A + '"/><circle cx="78" cy="28" r="5" fill="' + A + '"/><circle cx="78" cy="44" r="5" fill="' + A + '"/><circle cx="78" cy="60" r="5" fill="#4CAF50"/>',
      prog_cable: g + '<rect x="4" y="31" width="12" height="10" rx="1" fill="' + W + '"/><rect x="16" y="28" width="18" height="16" rx="3" fill="' + G + '"/>' +
        '<path d="M34 36c14-20 30 20 44 0"/></g><circle cx="84" cy="36" r="8" fill="#4CAF50" stroke="' + K + '" stroke-width="2.4"/>'
    };
    return svg(d[c] || d.cable);
  }
  function ends(v) {
    var p = function (x, kind) {
      if (kind === "male") return '<rect x="' + x + '" y="26" width="26" height="20" rx="4" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><path d="M' + (x + 26) + ' 31h7M' + (x + 26) + ' 36h7M' + (x + 26) + ' 41h7" stroke="' + K + '" stroke-width="2.4"/>';
      if (kind === "female") return '<rect x="' + x + '" y="26" width="26" height="20" rx="4" fill="' + G + '" stroke="' + K + '" stroke-width="2"/>' + pinsAt(x + 13, 36, 3, 5, 2).replace(/fill="#23303A"/g, 'fill="' + W + '" stroke="' + K + '"');
      return '<path d="M' + x + ' 30l20 3M' + x + ' 36h22M' + x + ' 42l20-3" stroke="' + H + '" stroke-width="2.4"/>';
    };
    var s = v.split("+").sort();                              /* "bare_leads", "female", "male" */
    return svg('<path d="M36 36h24" stroke="' + K + '" stroke-width="3"/>' + p(6, s[0] === "bare_leads" ? "bare" : s[0]) + p(62, s[1] === "bare_leads" ? "bare" : s[1]));
  }
  function grip(k) {
    var o = '<rect x="4" y="30" width="88" height="12" rx="6" fill="' + G + '" stroke="' + K + '" stroke-width="2"/>';
    if (k === "thumb") o += '<path d="M58 30l12-16" stroke="' + A + '" stroke-width="7" stroke-linecap="round"/>';
    if (k === "half_twist") o += '<rect x="62" y="26" width="18" height="20" rx="5" fill="' + A + '"/><path d="M60 58c8 6 20 6 26-2" fill="none" stroke="' + H + '" stroke-width="2.5"/>';
    if (k === "full_twist") o += '<rect x="48" y="26" width="40" height="20" rx="6" fill="' + A + '"/><path d="M48 58c14 8 32 8 40-2" fill="none" stroke="' + H + '" stroke-width="2.5"/>';
    return svg(o);
  }
  function side(s) {
    return svg('<path d="M8 40c20-14 60-14 80 0" fill="none" stroke="' + K + '" stroke-width="5" stroke-linecap="round"/><path d="M48 30v34" stroke="' + K + '" stroke-width="4"/>' +
      '<circle cx="' + (s === "left" ? 10 : 86) + '" cy="40" r="8" fill="' + A + '"/>');
  }
  function gears(k) {
    var o = "", n = { threaded_freewheel: 6, cassette: 10, single: 1 }[k];
    for (var i = 0; i < n; i++) { var h = 54 - i * (n > 1 ? 30 / (n - 1) : 0); o += '<rect x="' + (24 + i * 5) + '" y="' + (36 - h / 2) + '" width="3.5" height="' + h + '" rx="1" fill="' + (k === "single" ? A : K) + '"/>'; }
    if (k === "threaded_freewheel") o += '<path d="M14 26h8M14 32h8M14 38h8M14 44h8" stroke="' + H + '" stroke-width="2"/>';
    return svg('<rect x="4" y="33" width="88" height="6" fill="' + G + '"/>' + o);
  }
  /* chat-9: freewheel hub thread (big 35 mm / small 30 mm, numbers only) and sprocket count */
  function hubThread(v) {
    var big = v === "iso35", h = big ? 46 : 36, y = 36 - h / 2, o = "";
    for (var i = 0; i < 6; i++) o += '<path d="M' + (40 + i * 6) + " " + (y + h) + "l6 -" + h + '" stroke="' + K + '" stroke-width="1.3"/>';
    return svg('<rect x="8" y="26" width="32" height="20" rx="3" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><rect x="40" y="' + y + '" width="36" height="' + h +
      '" fill="' + A + '" stroke="' + K + '" stroke-width="2"/>' + o + '<path d="M84 ' + y + "v" + h + '" stroke="' + K + '" stroke-width="1.5"/>' + tx(86, 68, big ? "35" : "30", 13));
  }
  function sprockets(v) {
    var o = "", n = +v || 1;
    for (var i = 0; i < n; i++) { var hh = 54 - i * (n > 1 ? 30 / (n - 1) : 0); o += '<rect x="' + (30 + i * 6) + '" y="' + (36 - hh / 2) + '" width="4" height="' + hh + '" rx="1" fill="' + (n === 1 ? A : K) + '"/>'; }
    return svg('<rect x="4" y="33" width="88" height="6" fill="' + G + '"/>' + o + tx(14, 20, String(n), 14));
  }
  /* chat-8: mechanical option pictures */
  function clampPic(v) {
    return svg('<rect x="38" y="4" width="20" height="64" rx="3" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><rect x="30" y="28" width="36" height="14" rx="5" fill="' + A + '" stroke="' + K + '" stroke-width="2"/>' +
      (v === "qr" ? '<path d="M66 35c10 0 18-4 24-14" fill="none" stroke="' + K + '" stroke-width="5" stroke-linecap="round"/>'
                  : '<path d="M66 27h11l6 8-6 8H66z" fill="' + K + '"/><path d="M70 35h9" stroke="' + W + '" stroke-width="2"/>'));
  }
  function steerer(v) {
    var w = { "1in": [10, 10], "1_1_8": [14, 14], "1_5": [20, 20], tapered: [14, 24] }[v] || [14, 14];
    return svg('<path d="M' + (48 - w[0] / 2) + ' 4h' + w[0] + 'L' + (48 + w[1] / 2) + ' 56H' + (48 - w[1] / 2) + 'z" fill="' + G + '" stroke="' + K + '" stroke-width="2"/>' +
      '<path d="M24 56h48l-4 10H28z" fill="' + A + '"/>');
  }
  function cup(v) {
    var n = { english: "1.37", italian: "36", pf41: "41", pf42: "42", pf46: "46" }[v] || "", thr = v === "english" || v === "italian";
    return svg('<circle cx="48" cy="36" r="30" fill="' + (thr ? G : P) + '" stroke="' + K + '" stroke-width="2.4"' + (thr ? ' stroke-dasharray="3 2"' : "") + '/>' +
      '<circle cx="48" cy="36" r="19" fill="' + W + '" stroke="' + K + '" stroke-width="2"/>' + tx(48, 42, n, n.length > 2 ? 14 : 17));
  }
  function axleEnd(v) {
    var c = '<circle cx="48" cy="36" r="28" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/>';
    if (v === "square") return svg(c + '<rect x="37" y="25" width="22" height="22" fill="' + K + '" transform="rotate(45 48 36)"/>');
    if (v === "hollow24") return svg(c + '<circle cx="48" cy="36" r="17" fill="' + W + '" stroke="' + K + '" stroke-width="2"/>' + tx(48, 42, "24", 16));
    return svg(c + '<circle cx="48" cy="36" r="15" fill="' + K + '" stroke="' + A + '" stroke-width="5" stroke-dasharray="3 3"/>');
  }
  function standPic(v) {
    if (v === "hole18" || v === "hole40") {
      var d = v === "hole18" ? 10 : 24;
      return svg('<rect x="14" y="20" width="68" height="24" rx="6" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><circle cx="' + (48 - d) + '" cy="32" r="5" fill="' + W + '" stroke="' + K + '" stroke-width="2"/>' +
        '<circle cx="' + (48 + d) + '" cy="32" r="5" fill="' + W + '" stroke="' + K + '" stroke-width="2"/>' + tx(48, 64, v === "hole18" ? "18" : "40", 15, A));
    }
    if (v === "rear") return svg('<circle cx="40" cy="30" r="24" fill="none" stroke="' + K + '" stroke-width="5"/><circle cx="40" cy="30" r="4" fill="' + K + '"/><path d="M40 30l26 38" stroke="' + A + '" stroke-width="6" stroke-linecap="round"/>');
    return svg('<path d="M8 22h80M8 44h80" stroke="' + G + '" stroke-width="10" stroke-linecap="round"/><rect x="36" y="12" width="24" height="42" rx="4" fill="' + A + '"/><path d="M48 54l-12 16" stroke="' + K + '" stroke-width="6" stroke-linecap="round"/>');
  }
  function fenderPic(v) {
    var w = function (cx) { return '<circle cx="' + cx + '" cy="48" r="16" fill="none" stroke="' + K + '" stroke-width="4"/>'; };
    var f = function (cx) { return '<path d="M' + (cx - 22) + ' 46a22 22 0 0 1 44 0" fill="none" stroke="' + A + '" stroke-width="6" stroke-linecap="round"/>'; };
    return svg('<path d="M22 48L38 26h26L74 48" fill="none" stroke="' + K + '" stroke-width="2.4"/>' + w(22) + w(74) + (v !== "front" ? f(22) : "") + (v !== "rear" ? f(74) : ""));
  }
  var PIC = {
    rotor_cl: function () { return svg('<circle cx="48" cy="36" r="30" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/><circle cx="48" cy="36" r="15" fill="' + K + '"/><circle cx="48" cy="36" r="9" fill="' + W + '" stroke="' + A + '" stroke-width="4" stroke-dasharray="2 2"/>'); },
    hs_less: function () { return svg('<rect x="40" y="2" width="16" height="68" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><rect x="30" y="8" width="36" height="20" rx="4" fill="' + A + '"/><path d="M66 13h10M66 23h10" stroke="' + K + '" stroke-width="4"/><rect x="28" y="40" width="40" height="10" rx="3" fill="' + K + '"/>'); },
    hs_thread: function () { return svg('<rect x="40" y="2" width="16" height="68" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><path d="M40 8h16M40 13h16M40 18h16M40 23h16" stroke="' + K + '" stroke-width="1.5"/><path d="M30 28h36l6 7-6 7H30l-6-7z" fill="' + A + '" stroke="' + K + '" stroke-width="2"/><rect x="28" y="52" width="40" height="10" rx="3" fill="' + K + '"/>'); },
    schrader: function () { return svg('<path d="M10 62a40 40 0 0 1 76 0" fill="none" stroke="' + K + '" stroke-width="8"/><rect x="40" y="10" width="16" height="30" rx="3" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><rect x="42" y="4" width="12" height="8" rx="2" fill="' + K + '"/>'); },
    presta: function () { return svg('<path d="M10 62a40 40 0 0 1 76 0" fill="none" stroke="' + K + '" stroke-width="8"/><rect x="44" y="8" width="8" height="32" rx="2" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><rect x="39" y="26" width="18" height="6" rx="2" fill="' + A + '"/><rect x="45" y="3" width="6" height="6" rx="1" fill="' + K + '"/>'); },
    c_brake: function () { return svg('<path d="M8 20c30 0 46 10 52 22" fill="none" stroke="' + K + '" stroke-width="4"/><rect x="58" y="34" width="30" height="24" rx="5" fill="' + A + '"/><circle cx="8" cy="20" r="5" fill="' + K + '"/>'); },
    c_gear: function () { return svg('<path d="M8 20c30 0 40 10 44 22" fill="none" stroke="' + K + '" stroke-width="4"/><circle cx="68" cy="46" r="18" fill="none" stroke="' + A + '" stroke-width="6" stroke-dasharray="5 3"/><circle cx="68" cy="46" r="6" fill="' + K + '"/><circle cx="8" cy="20" r="5" fill="' + K + '"/>'); },
    bar_flat: function () { return svg('<path d="M6 36h84" stroke="' + K + '" stroke-width="7" stroke-linecap="round"/><path d="M48 36v28" stroke="' + K + '" stroke-width="5"/><rect x="6" y="30" width="16" height="12" rx="5" fill="' + A + '"/><rect x="74" y="30" width="16" height="12" rx="5" fill="' + A + '"/>'); },
    bar_drop: function () { return svg('<path d="M20 20h56M20 20c-14 0-14 18-4 24s6 20-6 20M76 20c14 0 14 18 4 24s-6 20 6 20" fill="none" stroke="' + K + '" stroke-width="6" stroke-linecap="round"/><path d="M48 20v40" stroke="' + K + '" stroke-width="5"/>'); },
    ax_flat: function () { return svg('<circle cx="48" cy="36" r="26" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/><rect x="28" y="12" width="40" height="48" fill="' + K + '"/><path d="M28 12h40M28 60h40" stroke="' + A + '" stroke-width="3"/>'); },
    ax_round: function () { return svg('<circle cx="48" cy="36" r="26" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/><circle cx="48" cy="36" r="20" fill="' + K + '"/>'); },
    tire_iso: function () { return svg('<circle cx="160" cy="214" r="180" fill="#23303A"/><circle cx="160" cy="214" r="118" fill="#F6F8FA"/><circle cx="160" cy="214" r="110" fill="none" stroke="#9AA6B2" stroke-width="6"/>' +
      '<g font-family="Arial,Helvetica,sans-serif" font-weight="700" text-anchor="middle" fill="#FFFFFF"><text x="122" y="72" font-size="26">50</text><text x="152" y="72" font-size="22">-</text><text x="196" y="72" font-size="26">559</text></g>' +
      '<rect x="168" y="46" width="58" height="34" rx="6" fill="none" stroke="#F5A623" stroke-width="3"/>', "0 0 320 150"); },
    typeit: function () { return svg('<rect x="8" y="22" width="80" height="28" rx="6" fill="' + W + '" stroke="' + K + '" stroke-width="2.4"/><path d="M20 30v12" stroke="' + A + '" stroke-width="3"/><path d="M28 36h40" stroke="' + G + '" stroke-width="4" stroke-linecap="round"/>'); },
    sym_motor: function () { return svg('<circle cx="48" cy="36" r="28" fill="none" stroke="' + K + '" stroke-width="3"/><circle cx="48" cy="36" r="12" fill="' + A + '"/><path d="M28 16l40 40" stroke="' + H + '" stroke-width="5" stroke-linecap="round"/>'); },
    sym_display: function () { return screen("off"); },
    sym_cut: function () { return svg('<path d="M52 4L28 40h16L36 68l30-40H50z" fill="' + A + '"/><path d="M20 30l56 14" stroke="' + H + '" stroke-width="5" stroke-linecap="round"/>'); },
    sym_charge: function () { return svg('<rect x="8" y="18" width="66" height="36" rx="6" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/><rect x="74" y="29" width="7" height="14" fill="' + K + '"/><rect x="14" y="24" width="10" height="24" rx="2" fill="' + H + '"/><path d="M58 8l20 56" stroke="' + K + '" stroke-width="3"/>'); },
    sym_broken: function () { return svg('<path d="M8 40c12-16 24-16 30-6M88 32c-12 16-24 16-30 6" fill="none" stroke="' + K + '" stroke-width="5" stroke-linecap="round"/><path d="M46 20l4 10M54 24l-6 8M44 44l6-6M52 48l-2-10" stroke="' + H + '" stroke-width="3" stroke-linecap="round"/>'); },
    unsure: function () { return svg('<circle cx="48" cy="36" r="28" fill="' + P + '" stroke="' + K + '" stroke-width="2.5"/>' + tx(48, 47, "?", 32, A)); },
    chk_brake: function () { return svg('<rect x="2" y="14" width="44" height="13" rx="6" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><circle cx="46" cy="22" r="4" fill="' + K + '"/>' +
      '<path d="M46 25c14 6 26 16 34 30" stroke="' + K + '" stroke-width="6" stroke-linecap="round" fill="none"/><path d="M50 36c6 10 14 18 24 24" stroke="' + K + '" stroke-width="2" stroke-dasharray="4 4" fill="none"/>' +
      '<path d="M84 40c6-8 6-18 0-26" stroke="' + A + '" stroke-width="3" fill="none"/><path d="M84 12l-8 2 6 6z" fill="' + A + '"/>'); },
    chk_plug: function () { return svg('<rect x="6" y="26" width="30" height="20" rx="4" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><path d="M36 31h10M36 36h10M36 41h10" stroke="' + K + '" stroke-width="2.4"/><rect x="58" y="26" width="30" height="20" rx="4" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><path d="M44 16h10l-4-4M54 16l-4 4" fill="none" stroke="' + A + '" stroke-width="3"/>'); },
    chk_charge: function () { return svg('<rect x="10" y="18" width="70" height="36" rx="6" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/><rect x="80" y="29" width="7" height="14" fill="' + K + '"/><rect x="16" y="24" width="58" height="24" rx="3" fill="' + A + '"/><path d="M48 26l-8 12h8l-4 10 12-14h-8l4-8z" fill="' + W + '"/>'); },
    chk_switch: function () { return svg('<rect x="18" y="14" width="60" height="44" rx="8" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/><circle cx="48" cy="36" r="13" fill="' + W + '" stroke="' + A + '" stroke-width="3"/><path d="M48 26v10" stroke="' + A + '" stroke-width="3" stroke-linecap="round"/>'); },
    chk_outlet: function () { return svg('<rect x="22" y="8" width="52" height="56" rx="8" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/><rect x="38" y="22" width="5" height="12" rx="2" fill="' + K + '"/><rect x="53" y="22" width="5" height="12" rx="2" fill="' + K + '"/><circle cx="48" cy="46" r="4" fill="' + K + '"/>'); },
    chk_dplug: function () { return svg('<rect x="22" y="6" width="52" height="34" rx="6" fill="' + K + '"/><rect x="27" y="11" width="42" height="24" rx="3" fill="#3A4652"/><path d="M48 40v10" stroke="' + K + '" stroke-width="3"/><circle cx="48" cy="58" r="9" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><path d="M62 54h14l-4-4M76 54l-4 4" fill="none" stroke="' + A + '" stroke-width="3"/>'); },
    chk_cplug: function () { return svg('<rect x="6" y="22" width="34" height="28" rx="5" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><path d="M40 36h18" stroke="' + K + '" stroke-width="3"/><circle cx="66" cy="36" r="8" fill="' + A + '"/><path d="M76 36h14" stroke="' + K + '" stroke-width="3"/>'); },
    code: function () { return screen("code"); },
    photo: function () { return svg('<rect x="10" y="18" width="76" height="46" rx="8" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/><rect x="34" y="10" width="28" height="10" rx="3" fill="' + K + '"/><circle cx="48" cy="41" r="14" fill="' + W + '" stroke="' + K + '" stroke-width="2.4"/><circle cx="48" cy="41" r="6" fill="' + A + '"/>'); },
    tire: function () { return svg('<circle cx="160" cy="214" r="180" fill="#23303A"/><circle cx="160" cy="214" r="118" fill="#F6F8FA"/><circle cx="160" cy="214" r="110" fill="none" stroke="#9AA6B2" stroke-width="6"/>' +
      '<g font-family="Arial,Helvetica,sans-serif" font-weight="700" text-anchor="middle" fill="#FFFFFF"><text x="118" y="72" font-size="26">26</text><text x="156" y="72" font-size="20">x</text><text x="200" y="72" font-size="26">4.0</text></g>' +
      '<rect x="96" y="46" width="44" height="34" rx="6" fill="none" stroke="#F5A623" stroke-width="3"/><rect x="174" y="46" width="54" height="34" rx="6" fill="none" stroke="#4AB3FF" stroke-width="3"/>' +
      '<g font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="14" text-anchor="middle"><circle cx="118" cy="20" r="11" fill="#F5A623"/><text x="118" y="25" fill="#23303A">1</text><circle cx="201" cy="20" r="11" fill="#4AB3FF"/><text x="201" y="25" fill="#23303A">2</text></g>', "0 0 320 150"); },
    dropout: function () { return svg('<path d="M58 6h20l6 98H64z" fill="#5B6B7A"/><path d="M242 6h20l-6 98h-20z" fill="#5B6B7A"/><rect x="52" y="96" width="38" height="44" rx="7" fill="#7B8A99"/><rect x="230" y="96" width="38" height="44" rx="7" fill="#7B8A99"/>' +
      '<rect x="96" y="98" width="128" height="40" rx="12" fill="#C9D3DC"/><rect x="30" y="114" width="260" height="8" rx="3" fill="#9AA6B2"/><line x1="30" y1="20" x2="290" y2="20" stroke="#5B6B7A" stroke-width="2.5" stroke-dasharray="7 5"/>' +
      '<g stroke="#5B6B7A" stroke-width="3"><line x1="152" y1="30" x2="168" y2="46"/><line x1="168" y1="30" x2="152" y2="46"/></g><line x1="90" y1="146" x2="90" y2="166" stroke="#0E8A8A" stroke-width="2.5"/><line x1="230" y1="146" x2="230" y2="166" stroke="#0E8A8A" stroke-width="2.5"/>' +
      '<line x1="92" y1="156" x2="228" y2="156" stroke="#0E8A8A" stroke-width="3"/><path d="M92 156l10-6v12zM228 156l-10-6v12z" fill="#0E8A8A"/>', "0 0 320 170"); },
    hall_yes: function () { return svg('<circle cx="48" cy="36" r="30" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><circle cx="34" cy="28" r="8" fill="#E8B04B"/><circle cx="50" cy="22" r="8" fill="#3BA55C"/><circle cx="62" cy="34" r="8" fill="#3B7DD8"/>' + pinsAt(44, 50, 5, 9, 2.8).replace(/fill="#23303A"/g, 'fill="' + A + '"')); },
    hall_no: function () { return svg('<circle cx="48" cy="36" r="30" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><circle cx="34" cy="32" r="9" fill="#E8B04B"/><circle cx="52" cy="26" r="9" fill="#3BA55C"/><circle cx="56" cy="44" r="9" fill="#3B7DD8"/>'); },
    disc: function () { return svg('<circle cx="40" cy="36" r="24" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/>' + pinsAt(40, 36, 6, 15, 3).replace(/fill="#23303A"/g, 'fill="' + W + '" stroke="' + K + '"') + '<circle cx="40" cy="36" r="6" fill="' + K + '"/><rect x="58" y="14" width="18" height="24" rx="4" fill="' + A + '"/>'); },
    rim: function () { return svg('<circle cx="48" cy="40" r="30" fill="none" stroke="' + K + '" stroke-width="6"/><rect x="38" y="2" width="8" height="14" rx="2" fill="' + A + '"/><rect x="50" y="2" width="8" height="14" rx="2" fill="' + A + '"/>'); },
    axle_nut: function () { return svg('<rect x="6" y="32" width="84" height="8" fill="' + G + '" stroke="' + K + '" stroke-width="1.5"/><path d="M60 22h14l7 14-7 14H60l-7-14z" fill="' + A + '"/>'); },
    axle_qr: function () { return svg('<rect x="6" y="33" width="70" height="6" fill="' + G + '" stroke="' + K + '" stroke-width="1.5"/><path d="M76 24v24" stroke="' + K + '" stroke-width="5"/><path d="M76 26c-6-14-30-16-44-10" fill="none" stroke="' + A + '" stroke-width="6" stroke-linecap="round"/>'); },
    axle_thru: function () { return svg('<rect x="4" y="29" width="88" height="14" rx="3" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><rect x="78" y="25" width="12" height="22" rx="3" fill="' + A + '"/>' + tx(40, 41, "12", 12)); },
    kitbox: function () { return svg('<rect x="14" y="26" width="68" height="40" rx="3" fill="#E3C9A0" stroke="' + K + '" stroke-width="2"/><path d="M14 26l10-14h48l10 14" fill="#D6B98A" stroke="' + K + '" stroke-width="2"/><circle cx="48" cy="46" r="10" fill="' + A + '"/>'); },
    ebike: function () { return bike("battery"); },
    nolabel: function () { return svg('<circle cx="48" cy="36" r="30" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><circle cx="48" cy="36" r="10" fill="' + K + '"/>'); },
    blur: function () { return svg('<rect x="14" y="16" width="68" height="40" rx="4" fill="' + W + '" stroke="' + K + '" stroke-width="2"/><path d="M22 28h40M22 36h50M22 44h30" stroke="' + G + '" stroke-width="5" stroke-linecap="round"/>'); },
    ctl_one: function () { return svg('<rect x="24" y="18" width="48" height="36" rx="4" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/><path d="M72 36h20" stroke="' + A + '" stroke-width="6" stroke-linecap="round"/>'); },
    ctl_many: function () { return svg('<rect x="24" y="18" width="48" height="36" rx="4" fill="' + G + '" stroke="' + K + '" stroke-width="2.4"/><path d="M72 24h18M72 32h20M72 40h18M72 48h20M24 30H6M24 42H8" stroke="' + A + '" stroke-width="3" stroke-linecap="round"/>'); },
    harness: function () { return svg('<path d="M8 36h34" stroke="' + K + '" stroke-width="6" stroke-linecap="round"/><path d="M42 36c14 0 18-22 40-24M42 36c14 0 20-8 40-8M42 36c14 0 20 8 40 8M42 36c14 0 18 22 40 24" fill="none" stroke="' + A + '" stroke-width="3"/>'); },
    signal: function () { return svg('<path d="M10 40c20-20 50 10 70-6" fill="none" stroke="' + K + '" stroke-width="3"/><circle cx="84" cy="32" r="7" fill="' + A + '"/>'); },
    to_ctl: function () { return svg('<path d="M8 36h44" stroke="' + K + '" stroke-width="3"/><path d="M46 30l8 6-8 6" fill="none" stroke="' + K + '" stroke-width="3"/><rect x="58" y="20" width="32" height="32" rx="4" fill="' + A + '"/>'); },
    to_display: function () { return svg('<path d="M8 50h40" stroke="' + K + '" stroke-width="3"/><path d="M42 44l8 6-8 6" fill="none" stroke="' + K + '" stroke-width="3"/><rect x="56" y="14" width="34" height="26" rx="4" fill="' + K + '"/><rect x="60" y="18" width="26" height="18" rx="2" fill="' + A + '"/>'); },
    to_main: function () { return PIC.harness(); },
    lev_cable: function () { return svg('<rect x="4" y="12" width="46" height="12" rx="6" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><path d="M44 24c14 2 28 12 40 30" fill="none" stroke="' + A + '" stroke-width="6" stroke-linecap="round"/><path d="M84 54c-10 12-40 10-72 4" fill="none" stroke="' + K + '" stroke-width="1.8"/>'); },
    lev_hyd: function () { return svg('<rect x="4" y="12" width="46" height="12" rx="6" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><path d="M44 24c14 2 28 12 40 30" fill="none" stroke="' + A + '" stroke-width="6" stroke-linecap="round"/><path d="M84 54c-10 12-40 10-72 4" fill="none" stroke="' + K + '" stroke-width="6" stroke-linecap="round"/>'); },
    snsr_reed: function () { return svg('<path d="M4 30h32M4 42h32" stroke="' + K + '" stroke-width="3" stroke-linecap="round"/><rect x="36" y="22" width="40" height="28" rx="14" fill="' + G + '" stroke="' + K + '" stroke-width="2"/><path d="M46 36h20" stroke="' + A + '" stroke-width="3"/>' + tx(84, 40, "2", 14)); },
    snsr_hall: function () { return svg('<path d="M4 24h32M4 36h32M4 48h32" stroke="' + K + '" stroke-width="3" stroke-linecap="round"/><rect x="36" y="16" width="40" height="40" rx="5" fill="' + G + '" stroke="' + K + '" stroke-width="2"/>' + tx(56, 42, "H", 18, A) + tx(86, 40, "3", 14)); },
    sw_no: function () { return svg('<circle cx="18" cy="42" r="5" fill="' + K + '"/><circle cx="78" cy="42" r="5" fill="' + K + '"/><path d="M22 40l44-18" stroke="' + A + '" stroke-width="4" stroke-linecap="round"/>' + tx(48, 64, "NO", 14)); },
    sw_nc: function () { return svg('<circle cx="18" cy="42" r="5" fill="' + K + '"/><circle cx="78" cy="42" r="5" fill="' + K + '"/><path d="M22 42h52" stroke="' + A + '" stroke-width="4" stroke-linecap="round"/>' + tx(48, 64, "NC", 14)); }
  };
  function optPic(q, v, ans) {
    var pinsOf = function (id) { var a = ans[id]; return a && a.v ? +a.v : 0; };
    switch (q) {
      case "B2": return bike(v);
      case "B3": return label(v + "V", "battery");
      case "B4": return wheelNum(v === "29" ? "29 / 700C" : v);
      case "B5": return tireW(v === "4" ? "f" : v === "2.5-3" ? "m" : "n");
      case "B6": return v === "kit" ? PIC.kitbox() : PIC.ebike();
      case "B7": return v === "no_label" ? PIC.nolabel() : PIC.blur();
      case "P0": return partIcon(v);
      case "M3": return null;
      case "M4": return PIC[{ nut: "axle_nut", qr: "axle_qr", thru12: "axle_thru" }[v]]();
      case "M6a": return face("kit", +v);
      case "M6b": return face(v, pinsOf("M6a") || 9);
      case "M7": return v === "yes" ? PIC.hall_yes() : PIC.hall_no();
      case "M8": return label(v + "W", "motor");
      case "M9": return PIC[v]();
      case "MG": return gears(v);
      case "C1": return bike(v);
      case "C2b": return label((v === "30plus" ? "30+" : v) + "A", "battery");
      case "C2": return label({ "15": "15", "18-22": "18–22", "25-30": "25–30", gt30: "30+" }[v] + "A", "ctl");
      case "C4": return v === "one" ? PIC.ctl_one() : PIC.ctl_many();
      case "D1": return screen({ nothing: "off", error: "code", off_again: "flash", works: "on" }[v]);
      case "D3": return null;
      case "D4": return face("round", +v);
      case "D5": return face(v, pinsOf("D4") || 5);
      case "D6": return bar(v);
      case "W2": return v === "motor_cable" ? partIcon("motor") : v === "display_cable" ? partIcon("display") : v === "harness" ? PIC.harness() : PIC.signal();
      case "W3a": return face(v, pinsOf("W3b") || 3);
      case "W3b": return face("round", +v);
      case "W3c": return ends(v);
      case "W4": return tape(v);
      case "T1": return grip(v);
      case "T2": return side(v);
      case "T3": return PIC[{ controller: "to_ctl", display: "to_display", main: "to_main" }[v]]();
      case "T4a": return face(v, pinsOf("T4") || 3);
      case "T4": return face("round", +v);
      case "K1": return v === "hydraulic" ? PIC.lev_hyd() : PIC.lev_cable();
      case "K2": return bar(v);
      case "K3": return face("round", +v);
      case "K3a": return face(v, pinsOf("K3") || 2);
      case "K4": return v === "hall" ? PIC.snsr_hall() : PIC.snsr_reed();
      case "K5": return v === "nc" ? PIC.sw_nc() : PIC.sw_no();
      case "G2": return clampPic(v);                          /* chat-8: mechanical parts (numbers only, no words) */
      case "R1": return v === "centerlock" ? PIC.rotor_cl() : partIcon("rotor");
      case "N1": return steerer(v);
      case "N2": return v === "threaded" ? PIC.hs_thread() : PIC.hs_less();
      case "O1": return cup(v);
      case "O3": return axleEnd(v);
      case "E1": return label(v === "1_2" ? "1/2" : "9/16", "ctl");
      case "U3": return v === "presta" ? PIC.presta() : PIC.schrader();
      case "V1": return standPic(v);
      case "X1": return fenderPic(v);
      case "Y1": return v === "gear" ? PIC.c_gear() : PIC.c_brake();
      case "Y2": return v === "drop" ? PIC.bar_drop() : PIC.bar_flat();
      case "A2": return v === "flat" ? PIC.ax_flat() : PIC.ax_round();
      case "J1": return hubThread(v);                          /* chat-9 */
      case "J2": return sprockets(v);
      case "Z1": case "Z6": return v === "hub" ? bike("rear") : v === "frame_built" ? PIC.ebike() : bike("mid");   /* chat-12 */
      case "Z3": return face("kit", +v);
      case "Z4": return v === "other" ? null : partIcon("mid_harness");
      case "Z5": return tape(v);
      case "Z8": return v === "sm" ? face("sm", 5) : v === "kit5" ? face("kit", 5) : face("kit", 8);
    }
    return null;
  }
  function topPic(q) {                                          /* r2: D3 shows the three label pictures (protoHelp) instead of one */
    return { B4: "tire", B5: "tire", M3: "dropout", D2: "code", F1: "tire_iso", U1: "tire_iso", F2: "tire", U2: "tire", X3: "tire", V2: "tire",
             X2: "tire" }[q] ||                                 /* chat-8: mechanical size questions */
      ({ D6: 1, K2: 1, G1: 1, S1: 1, R3: 1, N3: 1, N4: 1, H1: 1, H2: 1, A1: 1 }[q] ? "bar" :
       { W4: 1, S2: 1, R2: 1, O2: 1, O4: 1, Y3: 1, H3: 1, Z5: 1 }[q] ? "tape" : null);
  }

  /* ================================================================ rule parser (pure: text -> structured values, nothing else) */
  function norm(t) {
    return String(t || "").replace(/[！-～]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0xfee0); })
      .replace(/[×＊*]/g, "x").replace(/\s+/g, " ").trim().toLowerCase();
  }
  var IDK_RX = /^(?:i\s*(?:do\s*not|don'?t)\s*know|not\s*sure|no\s*idea|idk|unknown|dunno|不知道|不确定|不清楚|no\s*s[eé]|no\s*estoy\s*segur[oa]|n[aã]o\s*sei|n[aã]o\s*tenho\s*certeza)[\s.!?。！]*$/;
  function uniq(a) { var o = [], s = {}; a.forEach(function (x) { if (!s[x]) { s[x] = 1; o.push(x); } }); return o; }
  function all(rx, s, f) { var out = [], m; rx.lastIndex = 0; while ((m = rx.exec(s))) out.push(f ? f(m) : m[1]); return uniq(out.filter(function (x) { return x != null; })); }
  function num(x) { var f = parseFloat(x); return isFinite(f) ? f : null; }
  function fmtn(f) { return String(Math.round(f * 100) / 100); }
  function pickOne(xs, v) { return xs.length === 1 ? xs[0] : (v || null); }
  var FIELD_Q = { volt: ["B3"], watt: ["M8"], amps: ["C2b", "C2"], pins: ["M6a", "D4", "W3b", "T4", "Z3"], conn: ["M6b", "D5", "W3a", "T4a"],
                  wheel: ["B4", "V2", "X2"], width: ["B5", "F2", "U2", "X3"], dropout: ["M3"], barmm: ["D6"], cm: ["W4", "Y3", "Z5"], pos: ["B2"], hall: ["M7"], brake: ["M9"],
                  gears: ["MG"], proto: ["D3"], tstyle: ["T1"], tside: ["T2"], role: ["W2"], sym: ["B1"], part: ["P0"], axle: ["M4"],
                  mm: CARRY_Q["@mm"], iso: ["F1", "U1"] };            /* chat-8: mechanical sizes */
  /* chat-8: typed mechanical part names (English, Chinese, Spanish, Portuguese), first match wins; only on the "Part broken" list */
  var MECH_RX = [["clamp", /seat\s*-?\s*post\s*clamp|seat\s*clamp|座管夹|座杆夹|abrazadera|abra[cç]adeira/],
    ["seatpost", /seat\s*-?\s*post|座管|座杆|\btija\b|canote/], ["rotor", /rotor|brake\s*dis[ck]|碟片|刹车盘|disco\s*de\s*fre/],
    ["headset", /head\s*-?\s*set|碗组|juego\s*de\s*direcci|caixa\s*de\s*dire/], ["bottom_bracket", /bottom\s*bracket|\bbb\b|中轴|pedalier|movimento\s*central/],
    ["pedals", /^(?!.*sensor)(?!.*传感).*(?:\bpedals?\b|脚踏|踏板|pedales|pedais)/], ["tube", /inner\s*tube|\btubes?\b|内胎|c[aá]mara/],
    ["tire", /\btires?\b|\btyres?\b|外胎|轮胎|neum[aá]tico|llanta|\bpneu/], ["kickstand", /kick\s*-?\s*stand|脚撑|边撑|停车架|caballete|pata\s*de\s*cabra|descanso/],
    ["fender", /fender|mud\s*-?\s*guard|挡泥板|guardabarros|para-?lamas?/],
    ["mech_cable", /(?:brake|gear|shift(?:er)?|derailleur)\s*(?:cable|wire)|刹车线|变速线|cable\s*de\s*(?:freno|cambio)|cabo\s*de\s*(?:freio|c[aâ]mbio)/],
    ["torque_arm", /torque\s*arm|扭力臂|brazo\s*de\s*torsi|bra[cç]o\s*de\s*tor/], ["axle_hardware", /axle\s*(?:nut|washer)|轴螺母|轴垫片|tuerca\s*del\s*eje|porca\s*do\s*eixo/],
    /* chat-9: "大小螺纹" = the freewheel thread (Chris 10-25); last, so a named bottom bracket / pedal / headset wins; a cassette is not a freewheel */
    ["freewheel", /^(?!.*(?:cassette|卡式飞轮|卡飞|塔基|casete|cassete)).*(?:free\s*-?\s*wheel|(?:big|large|small)\s*thread|飞轮|旋飞|大小螺纹|大螺纹|小螺纹|rueda\s*libre|pi[ñn][oó]n\s*libre|rosca\s*(?:grande|peque[ñn]a)|roda\s*livre|catraca)/]];
  var INCH_ISO = { "20": "406", "24": "507", "26": "559", "27.5": "584", "28": "622", "29": "622" };
  function fields(s, cur, qs) {
    var F = {}, set = function (k, xs) { xs = uniq(xs); if (xs.length === 1) F[k] = xs[0]; else if (xs.length > 1) F[k] = null; };
    set("volt", all(/(\d{2}(?:\.\d)?)(?=(?:\s*\/\s*\d{2}(?:\.\d)?)*\s*(?:v\b|volts?\b|伏))/g, s));
    var w = all(/(\d{3,5})\s*(?:w\b|watts?\b|瓦)/g, s).concat(all(/(\d+(?:\.\d+)?)\s*kw\b/g, s, function (m) { return fmtn(num(m[1]) * 1000); }));
    set("watt", w);
    set("amps", all(/(\d{1,3})\s*(?:a\b|amps?\b|安)/g, s));
    set("pins", all(/(\d{1,2})\s*-?\s*(?:pins?\b|p\b|针|芯|pines?\b|pinos?\b)/g, s));
    set("dropout", all(/(\d{2,3}(?:\.\d)?)\s*mm\b/g, s).filter(function (x) { return num(x) >= 90 && num(x) <= 220; }));
    set("barmm", all(/(\d{2}(?:\.\d)?)\s*mm\b/g, s).filter(function (x) { return num(x) >= 20 && num(x) <= 40; }));
    set("cm", all(/(\d{2,3})\s*cm\b/g, s));
    set("mm", all(/(\d{1,3}(?:\.\d{1,2})?)\s*mm\b/g, s).filter(function (x) { return num(x) > 0 && num(x) <= 800; }));   /* chat-8 */
    var wh = all(/(?:^|[^\d.])((?:1[2-9]|2\d)(?:\.5)?)\s*(?:"|''|in\b|inch|寸|x\s*\d)/g, s);
    if (/\b700\s*c\b/.test(s)) wh.push("29");
    set("wheel", wh);
    set("width", all(/(?:1[2-9]|2\d)(?:\.5)?\s*x\s*(\d(?:\.\d{1,3})?)/g, s));
    var iso = all(/\b\d{2,3}\s*-\s*(\d{3})\b/g, s).concat(all(/\biso\s*(\d{3})\b/g, s));                  /* chat-8: 50-559, ISO 559, 700c */
    if (!iso.length && /\b700\s*c\b/.test(s)) iso.push("622");
    if (!iso.length && F.wheel && INCH_ISO[F.wheel]) iso.push(INCH_ISO[F.wheel]);
    set("iso", iso);
    var pos = [];
    var NOTPOS = "(?!\\s*(?:brakes?|lights?|lamps?|racks?|fenders?|mudguards?|baskets?|forks?|rotors?|discs?|calipers?|reflectors?|tires?|tyres?))";
    if (new RegExp("\\b(?:front|fwd)\\b" + NOTPOS).test(s) || /前轮|前驱/.test(s)) pos.push("front");
    if (new RegExp("\\b(?:rear|back)\\b" + NOTPOS).test(s) || /后轮|后驱/.test(s)) pos.push("rear");
    if (/\bmid(?:-?drive)?\b|\bmiddle\b|\bpedals?\b|\bcrank\b|中置/.test(s)) pos.push("mid");
    set("pos", pos);
    if (/sensorless|no\s+hall|without\s+hall|无霍尔/.test(s)) F.hall = "no"; else if (/\bhall\b|霍尔|sensored/.test(s)) F.hall = "yes";
    var br = [];
    if (/\bdisc\b|碟刹/.test(s)) br.push("disc");
    if (/\brim\b|\bv-?brake|圈刹|v刹/.test(s)) br.push("rim");
    set("brake", br);
    var gr = [];
    if (/cassette|塔基/.test(s)) gr.push("cassette");
    if (/freewheel|screw-?on|旋飞/.test(s)) gr.push("threaded_freewheel");
    if (/single\s*speed|单速/.test(s)) gr.push("single");
    set("gears", gr);
    var cn = [];
    if (/z910|arrow/.test(s)) cn.push("arrow9");
    else if (/julet|higo|朱丽叶/.test(s)) cn.push("round");
    if (/bafang|kit[- ]?brand|eb-?bus|八方/.test(s)) cn.push("kit");
    if (/\bsm\b|\bjst\b/.test(s)) cn.push("sm");
    set("conn", cn);
    var pr = [];
    if (/\bcan\s*-?\s*bus\b|\bcanbus\b|\bcan\s+protocol\b/.test(s) || (cur === "D3" && /^can$/.test(s))) pr.push("can_kit");
    if (/\bkt\b/.test(s)) pr.push("uart_generic");
    set("proto", pr);
    var ts = [];
    if (/thumb|拇指/.test(s)) ts.push("thumb");
    if (/half\s*-?\s*twist|半转把/.test(s)) ts.push("half_twist");
    if (/full\s*-?\s*twist|全转把/.test(s)) ts.push("full_twist");
    set("tstyle", ts);
    var sd = [];
    if (/\bright\b|右/.test(s)) sd.push("right");
    if (/\bleft\b|左/.test(s)) sd.push("left");
    set("tside", sd);
    var rl = [];
    if (/motor\s*cable|电机线/.test(s)) rl.push("motor_cable");
    if (/display\s*cable|仪表线/.test(s)) rl.push("display_cable");
    if (/main\s*cable|harness|主线/.test(s)) rl.push("harness");
    if (/(?:sensor|throttle|brake)\s*cable/.test(s)) rl.push("cable");
    set("role", rl);
    var ax = [];
    if (/quick\s*-?\s*release|\bqr\b|快拆/.test(s)) ax.push("qr");
    if (/\bthru|桶轴/.test(s)) ax.push("thru12");
    if (/\bnut\b|螺母/.test(s)) ax.push("nut");
    set("axle", ax);
    var sy = [];
    if (/motor.{0,20}(?:dead|not|no\b|won'?t|doesn'?t|stopped)|电机不转/.test(s)) sy.push("motor_off");
    if (/(?:display|screen|lcd).{0,20}(?:off|dark|blank|dead|not|no\b)|不亮|黑屏/.test(s)) sy.push("display_off");
    if (/cuts?\s*out|cutting\s*out|cutout|shuts?\s*off|断电/.test(s)) sy.push("cuts_out");
    if (/(?:not|won'?t|doesn'?t|no)\s*charg|charg\w*.{0,12}(?:not|fail)|充不进|不充电/.test(s)) sy.push("no_charge");
    if (/\bbroken\b|\bbroke\b|\bcrack|\bsnapped\b|\bburn|\bmelt|坏了|断了|烧/.test(s)) sy.push("broken");
    set("sym", sy);
    var mechList = cur === "P0" && (qs || []).some(function (q) { return q.id === "P0" && (q.options || []).some(function (o) { return MECHP[o.value]; }); });
    var mp = null;
    if (mechList) MECH_RX.forEach(function (x) { if (!mp && x[1].test(s)) mp = x[0]; });
    /* chat-12: a typed programming cable / mid-drive main cable, only when the engine lists it (never for a hub motor) */
    var midList = cur === "P0" && (qs || []).some(function (q) { return q.id === "P0" && (q.options || []).some(function (o) { return MIDP[o.value]; }); });
    if (!mp && midList) {
      if (/programm?ing|\bprogram\s*cable|编程|调参|programaci|programa[cç][aã]o/.test(s)) mp = "prog_cable";
      else if (/(?:mid\s*-?\s*drive|中置|motor\s*central).{0,24}(?:cable|harness|wire|线)|(?:cable|harness|主线|线束).{0,24}(?:mid\s*-?\s*drive|中置|motor\s*central)|\b1\s*-?\s*to\s*-?\s*4\b|\b1t4\b|一拖四/.test(s)) mp = "mid_harness";
    }
    if (mp) F.part = mp;                                       /* chat-8: a mechanical part name wins over the electric words in it ("brake cable") */
    else if (cur === "P0") {
      var pt = [];
      [["controller", /controller|控制器/], ["display", /display|screen|\blcd\b|仪表/], ["throttle", /throttle|转把/],
       ["brake_lever", /brake\s*levers?|刹把/], ["pas_sensor", /\bpas\b|pedal\s*sensor|助力传感器/], ["charger", /charger|充电器/],
       ["battery", /battery|电池/], ["motor", /motor|电机/], ["cable", /cable|\bwire|harness|线/]].forEach(function (x) { if (x[1].test(s)) pt.push(x[0]); });
      set("part", pt);
    }
    /* a bare number answers the question on screen (unit implied by that question) */
    var bare = /^(\d{1,4}(?:\.\d{1,2})?)\s*([a-z"]*)$/.exec(s);
    if (bare && !bare[2]) {
      var b = bare[1], f = num(b);
      var BQ = { B3: ["volt", f >= 12 && f <= 100], M8: ["watt", f >= 100], C2b: ["amps", f <= 200], C2: ["amps", f <= 200],
                 M3: ["dropout", f >= 90 && f <= 220], D6: ["barmm", f >= 20 && f <= 40], W4: ["cm", f >= 5],
                 M6a: ["pins", f <= 20], D4: ["pins", f <= 20], W3b: ["pins", f <= 20], T4: ["pins", f <= 20], Z3: ["pins", f <= 20], Z5: ["cm", f >= 5],
                 B4: ["wheel", f >= 12 && f <= 29], B5: ["width", f > 0 && f <= 6],
                 /* chat-8: mechanical sizes (the number is in the unit of the question on screen) */
                 G1: ["mm", f > 0 && f <= 80], S1: ["mm", f > 0 && f <= 80], R3: ["mm", f > 0 && f <= 10], N3: ["mm", f > 0 && f <= 80],
                 N4: ["mm", f > 0 && f <= 80], H1: ["mm", f > 0 && f <= 30], H2: ["mm", f > 0 && f <= 30], H3: ["mm", f > 0 && f <= 30],
                 A1: ["mm", f > 0 && f <= 30], S2: ["mm", f >= 100 && f <= 800], R2: ["mm", f >= 100 && f <= 260], O2: ["mm", f >= 50 && f <= 150],
                 O4: ["mm", f >= 90 && f <= 150], F1: ["iso", f >= 300 && f <= 700], U1: ["iso", f >= 300 && f <= 700],
                 F2: ["width", f > 0 && f <= 6], U2: ["width", f > 0 && f <= 6], X3: ["width", f > 0 && f <= 6],
                 V2: ["wheel", f >= 12 && f <= 29], X2: ["wheel", f >= 12 && f <= 29], Y3: ["cm", f >= 5] }[cur];
      if (BQ && BQ[1]) F[BQ[0]] = b;
      else if ((cur === "F1" || cur === "U1") && INCH_ISO[b]) F.iso = INCH_ISO[b];     /* "26" on the ISO question = 26 in = ISO 559 */
    }
    return F;
  }
  function optLabel(q, v) { return (OPT[q] && OPT[q][v]) || null; }
  function valueLabel(item) {
    if (item.idk) return U("not_sure");
    if (item.v != null) return L(optLabel(item.q, item.v) || item.v);
    return item.other + (UNIT[item.q] && /^\d+(\.\d+)?$/.test(item.other) ? L(UNIT[item.q]) : "");
  }
  /* ctx = {cur: question on screen, qs: [{id, state, options:[{value}]}]} -> [{q, v} | {q, other} | {q, idk}] with our own label */
  function parse(text, ctx) {
    var s = norm(text), cur = ctx && ctx.cur, qs = (ctx && ctx.qs) || [], out = [];
    if (!s) return out;
    if (IDK_RX.test(s)) return cur ? [{ q: cur, idk: true, label: U("not_sure") }] : [];
    var by = {}; qs.forEach(function (q) { by[q.id] = q; });
    var has = function (q, v) { return by[q] && (by[q].options || []).some(function (o) { return o.value === v; }); };
    var open = function (q) { return q === cur || (by[q] && by[q].state === "pending"); };
    var F = fields(s, cur, qs), seen = {};
    /* fix 3: a plug value from a plug word only (julet, higo, SM/JST, "plug", "pin"…); a brand name on a label is not a plug shape */
    var plugWord = /julet|higo|z910|arrow|\bsm\b|\bjst\b|plug|connector|\bpins?\b|\dp\b|朱丽叶|插头|针|芯/.test(s);
    Object.keys(FIELD_Q).forEach(function (f) {
      var v = F[f];
      if (v == null) return;
      var cands = FIELD_Q[f].filter(function (q) { return by[q] && open(q); });
      if (f === "amps" && cands.length > 1) {
        if (/bms|battery|discharge|电池/.test(s)) cands = ["C2b"]; else if (/controller|控制器/.test(s)) cands = ["C2"];
      }
      var SIB = { M6b: "M6a", M6a: "M6b", D5: "D4", D4: "D5", W3a: "W3b", W3b: "W3a", T4a: "T4", T4: "T4a" };
      var rank = function (q) { return q === cur ? 0 : q === SIB[cur] ? 1 : (has(q, String(v)) || has(q, fmtn(num(v)))) ? 2 : 3; };
      cands.sort(function (x, y) { return rank(x) - rank(y); });
      var q = cands[0];
      if (!q && (f === "conn" || f === "pins" || (f === "mm" && cur === "P0")) && !FIELD_Q[f].some(function (x) { return by[x]; })) {    /* fix 3: no plug question yet */
        var ck = f === "conn" ? "@conn" : f === "mm" ? "@mm" : "@pins", ci = null;
        if (seen[ck]) return;
        if (f === "conn" && OPT["@conn"][v] && plugWord) ci = { q: ck, v: String(v) };
        else if (f === "pins" && num(v) != null && num(v) >= 1 && num(v) <= 20) ci = { q: ck, other: fmtn(num(v)) };
        else if (f === "mm" && num(v) != null) ci = { q: ck, other: fmtn(num(v)) };       /* chat-8: "seat post clamp 31.8 mm" */
        if (ci) { seen[ck] = 1; ci.label = valueLabel(ci); out.push(ci); }
        return;
      }
      if (!q || seen[q]) return;
      var item = null;
      if (f === "width" && q !== "B5") {                       /* chat-8: tire / tube / fender width cards are exact widths */
        var ww = String(num(v));
        item = has(q, ww) ? { q: q, v: ww } : (q === cur ? { q: q, other: ww } : null);
      } else if (f === "width") {
        var w = num(v);
        var bv = w < 2.5 ? "lt2.5" : (w <= 3.0 ? "2.5-3" : (w === 4 ? "4" : null));
        item = bv && has(q, bv) ? { q: q, v: bv } : (q === cur ? { q: q, other: fmtn(w) } : null);
      } else if (has(q, String(v))) item = { q: q, v: String(v) };
      else if (has(q, fmtn(num(v)))) item = { q: q, v: fmtn(num(v)) };
      else if (f === "amps" && q === "C2b" && num(v) > 30) item = { q: q, v: "30plus" };
      else if (q === cur && UNIT[q] && num(v) != null) item = { q: q, other: fmtn(num(v)) };      /* typed number only for the question on screen */
      else if (q === cur && f === "conn") item = { q: q, other: String(text).trim().slice(0, 60) };
      else if (f === "pins" && num(v) != null && num(v) >= 1 && num(v) <= 20) item = { q: q, other: fmtn(num(v)) };   /* fix 3: "5pin" names its unit */
      else if (f === "conn" && OPT["@conn"][v] && plugWord) item = { q: q, other: OPT["@conn"][v] };  /* fix 3: a named plug shape */
      if (item) { seen[q] = 1; item.label = valueLabel(item); out.push(item); }
    });
    var ord = {}; qs.forEach(function (q, i) { ord[q.id] = i; });
    if (TEXTQ[cur] && !out.some(function (x) { return x.q === cur; })) out.push({ q: cur, other: String(text).trim().slice(0, 120), label: String(text).trim().slice(0, 120) });
    var rk = function (x) { return x.q === cur ? -1 : x.q in ord ? ord[x.q] : 900 + (x.q === "@conn" ? 0 : 1); };   /* plug cards last */
    out.sort(function (a, b) { return rk(a) - rk(b); });
    return out;
  }
  /* AI branch output filter: keep only {q, v} with v an option of a question on the list, or a short typed value for a number question.
     Names, SKUs, prices, "compatible", URLs and anything else are dropped; labels are always ours. */
  var BAD = /\$|€|£|\bsku\b|\bprice\b|\bfits?\b|compatib|\bmatch|https?:|www\.|[A-Z]{2,}-[A-Z0-9]{2,}-|\d+\.\d\d\b/i;
  function filterAI(payload, ctx) {
    var qs = (ctx && ctx.qs) || [], by = {}, out = [], seen = {};
    qs.forEach(function (q) { by[q.id] = q; });
    ((payload && payload.values) || []).forEach(function (x) {
      if (!x || typeof x !== "object" || !by[x.q] || seen[x.q]) return;
      var item = null;
      if (x.v != null && (by[x.q].options || []).some(function (o) { return o.value === String(x.v); })) item = { q: x.q, v: String(x.v) };
      else if (x.other != null && UNIT[x.q] && /^\d{1,4}(\.\d{1,2})?$/.test(String(x.other).trim()) && !BAD.test(String(x.other))) item = { q: x.q, other: String(x.other).trim() };
      else if (x.idk === true) item = { q: x.q, idk: true };
      if (item) { seen[x.q] = 1; item.label = valueLabel(item); out.push(item); }
    });
    return out;
  }
  window.RRDiagChat = { version: VERSION, parse: parse, filterAI: filterAI, strings: strings, norm: norm };

  /* ================================================================ page */
  var root = document.querySelector("[data-rr-diag-chat]");
  if (!root) return;
  var API = (root.getAttribute("data-api-base") || "").replace(/\/+$/, "");
  var ROOT = (root.getAttribute("data-root") || "/").replace(/\/+$/, "");
  var AI = root.getAttribute("data-ai-parse") === "1";
  var KEY = "rr-diag2-v1", CKEY = "rr-diag-chat-v1";
  var MAX_BYTES = 10 * 1024 * 1024, TYPES = { "image/jpeg": 1, "image/png": 1, "image/webp": 1 };
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var S = { answers: {}, notes: {}, skipped: [], cur: null, resp: null, seq: 0, stage: "start", code: null, check: 0, pend: [], photos: [],
            view: null, mode: null, part: null, edit: false, noteOpen: false, photo: null, err: null, sending: false,
            branch: null, carry: {}, carryDone: {}, resume: false, codeDone: false };

  function load() {
    try {
      var o = JSON.parse(window.localStorage.getItem(KEY) || "null");
      if (o && typeof o === "object") { S.answers = o.answers || {}; S.notes = o.notes || {}; S.skipped = o.skipped || []; }
      var c = JSON.parse(window.localStorage.getItem(CKEY) || "null");
      if (c && typeof c === "object" && S.answers.B1) {
        S.stage = c.stage || "flow"; S.code = c.code == null ? null : c.code; S.check = c.check || 0;
        S.carry = c.carry || {}; S.carryDone = c.carryDone || {}; S.branch = typeof c.branch === "string" ? c.branch : null;
        S.codeDone = !!c.codeDone || S.code != null;
      }
    } catch (e) { /* storage blocked: start fresh */ }
    if (S.branch == null) S.branch = branchKey();          /* saved before fix 1: take the saved part as the branch, clear nothing */
    S.resume = !!S.answers.B1;                            /* fix 5: saved answers -> ask "Continue / Start again" first */
    if (!S.answers.B1) S.stage = "start";
    if (S.stage === "flow" || S.stage === "fixed") S.stage = S.stage === "fixed" ? "fixed" : "flow";
  }
  function save() {
    try {
      window.localStorage.setItem(KEY, JSON.stringify({ answers: S.answers, notes: S.notes, skipped: S.skipped, cur: S.cur || (S.resp && S.resp.next) || null }));
      window.localStorage.setItem(CKEY, JSON.stringify({ stage: S.stage, code: S.code, check: S.check, carry: S.carry, carryDone: S.carryDone,
                                                         branch: S.branch, codeDone: S.codeDone }));
    } catch (e) { /* ignore */ }
  }
  function el(tag, cls, text, role) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    if (role) n.setAttribute("data-rrc-role", role);
    return n;
  }
  function pic(html, cls) { var d = el("span", cls || "rrc__pic"); d.innerHTML = html; return d; }   /* our own static drawings only */
  function btn(text, cls, attr, fn) {
    var b = el("button", cls || "rrc__btn", null);
    b.type = "button";
    var t = el("span", null, text, "btn");
    b.appendChild(t);
    if (attr) b.setAttribute(attr, "");
    if (fn) b.addEventListener("click", fn);
    return b;
  }

  /* ---------------------------------------------------------------- engine */
  function body(english) {
    var out = {};
    Object.keys(S.answers).forEach(function (k) {
      var a = S.answers[k], o = {};
      if (a.idk) o.idk = true; else if (a.other != null) o.other = a.other; else if (a.v != null) o.v = a.v; else return;
      if (S.notes[k]) o.note = S.notes[k];
      out[k] = o;
    });
    var b = { answers: out, skipped: S.skipped };
    if (LANG && !english) b.locale = LANG;
    return b;
  }
  function branchKey() { return S.answers.P0 ? JSON.stringify(S.answers.P0) : ""; }
  function branchGuard() {                /* fix 1: another part (or no part) = another branch: the old part's answers go */
    var k = branchKey();
    if (S.branch != null && S.branch !== k) {
      Object.keys(S.answers).forEach(function (q) { if (LAYER0.indexOf(q) < 0) { delete S.answers[q]; delete S.notes[q]; } });
      S.skipped = S.skipped.filter(function (q) { return LAYER0.indexOf(q) >= 0; });
      S.carryDone = {};
    }
    S.branch = k;
  }
  function pruneStale() {                 /* fix 1: answers to questions the engine no longer asks, or choices it no longer offers */
    var r = S.resp, by = {}, changed = false;
    if (!r || !r.questions) return false;
    r.questions.forEach(function (q) { by[q.id] = q; });
    Object.keys(S.answers).forEach(function (id) {
      var q = by[id], a = S.answers[id];
      if (!q || (a.v != null && !(q.options || []).some(function (o) { return o.value === a.v; }))) { delete S.answers[id]; delete S.notes[id]; changed = true; }
    });
    return changed;
  }
  function applyCarry() {                 /* fix 3: confirmed plug shape / pin count -> the plug questions of this part (once each) */
    var changed = false;
    Object.keys(S.carry).forEach(function (k) {
      var c = S.carry[k];
      if (k === "@mm") {                   /* chat-8: the first size question of this part whose range holds the size; then the size is gone */
        var id = (CARRY_Q[k] || []).filter(function (x) {
          var q = findQ(x), r = MMR[x], v = num(c.v);
          return q && q.state === "pending" && !S.answers[x] && S.skipped.indexOf(x) < 0 && r && v != null && v >= r[0] && v <= r[1];
        })[0];
        if (id) {
          S.answers[id] = (findQ(id).options || []).some(function (o) { return o.value === c.v; }) ? { v: c.v } : { other: c.v };
          delete S.carry[k]; changed = true;
        }
        return;
      }
      (CARRY_Q[k] || []).forEach(function (id) {
        var q = findQ(id);
        if (!q || q.state !== "pending" || S.answers[id] || S.carryDone[id] || S.skipped.indexOf(id) >= 0) return;
        var has = (q.options || []).some(function (o) { return o.value === c.v; });
        S.answers[id] = has ? { v: c.v } : { other: c.en };
        S.carryDone[id] = 1; changed = true;
      });
    });
    return changed;
  }
  function post(then) {
    branchGuard();
    var seq = ++S.seq;
    root.setAttribute("data-rrc-busy", "1");
    return fetch(API + "/diag2", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(body()) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) {
        if (seq !== S.seq) return;
        root.removeAttribute("data-rrc-busy");
        if (!x.ok || !x.j || !x.j.ok) { S.err = "net"; render(); return; }
        S.err = null;
        S.resp = x.j;
        root.setAttribute("data-rrc-status", x.j.status);
        var pruned = pruneStale(), carried = applyCarry();
        if (pruned || carried) { save(); post(then); return; }      /* ask the engine again with the clean answers */
        autoD2();
        warmPhotos(x.j);
        if (then) then();
        save(); render();
      })
      .catch(function () {
        if (seq !== S.seq) return;
        root.removeAttribute("data-rrc-busy");
        S.err = "net"; render();
      });
  }
  function autoD2() {                     /* the code the customer confirmed on screen 2 answers engine question D2 (record only) */
    var d2 = findQ("D2");
    if (d2 && d2.state === "pending" && S.code != null && !S.answers.D2) {
      S.answers.D2 = S.code ? { other: S.code } : { v: "none" };
      setTimeout(function () { post(); }, 0);
    }
  }
  function findQ(id) {
    var qs = (S.resp && S.resp.questions) || [];
    for (var i = 0; i < qs.length; i++) if (qs[i].id === id) return qs[i];
    return null;
  }
  function qsList() { return (S.resp && S.resp.questions) || []; }
  function pending() { return qsList().filter(function (q) { return q.state === "pending"; }).length; }
  function gateOpen(r) {
    if (!r || r.status !== "results" || !r.gate || r.gate.open !== true || !(r.results || []).length) return false;
    var req = 0;
    for (var i = 0; i < r.questions.length; i++) {
      if (!r.questions[i].required) continue;
      req++;
      if (r.questions[i].state !== "answered") return false;
    }
    return req > 0;
  }

  /* ---------------------------------------------------------------- counter bar: "N parts fit · M questions left" */
  function preEl() {                      /* "0 parts fit · " in front of the counter words (fix 2b) */
    var p = $("[data-rrc-counter-pre]");
    if (!p) { p = el("span", "rrc__pre", null, "counter"); p.setAttribute("data-rrc-counter-pre", ""); var t = $("[data-rrc-counter-text]"); t.parentNode.insertBefore(p, t); }
    return p;
  }
  function setCounter(n, m, zero, upto, maybe) {
    var t = $("[data-rrc-counter-text]");
    root.setAttribute("data-rrc-count", String(n));
    root.setAttribute("data-rrc-left", String(m));
    if (upto) root.setAttribute("data-rrc-upto", "1"); else root.removeAttribute("data-rrc-upto");
    t.setAttribute("data-rrc-role", "counter");
    preEl().textContent = zero ? U("zero_pre") + " · " : "";          /* fix 2b: the 0 shows the moment an answer gives 0 parts */
    var lw = upto && m > 1 ? U("upto_many", { n: m }) : UN(m, "left_one", "left_many");
    /* chat-8: a mechanical part with 0 parts in stock still asks its sizes: "We find it for you · 2 questions left" */
    /* chat-10 (retest item 2): a required answer is "Not sure": the parts fit the other answers only -> "1 part may fit", not "1 part fits" */
    /* chat-15 (F1103-2002mh): before the part is known the count is "every part in the shop" (108), so the bar shows only the
       questions left; from the moment the engine has the part it shows the real count again. 0 parts still shows (fix 2b). */
    var noPart = !zero && !partKnown();
    if (noPart) root.setAttribute("data-rrc-count-hidden", "1"); else root.removeAttribute("data-rrc-count-hidden");
    t.textContent = zero ? U("find_it") + (m > 0 ? " · " + lw : "") : noPart ? lw : UN(n, maybe ? "maybe_one" : "parts_one", maybe ? "maybe_many" : "parts_many") + " · " + lw;
  }
  function partKnown() {
    var q = findQ("P0");
    if (q) return q.state === "answered";
    var a = S.answers.P0;
    return !!(a && !a.idk && (a.v != null || (a.other != null && String(a.other).trim())));
  }
  function setStatus(text, n) {           /* fix 2a: summary, results and hand-off show a state, not "N parts fit · 0 questions left" */
    if (n != null) root.setAttribute("data-rrc-count", String(n));
    root.setAttribute("data-rrc-left", "0");
    root.removeAttribute("data-rrc-upto");
    preEl().textContent = "";
    $("[data-rrc-counter-text]").textContent = text;
  }
  function partFirst() { return !!(S.answers.B1 && S.answers.B1.v === "broken"); }    /* chat-8: the engine asks the part right after "Part broken" */
  /* chat-10 (retest item 1): on "Part broken" the code question comes after the part, and only for a part that is not mechanical
     (a typed part name counts as the part the engine read from it) */
  function mechNow() {
    var a = S.answers.P0, q = findQ("P0"), v = a && a.v ? a.v : q && q.answer ? q.answer.value : null;
    return !!(v && MECHP[v]);
  }
  function dropCode() {                   /* a mechanical part: no code question, no "Code" answer */
    S.code = null; S.codeDone = false;
    if (S.notes.B1 && /^Error code:/.test(S.notes.B1)) delete S.notes.B1;
    save();
  }
  /* chat-10 (retest item 2): required questions answered "Not sure"; the engine keeps the gate closed and lists no part */
  function idkReq(r) { return ((r && r.questions) || []).filter(function (q) { return q.required && q.state === "idk"; }); }
  function idkOnly(r) {                   /* nothing left to ask, parts fit every other answer, and every missing answer is "Not sure" */
    if (!r || !r.questions || r.next || !(r.count > 0)) return false;
    var need = r.questions.filter(function (q) { return q.required && q.state !== "answered"; });
    return need.length > 0 && need.every(function (q) { return q.state === "idk"; });
  }
  function pathLen(v) {
    var n = PATH_N[v] || 0;
    if (v === "motor" && S.answers.B2 && S.answers.B2.v === "front") n -= 1;
    if ((MECHP[v] || MIDP[v] || v === "brake_lever") && !S.answers.B6 && S.skipped.indexOf("B6") < 0) n += 1;     /* chat-8: the optional bike question at the end */
    else if (partFirst() && !MECHP[v] && !MIDP[v]) n += qsList().filter(function (q) { return q.state === "pending" && LAYER0.indexOf(q.id) >= 0 && q.id !== "P0"; }).length;
    return n;
  }
  function left() {                       /* fix 2c: before the part is known (or while it is changed): "up to" the longest part path */
    var p0 = findQ("P0");
    if (!p0 || (p0.state !== "pending" && !(S.cur === "P0" && S.edit))) return { n: pending(), upto: false };
    var mx = 0;
    (p0.options || []).forEach(function (o) { mx = Math.max(mx, pathLen(o.value)); });
    if (partFirst()) return { n: 1 + mx, upto: mx > 0 };
    var l0 = qsList().filter(function (q) { return q.state === "pending" && LAYER0.indexOf(q.id) >= 0; }).length;
    return { n: l0 + mx, upto: mx > 0 };
  }
  function counter() {
    var r = S.resp, at = root.getAttribute("data-rrc-at");
    if (!r) { setStatus(U("loading")); return; }
    if (at === "S8b") {
      var md = $("[data-rrc-screen]").getAttribute("data-rrc-mode");
      if (md === "source" || r.status === "source" || r.count === 0) setCounter(0, 0, true); else setStatus(U("check_c"), r.count);
      return;
    }
    if (at === "S8a" || (at === "S7" && gateOpen(r))) { setStatus(UN(r.count, "parts_one", "parts_many"), r.count); return; }
    if (at === "S7") { setStatus(idkOnly(r) ? UN(r.count, "maybe_one", "maybe_many") : U("check_c"), r.count); return; }    /* chat-11: same words as the summary text below it */
    var lf = left();
    setCounter(r.count, lf.n, r.status === "source" || r.count === 0, lf.upto, idkReq(r).length > 0);
  }

  /* ---------------------------------------------------------------- drawer: answers (tap ✕ to undo) + funnel */
  function chipText(q) {
    var a = S.answers[q], qc = QC[q];
    var name = L(qc ? qc[2] : q);
    if (!a) return name + ": " + U("skipped");
    var fq = findQ(q);
    var v = a.idk ? U("unsure_chip") : a.other != null ? valueLabel({ q: q, other: a.other }) : L(optLabel(q, a.v) || (fq && fq.answer && fq.answer.label) || a.v);
    return name + ": " + v;
  }
  function renderDrawer() {
    var r = S.resp, ul = $("[data-rrc-chips]"), fl = $("[data-rrc-funnel]");
    ul.textContent = ""; fl.textContent = "";
    if (!r) return;
    var cw = {};
    (r.chips || []).forEach(function (c) { cw[c.q] = c.count_without; });
    if (S.code != null) ul.appendChild(el("li", "rrc__chip rrc__chip--static", L(UI.code_chip[0]) + ": " + (S.code || U("no_code")), "data"));
    r.questions.forEach(function (q) {
      if (q.state === "pending" || (q.state === "skipped" && !S.answers[q.id])) return;
      var li = el("li");
      var b = el("button", "rrc__chip");
      b.type = "button";
      b.setAttribute("data-rrc-chip", q.id);
      b.setAttribute("aria-label", U("remove") + ": " + chipText(q.id));
      b.appendChild(el("span", null, chipText(q.id), "data"));
      b.appendChild(el("span", "rrc__chipx", "✕"));
      b.addEventListener("click", function () {
        delete S.answers[q.id];
        if (typeof cw[q.id] === "number") setCounter(cw[q.id], pending() + 1, cw[q.id] === 0);   /* at once; the engine answer follows */
        S.cur = q.id; S.view = null; S.stage = "flow"; S.edit = true;
        save(); post(); closeDrawer();
      });
      li.appendChild(b); ul.appendChild(li);
    });
    var need = r.questions.filter(function (q) { return q.required && q.state !== "answered"; });
    var nw = $("[data-rrc-need]");
    nw.textContent = "";
    nw.hidden = !need.length;
    if (need.length) {
      nw.appendChild(el("span", null, U("still_need") + ": ", "label"));
      nw.appendChild(el("span", null, need.map(function (q) { return L(QC[q.id] ? QC[q.id][2] : q.id); }).join(", "), "data"));
      nw.setAttribute("data-rrc-need", need.map(function (q) { return q.id; }).join(" "));
    }
    r.funnel.forEach(function (st) {
      var li = el("li", "rrc__fstep");
      li.appendChild(el("span", null, st.label, "data"));
      li.appendChild(el("b", null, String(st.count), "data"));
      if (st.why) li.appendChild(el("span", "rrc__fwhy", st.why, "data"));
      fl.appendChild(li);
    });
  }
  function openDrawer() { renderDrawer(); $("[data-rrc-drawer]").hidden = false; root.classList.add("rrc--drawer"); }
  function closeDrawer() { $("[data-rrc-drawer]").hidden = true; root.classList.remove("rrc--drawer"); }

  /* ---------------------------------------------------------------- screens */
  function screenEl(id, qid) {
    var box = $("[data-rrc-screen]");
    box.textContent = "";
    box.setAttribute("data-rrc-screen", id);
    if (qid) box.setAttribute("data-rrc-qid", qid); else box.removeAttribute("data-rrc-qid");
    root.setAttribute("data-rrc-at", id);
    return box;
  }
  function bot(box, text, role) { var b = el("p", "rrc__bot", text, role || "q"); if ((role || "q") === "q") b.setAttribute("data-rrc-active", ""); box.appendChild(b); return b; }
  function hint(box, text) {
    if (S.err === "photo") { text = U("err_photo"); S.err = null; }
    if (text) box.appendChild(el("p", "rrc__hint", text, "hint"));
  }
  function history(box) {                 /* the last answered question and its answer, like a chat log */
    if (S.ret === "sum" && S.edit) return;   /* r5 fix 1: opened from the summary = that question alone, no earlier question above it */
    var qs = qsList(), last = null;
    for (var i = 0; i < qs.length; i++) {
      if (qs[i].id === S.cur) break;
      if (S.answers[qs[i].id]) last = qs[i].id;
    }
    if (!last) return;
    var h = el("div", "rrc__hist"), unsure = !!S.answers[last].idk;
    h.appendChild(el("p", "rrc__bot rrc__bot--old", L(QC[last] ? QC[last][0] : last), "hist"));
    /* r2 fix 8: "Not sure" as the old answer reads "Tire width: Not sure" in grey, so it is not taken for the "Not sure" card below */
    h.appendChild(el("p", "rrc__me" + (unsure ? " rrc__me--idk" : ""), unsure ? chipText(last) : chipText(last).split(": ").slice(1).join(": "), "data"));
    box.appendChild(h);
  }
  function card(text, picHtml, attrs, fn) {
    var b = el("button", "rrc__card");
    b.type = "button";
    Object.keys(attrs || {}).forEach(function (k) { b.setAttribute(k, attrs[k]); });
    if (picHtml) b.appendChild(pic(picHtml));
    b.appendChild(el("span", "rrc__clabel", text, "btn"));
    if (fn) b.addEventListener("click", fn);
    return b;
  }
  function inputBar(box, cur) {           /* every question: type an answer, add a photo, add a note */
    var f = el("form", "rrc__input");
    f.setAttribute("data-rrc-input", "");
    var ph = el("label", "rrc__icon");
    ph.setAttribute("aria-label", U("add_photo"));
    ph.setAttribute("data-rrc-role", "aria");
    ph.innerHTML = PIC.photo();
    var fi = el("input", "rrc__file");
    fi.type = "file"; fi.accept = "image/jpeg,image/png,image/webp";
    fi.setAttribute("data-rrc-photo", "");
    fi.addEventListener("change", function () { if (fi.files && fi.files[0]) onPhoto(fi.files[0], cur); fi.value = ""; });
    ph.appendChild(fi);
    f.appendChild(ph);
    var nt = el("button", "rrc__icon rrc__icon--note", "✎");
    nt.type = "button";
    nt.setAttribute("aria-label", U("add_note"));
    nt.setAttribute("data-rrc-note-toggle", "");
    nt.addEventListener("click", function () { S.noteOpen = !S.noteOpen; render(); var t = $("[data-rrc-note]"); if (t) t.focus(); });
    f.appendChild(nt);
    var inp = el("input", "rrc__text");
    inp.type = "text"; inp.maxLength = 120; inp.placeholder = U("type_here");
    inp.setAttribute("aria-label", U("type_here"));
    inp.setAttribute("data-rrc-text", "");
    inp.setAttribute("enterkeyhint", "send");
    f.appendChild(inp);
    var sb = el("button", "rrc__send", null);
    sb.type = "submit";
    sb.setAttribute("data-rrc-send", "");
    sb.appendChild(el("span", null, U("send"), "btn"));
    f.appendChild(sb);
    f.addEventListener("submit", function (e) { e.preventDefault(); var t = inp.value.trim(); if (t) onText(t, cur); });
    box.appendChild(f);
    if (S.noteOpen) {
      var key = cur && /^[A-Z]/.test(cur) ? cur : "B1";
      var ta = el("textarea", "rrc__note");
      ta.rows = 2; ta.maxLength = 500; ta.placeholder = U("note_ph");
      ta.setAttribute("aria-label", U("note_ph"));
      ta.setAttribute("data-rrc-note", "");
      ta.value = S.notes[key] || "";
      ta.addEventListener("input", function () { if (ta.value.trim()) S.notes[key] = ta.value.trim(); else delete S.notes[key]; save(); });
      box.appendChild(ta);
    }
  }

  /* S1: six symptom cards */
  function renderStart() {
    var box = screenEl("S1");
    bot(box, U("start_q"));
    hint(box, null);
    var g = el("div", "rrc__cards rrc__cards--sym");
    g.setAttribute("role", "group");
    g.setAttribute("data-rrc-cards", "");
    SYM.forEach(function (s) {
      var a = S.answers.B1;
      var on = s[0] ? (a && a.v === s[0]) : (a && a.idk);
      g.appendChild(card(L(s[1]), PIC[s[2]](), { "data-rrc-sym": s[0] || "idk", "aria-pressed": on ? "true" : "false" }, function () { setSym(s[0]); }));
    });
    box.appendChild(g);
    inputBar(box, "B1");
  }
  function setSym(v) {
    S.answers.B1 = v ? { v: v } : { idk: true };
    S.stage = symStage(); S.check = 0;
    save(); post();
  }
  function symStage() {                   /* chat-10 (retest item 1): "Part broken" -> the part list first; the code question waits for the part */
    if (!partFirst()) return "code";
    S.code = null; S.codeDone = false;
    return "flow";
  }
  /* S2: error code first */
  function renderCode() {
    var box = screenEl("S2", "code");
    bot(box, U("code_q"));
    box.appendChild(pic(PIC.code(), "rrc__pic rrc__pic--top"));
    hint(box, U("code_hint"));
    var g = el("div", "rrc__actions");
    g.appendChild(btn(U("no_code"), "rrc__btn rrc__btn--ghost", "data-rrc-nocode", function () { S.code = ""; afterCode(); }));
    g.appendChild(btn(U("back"), "rrc__link", "data-rrc-back", function () {
      if (partFirst() && S.answers.P0) { S.stage = "flow"; S.cur = "P0"; S.edit = true; save(); render(); return; }   /* chat-10: back to the part */
      S.stage = "start"; save(); render();
    }));
    box.appendChild(g);
    inputBar(box, "code");
  }
  function afterCode() {
    S.codeDone = true;
    if (S.code) S.notes.B1 = "Error code: " + S.code; else if (S.notes.B1 && /^Error code:/.test(S.notes.B1)) delete S.notes.B1;
    var sym = S.answers.B1 && S.answers.B1.v ? S.answers.B1.v : "idk";
    S.stage = (CHECKS[sym] || []).length ? "check" : "flow";
    S.check = 0;
    save(); post();
  }
  /* S3: free checks. r3 fix 3: all quick checks on one screen as a list, then one button "I did these. Still dead."
     (was one screen per check with Fixed / Not fixed: 5 screens before the first engine question on the motor path) */
  function renderCheck() {
    var sym = S.answers.B1 && S.answers.B1.v ? S.answers.B1.v : "idk", steps = CHECKS[sym] || [];
    if (!steps.length) { S.stage = "flow"; save(); render(); return; }
    var box = screenEl("S3", "checks");
    bot(box, U("checks_q"));
    var ol = el("ol", "rrc__checks");
    ol.setAttribute("data-rrc-checks", String(steps.length));
    steps.forEach(function (st) {
      var li = el("li", "rrc__chk");
      li.appendChild(pic(PIC[st[1]](), "rrc__pic rrc__chk-pic"));
      li.appendChild(el("span", "rrc__chk-t", L(st[0]), "label"));
      ol.appendChild(li);
    });
    box.appendChild(ol);
    var g = el("div", "rrc__actions");
    g.appendChild(btn(L(STILL[sym] || STILL.idk), "rrc__btn", "data-rrc-notfixed", function () { S.check = steps.length; S.stage = "flow"; save(); render(); }));
    g.appendChild(btn(U("works_now"), "rrc__btn rrc__btn--ghost", "data-rrc-fixed", function () { S.stage = "fixed"; save(); render(); }));
    g.appendChild(btn(U("back"), "rrc__link", "data-rrc-back", function () { S.check = 0; S.stage = "code"; save(); render(); }));
    box.appendChild(g);
  }
  function renderFixed() {
    var box = screenEl("S3", "fixed");
    box.appendChild(el("h2", "rrc__title", U("works_t"), "title"));
    box.appendChild(pic(PIC.chk_switch(), "rrc__pic rrc__pic--top"));
    var g = el("div", "rrc__actions");
    g.appendChild(btn(U("find_part"), "rrc__btn rrc__btn--ghost", "data-rrc-findpart", function () { S.stage = "flow"; save(); render(); }));
    g.appendChild(btn(U("start_again"), "rrc__btn", "data-rrc-again", restart));
    box.appendChild(g);
  }
  /* S4 / S6: one engine question */
  function renderQuestion(q) {
    var measure = !!MEASURE[q.id];
    var box = screenEl(measure ? "S6" : "S4", q.id);
    box.setAttribute("data-rrc-required", q.required ? "1" : "0");
    history(box);
    bot(box, L(QC[q.id] ? QC[q.id][0] : q.text));
    var tp = topPic(q.id);
    if (tp) box.appendChild(pic(tp === "bar" ? bar("") : tp === "tape" ? tape("") : PIC[tp](), "rrc__pic rrc__pic--top"));
    if (q.id === "D3") protoHelp(box, false);
    var a = S.answers[q.id] || {};
    /* chat-8: the part list in two levels. Electric parts + one "Mechanical part" card; that card opens the mechanical parts
       (engine lists them on the "Part broken" route only) with a card back to the electric parts. */
    var mo = q.id === "P0" ? q.options.filter(function (o) { return MECHP[o.value]; }) : [];
    if (mo.length && S.p0m == null) S.p0m = !!(a.v && MECHP[a.v]);
    var mlist = mo.length > 0 && !!S.p0m;
    hint(box, mlist ? U("mech_hint") : QC[q.id] && QC[q.id][1] ? L(QC[q.id][1]) : null);
    box.setAttribute("data-rrc-p0list", q.id !== "P0" ? "" : mlist ? "mech" : "elec");
    var g = el("div", "rrc__cards" + (measure || q.id === "D3" ? " rrc__cards--num" : "") + (q.id === "B4" ? " rrc__cards--wheel" : ""));
    g.setAttribute("role", "group");
    g.setAttribute("data-rrc-cards", "");
    var opts = q.options.slice();
    if (mo.length) opts = opts.filter(function (o) { return mlist ? MECHP[o.value] : !MECHP[o.value]; });
    if (q.id === "B3") {                     /* fix 4: 24 / 60 / 72 V cards next to the engine's 36 / 48 / 52 V */
      EXTRA_V.forEach(function (v) { if (!opts.some(function (o) { return o.value === v; })) opts.push({ value: v, extra: true }); });
      opts.sort(function (x, y) { return num(x.value) - num(y.value); });
    }
    opts.forEach(function (o) {
      var ph = optPic(q.id, o.value, S.answers);
      var on = o.extra ? a.other != null && num(a.other) === num(o.value) : a.v === o.value;
      var at = { "data-rrc-opt": o.value, "aria-pressed": on ? "true" : "false" };
      if (o.extra) at["data-rrc-extra"] = ""; else at["data-count"] = String(o.count);
      g.appendChild(card(L(optLabel(q.id, o.value) || o.label), ph, at, function () { if (o.extra) chooseOther(q, o.value); else choose(q, o.value, o.count); }));
    });
    if (q.id === "B3") {                     /* r3 fix 5: an Other card opens a box to type the voltage (was: only the input bar at the bottom) */
      var typed = a.other != null && !opts.some(function (o) { return num(o.value) === num(a.other); });
      g.appendChild(card(U("other"), label("?V", "battery"), { "data-rrc-other": "", "aria-pressed": typed || S.otherOpen === q.id ? "true" : "false" },
        function () { S.otherOpen = S.otherOpen === q.id ? null : q.id; render(); }));
    }
    if (q.id === "B6" || q.id === "B7") {    /* chat-8 (retest item 4): a card that opens a text box for the brand / model or the label text */
      g.appendChild(card(U("type_it"), PIC.typeit(), { "data-rrc-other": "", "aria-pressed": a.other != null || S.otherOpen === q.id ? "true" : "false" },
        function () { S.otherOpen = S.otherOpen === q.id ? null : q.id; render(); }));
    }
    if (mo.length) {                         /* chat-8: switch between the two part lists (no engine call) */
      g.appendChild(mlist ? card(U("elec_parts"), partIcon("@elec"), { "data-rrc-elec": "" }, function () { S.p0m = false; render(); })
                          : card(U("mech_part"), partIcon("@mech"), { "data-rrc-mech": "" }, function () { S.p0m = true; render(); }));
    }
    g.appendChild(card(U("not_sure"), PIC.unsure(), { "data-rrc-idk": "", "aria-pressed": a.idk ? "true" : "false" }, function () { setIdk(q.id); }));
    box.appendChild(g);
    if (S.otherOpen === q.id) otherBox(box, q);
    var nav = el("div", "rrc__actions");
    if (q.optional) nav.appendChild(btn(U("skip"), "rrc__btn rrc__btn--ghost", "data-rrc-skip", function () { skip(q.id); }));
    if (S.ret === "sum" && S.edit) nav.appendChild(btn(U("sum_back"), "rrc__link", "data-rrc-sumback", function () {   /* r4 fix 3: no change */
      S.cur = null; S.edit = false; S.ret = null; S.otherOpen = null; save(); render();
    }));
    else nav.appendChild(btn(U("back"), "rrc__link", "data-rrc-back", function () { back(q.id); }));
    box.appendChild(nav);
    inputBar(box, q.id);
  }
  /* r3 fix 5: the box under the voltage cards. Sending it = typing the value in the input bar (same confirm card, same strict filter). */
  function otherBox(box, q) {
    var f = el("form", "rrc__other"), txt = q.id === "B6" || q.id === "B7";    /* chat-8: the same box takes text on the bike / label questions */
    f.setAttribute("data-rrc-otherbox", q.id);
    var lw = txt ? U(q.id === "B6" ? "box_b6" : "box_b7") : U("other_v");
    var lb = el("label", "rrc__other-t", lw, "label");
    var inp = el("input", "rrc__text rrc__other-in");
    inp.type = "text"; inp.maxLength = txt ? 120 : 20; inp.placeholder = txt ? U(q.id === "B6" ? "ph_b6" : "ph_b7") : U("other_ph");
    inp.setAttribute("inputmode", txt ? "text" : "decimal");
    inp.setAttribute("enterkeyhint", "send");
    inp.setAttribute("aria-label", lw);
    inp.setAttribute("data-rrc-other-input", "");
    lb.appendChild(inp);
    f.appendChild(lb);
    var sb = el("button", "rrc__btn rrc__other-send", null);
    sb.type = "submit";
    sb.setAttribute("data-rrc-other-send", "");
    sb.appendChild(el("span", null, U("send"), "btn"));
    f.appendChild(sb);
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var t = inp.value.trim();
      if (!t) { inp.focus(); return; }
      if (!txt && /^\d+(?:[.,]\d+)?$/.test(t)) t = t.replace(",", ".") + "V";   /* a bare number on the voltage box means volts */
      S.otherOpen = null;
      onText(t, q.id);
    });
    box.appendChild(f);
    setTimeout(function () { try { inp.focus(); } catch (e) { /* old browsers */ } }, 0);
  }
  /* r2 fix 5: protocol help with pictures: the 3 places the word is written, what to look for, a label photo button.
     On the question screen the photo goes the usual way (photo screen -> "Use photo" = Not sure + the photo goes with the request);
     on the hand-off screen it joins the photos of the request at once. */
  function protoHelp(box, handoff) {
    var w = el("div", "rrc__phelp");
    w.setAttribute("data-rrc-protohelp", handoff ? "handoff" : "question");
    w.appendChild(el("p", "rrc__phelp-t", U("proto_where"), "label"));
    var g = el("div", "rrc__phelp-g");
    [["proto_disp", "display"], ["proto_cable", "cable"], ["proto_ctl", "ctl"]].forEach(function (x) {
      var f = el("figure", "rrc__phelp-f");
      f.appendChild(pic(protoPic(x[1])));
      f.appendChild(el("figcaption", null, U(x[0]), "label"));
      g.appendChild(f);
    });
    w.appendChild(g);
    w.appendChild(el("p", "rrc__phelp-look", U("proto_look"), "label"));
    var lab = el("label", "rrc__btn rrc__btn--ghost rrc__phelp-photo");
    lab.setAttribute("data-rrc-protophoto", "");
    lab.appendChild(el("span", null, U("proto_photo"), "btn"));
    var fi = el("input", "rrc__file");
    fi.type = "file"; fi.accept = "image/jpeg,image/png,image/webp";
    fi.addEventListener("change", function () {
      var f = fi.files && fi.files[0];
      fi.value = "";
      if (!f) return;
      if (!handoff) { onPhoto(f, "D3"); return; }
      if (!TYPES[f.type] || f.size > MAX_BYTES) { S.err = "photo"; render(); return; }
      S.err = null; S.photos.push({ file: f, q: "D3" }); render();
    });
    lab.appendChild(fi);
    w.appendChild(lab);
    box.appendChild(w);
  }
  /* r5 fix 2: opened from the summary and tapped the answer that is already chosen -> back to the summary at once (no change to send) */
  function keepAnswer(id, same) {
    var a = S.answers[id];
    if (!(S.ret === "sum" && S.edit && S.cur === id && a && same(a))) return false;
    S.cur = null; S.edit = false; S.ret = null; S.otherOpen = null; S.typed = null; S.noteOpen = false;
    save(); render();
    return true;
  }
  function choose(q, value, count) {
    if (keepAnswer(q.id, function (a) { return a.v === value; })) return;
    var lf = left(), p0 = q.id === "P0";
    S.answers[q.id] = { v: value };
    S.skipped = S.skipped.filter(function (x) { return x !== q.id; });
    var maybe = idkReq(S.resp).some(function (x) { return x.id !== q.id; });
    if (typeof count === "number") setCounter(count, p0 ? pathLen(value) : Math.max(0, lf.n - 1), count === 0, !p0 && lf.upto, maybe);   /* at once (< 300 ms) */
    advance();
  }
  function chooseOther(q, value) {        /* fix 4: a picture card the engine does not list = the same as typing the value */
    if (keepAnswer(q.id, function (a) { return a.other != null && num(a.other) === num(value); })) return;
    S.answers[q.id] = { other: value };
    S.skipped = S.skipped.filter(function (x) { return x !== q.id; });
    advance();
  }
  function setIdk(id) { if (keepAnswer(id, function (a) { return !!a.idk; })) return; S.answers[id] = { idk: true }; S.skipped = S.skipped.filter(function (x) { return x !== id; }); advance(); }
  function skip(id) { delete S.answers[id]; if (S.skipped.indexOf(id) < 0) S.skipped.push(id); advance(); }
  function advance() { S.ret = null; S.resetAsk = false; S.typed = null; S.cur = null; S.edit = false; S.noteOpen = false; S.otherOpen = null; S.photo = null; S.stage = "flow"; S.view = null; save(); post(); }
  function back(id) {
    var qs = qsList(), i = -1;
    for (var k = 0; k < qs.length; k++) if (qs[k].id === id) i = k;
    for (var j = i - 1; j >= 0; j--) if (qs[j].state !== "pending") {
      if (qs[j].id === "P0" && partFirst() && S.codeDone && !mechNow()) { S.cur = null; S.edit = false; S.stage = "code"; save(); render(); return; }   /* chat-10 */
      S.cur = qs[j].id; S.edit = true; S.stage = "flow"; save(); render(); return;
    }
    var sym = S.answers.B1 && S.answers.B1.v ? S.answers.B1.v : "idk";
    if ((CHECKS[sym] || []).length) { S.stage = "check"; S.check = CHECKS[sym].length - 1; } else S.stage = "code";
    save(); render();
  }
  /* typed text and photos -> confirm cards */
  function onText(t, cur) {
    S.typed = t.slice(0, 120);
    if (cur === "code") {
      S.pend = /^(?:no|none|no code|没有|ninguno|nenhum)$/i.test(norm(t)) ? [{ q: "code", other: "", label: U("no_code") }]
        : [{ q: "code", other: t.slice(0, 20), label: t.slice(0, 20) }];
      S.stage = S.stage === "start" ? "start" : S.stage; render(); return;
    }
    var ctx = { cur: cur, qs: qsList().length ? qsList() : [{ id: "B1", state: "pending", options: SYM.filter(function (s) { return s[0]; }).map(function (s) { return { value: s[0] }; }) }] };
    var done = function (items) {
      if (!items.length) items = [{ q: cur, other: t.slice(0, 120) }];
      items.forEach(function (x) { if (!x.label) x.label = valueLabel(x); });
      S.pend = items; render();
    };
    if (AI) aiParse({ text: t }, ctx).then(done, function () { done(parse(t, ctx)); });
    else done(parse(t, ctx));
  }
  function aiParse(input, ctx) {                 /* switch off by default; no endpoint is connected in this task */
    var opts = {};
    ctx.qs.forEach(function (q) { if (q.state === "pending" || q.id === ctx.cur) opts[q.id] = (q.options || []).map(function (o) { return o.value; }); });
    var fd;
    if (input.file) { fd = new FormData(); fd.append("photo", input.file); fd.append("q", ctx.cur || ""); fd.append("options", JSON.stringify(opts)); }
    return fetch(API + "/diag2/parse", input.file ? { method: "POST", body: fd } :
      { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ text: input.text, q: ctx.cur, options: opts }) })
      .then(function (r) { if (!r.ok) throw new Error("parse"); return r.json(); })
      .then(function (j) { var v = filterAI(j, ctx); if (!v.length) throw new Error("empty"); return v; });
  }
  function onPhoto(f, cur) {
    if (!TYPES[f.type] || f.size > MAX_BYTES) { S.err = "photo"; render(); return; }
    S.err = null;
    S.typed = null;
    S.photos.push({ file: f, q: cur });
    if (AI && cur !== "code") {
      aiParse({ file: f }, { cur: cur, qs: qsList() }).then(function (v) { S.pend = v; render(); }, function () { S.photo = { file: f, q: cur }; render(); });
      return;
    }
    S.photo = { file: f, q: cur }; render();
  }
  function renderPhoto() {                       /* S5 (AI off): the photo goes to a person; the customer picks what to do */
    var p = S.photo, box = screenEl("S5", "photo");
    var b = el("div", "rrc__me rrc__me--photo");
    var im = el("img", "rrc__thumb");
    try { im.src = URL.createObjectURL(p.file); } catch (e) { /* no preview */ }
    im.alt = "";
    b.appendChild(im);
    box.appendChild(b);
    bot(box, U("photo_hint"), "hint");
    var g = el("div", "rrc__actions");
    g.appendChild(btn(U("use_photo"), "rrc__btn", "data-rrc-usephoto", function () {
      S.photo = null;
      if (p.q === "code") { S.code = null; afterCode(); return; }
      if (p.q === "B1") { setSym(null); return; }
      var q = findQ(p.q);
      if (q && q.optional) skip(p.q); else setIdk(p.q);
    }));
    g.appendChild(btn(U("pick_card"), "rrc__btn rrc__btn--ghost", "data-rrc-pickcard", function () { S.photo = null; render(); }));
    box.appendChild(g);
  }
  function renderConfirm() {                     /* S5: one value per card; Yes = into the answers, No = back to the cards */
    var it = S.pend[0], box = screenEl("S5", "confirm");
    box.setAttribute("data-rrc-confirm-q", it.q);
    if (S.typed) box.appendChild(el("p", "rrc__me", S.typed, "data"));      /* what the customer typed, as their chat bubble */
    bot(box, U("confirm_q"));
    var name = it.q === "code" ? L(UI.code_chip[0]) : L(QC[it.q] ? QC[it.q][2] : it.q);
    var c = el("p", "rrc__value", name + ": " + it.label, "data");
    c.setAttribute("data-rrc-value", "");
    box.appendChild(c);
    var g = el("div", "rrc__actions");
    g.appendChild(btn(U("yes"), "rrc__btn", "data-rrc-yes", function () {
      S.pend.shift();
      if (it.q === "code") { S.code = it.other; afterCode(); return; }
      if (it.q === "B1") {                       /* first screen: typed symptom */
        S.answers.B1 = it.idk ? { idk: true } : it.v ? { v: it.v } : { other: it.other };
        S.stage = symStage(); save(); post(); return;
      }
      if (it.q.charAt(0) === "@") {            /* fix 3: plug shape / pin count kept until the part's plug question is on the list */
        S.carry[it.q] = it.v != null ? { v: it.v, en: OPT["@conn"][it.v] || it.v } : { v: it.other, en: it.other };
        if (S.pend.length) { save(); render(); return; }
        if (!S.answers.B1 || S.stage !== "flow") { if (!S.answers.B1) S.stage = "start"; save(); post(); return; }
        advance(); return;
      }
      S.answers[it.q] = it.idk ? { idk: true } : it.v != null ? { v: it.v } : { other: it.other };
      S.skipped = S.skipped.filter(function (x) { return x !== it.q; });
      if (S.pend.length || !S.answers.B1 || S.stage !== "flow") { if (!S.answers.B1) S.stage = "start"; save(); post(); return; }   /* before the questions: stay on code / checks */
      advance();
    }));
    g.appendChild(btn(U("no"), "rrc__btn rrc__btn--ghost", "data-rrc-no", function () { S.pend = []; render(); }));
    box.appendChild(g);
  }
  /* S7: summary */
  function renderSummary() {
    var r = S.resp, box = screenEl("S7");
    if (S.resetAsk) {                         /* r4 fix 3: the problem answer decides every other question -> ask before the reset */
      bot(box, U("reset_q"));
      var g0 = el("div", "rrc__actions");
      g0.setAttribute("data-rrc-resetask", "");      /* on the buttons, not the screen box: the box is reused by the next screen */
      g0.appendChild(btn(U("reset_yes"), "rrc__btn", "data-rrc-resetyes", function () { S.resetAsk = false; restart(); }));
      g0.appendChild(btn(U("cancel"), "rrc__btn rrc__btn--ghost", "data-rrc-resetno", function () { S.resetAsk = false; render(); }));
      box.appendChild(g0);
      return;
    }
    bot(box, U("sum_q"));
    hint(box, U("sum_hint"));
    var ul = el("ul", "rrc__chips rrc__chips--sum");
    r.questions.forEach(function (q) {
      if (q.state === "pending") return;
      var li = el("li");
      var miss = q.required && q.state !== "answered";
      var b = el("button", "rrc__chip" + (miss ? " rrc__chip--miss" : ""));
      b.type = "button";
      b.setAttribute("data-rrc-sumchip", q.id);
      b.setAttribute("data-rrc-state", q.state);
      b.appendChild(el("span", null, (q.state === "answered" ? "✔ " : miss && q.state === "idk" ? "? " : miss ? "✖ " : "– ") + chipText(q.id), "data"));
      b.addEventListener("click", function () {
        S.view = null;
        if (q.id === "B1") { S.resetAsk = true; render(); return; }     /* r4 fix 3: was "back to the first screen" at once */
        S.cur = q.id; S.edit = true; S.ret = "sum";                    /* r4 fix 3: only this question; a new answer comes back here */
        save(); render();
      });
      li.appendChild(b); ul.appendChild(li);
    });
    box.appendChild(ul);
    var open = gateOpen(r), unsure = !open && idkOnly(r);
    var miss = r.questions.filter(function (q) { return q.required && q.state !== "answered"; }).length;
    /* chat-10 (retest item 2): only "Not sure" answers keep the gate closed -> say that parts may fit and a person checks the photos */
    var st = el("p", "rrc__status" + (open ? " rrc__status--ok" : ""), open ? U("all_set") : unsure ? UN(r.count, "idk_st_one", "idk_st_many") :
      UN(miss || 1, "need_one", "need_many"), "label");
    st.setAttribute("data-rrc-gate", open ? "open" : unsure ? "unsure" : "closed");
    box.appendChild(st);
    var g = el("div", "rrc__actions");
    if (open) g.appendChild(btn(U("see_parts"), "rrc__btn", "data-rrc-seeparts", function () { S.view = "results"; save(); render(); }));
    else if (unsure) {
      g.appendChild(btn(U("check_fit"), "rrc__btn", "data-rrc-gethelp", function () { S.view = "handoff"; S.mode = "help"; save(); render(); }));
      if (idkReq(r).some(function (q) { return q.id === "D3"; })) g.appendChild(btn(U("find_proto"), "rrc__btn rrc__btn--ghost", "data-rrc-findproto", function () {
        S.view = null; S.cur = "D3"; S.edit = true; S.ret = "sum"; save(); render();
      }));
    }
    else g.appendChild(btn(U("get_help"), "rrc__btn", "data-rrc-gethelp", function () { S.view = "handoff"; S.mode = "help"; save(); render(); }));
    g.appendChild(btn(U("start_again"), "rrc__link", "data-rrc-again", restart));
    box.appendChild(g);
  }
  /* S8a: result */
  function money(v) { return "$" + Number(v).toFixed(2); }
  var IMG = {};                             /* variant id -> {u: photo URL, c: crop box or null}, or null when there is no usable photo (fix 6; r4 fix 1) */
  /* r4 fix 1: 27 of the 108 parts have the part small in a big grey photo (part box 10-20 % of the photo), so the card looked like an
     empty grey frame. trim() reads the photo on a small canvas (cdn.shopify.com sends Access-Control-Allow-Origin: *), finds the box that
     is not the background colour and returns it with a margin, kept between 1:1 and 1.8:1 so the card height stays as before.
     null = no crop (pixels not readable, or the part already fills the photo); {empty: true} = nothing but background. */
  function trim(im) {
    var n = 96, d;
    try {
      var cv = document.createElement("canvas"); cv.width = n; cv.height = n;
      var cx = cv.getContext("2d"); cx.drawImage(im, 0, 0, n, n); d = cx.getImageData(0, 0, n, n).data;
    } catch (e) { return null; }
    var at = function (x, y) { var i = (y * n + x) * 4; return [d[i], d[i + 1], d[i + 2], d[i + 3]]; };
    var cs = [at(1, 1), at(n - 2, 1), at(1, n - 2), at(n - 2, n - 2)];
    var clear = cs.filter(function (c) { return c[3] < 20; }).length >= 2;
    var bg = [0, 1, 2].map(function (k) { var v = cs.map(function (c) { return c[k]; }).sort(function (a, b) { return a - b; }); return Math.round((v[1] + v[2]) / 2); });
    var x0 = n, y0 = n, x1 = -1, y1 = -1, cnt = 0;
    for (var y = 0; y < n; y++) for (var x = 0; x < n; x++) {
      var p = at(x, y);
      if (p[3] < 20) continue;
      if (!clear && Math.abs(p[0] - bg[0]) + Math.abs(p[1] - bg[1]) + Math.abs(p[2] - bg[2]) <= 28) continue;
      cnt++; if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
    }
    if (cnt < n * n * 0.004) return { empty: true };
    var nw = im.naturalWidth || 1, nh = im.naturalHeight || 1;
    var b = { x0: x0 / n, y0: y0 / n, x1: (x1 + 1) / n, y1: (y1 + 1) / n };
    var area = (b.x1 - b.x0) * (b.y1 - b.y0);
    var m = 0.1 * Math.max(b.x1 - b.x0, b.y1 - b.y0);
    b.x0 -= m; b.x1 += m; b.y0 -= m * nw / nh; b.y1 += m * nw / nh;
    var grow = function (lo, hi, want) { var c = (lo + hi) / 2; return [c - want / 2, c + want / 2]; };
    var asp = (b.x1 - b.x0) * nw / ((b.y1 - b.y0) * nh), g;
    if (asp > 1.8) { g = grow(b.y0, b.y1, (b.x1 - b.x0) * nw / (1.8 * nh)); b.y0 = g[0]; b.y1 = g[1]; }
    if (asp < 1) { g = grow(b.x0, b.x1, (b.y1 - b.y0) * nh / nw); b.x0 = g[0]; b.x1 = g[1]; }
    var fit = function (lo, hi) { var w = Math.min(1, hi - lo); lo = Math.max(0, Math.min(lo, 1 - w)); return [lo, lo + w]; };
    g = fit(b.x0, b.x1); b.x0 = g[0]; b.x1 = g[1];
    g = fit(b.y0, b.y1); b.y0 = g[0]; b.y1 = g[1];
    var cw = b.x1 - b.x0, ch = b.y1 - b.y0;
    if (cw > 0.88 && ch > 0.88) return null;                        /* the part already fills the photo */
    return { x0: b.x0, y0: b.y0, w: cw, h: ch, ar: cw * nw / (ch * nh), fill: area / (cw * ch), bg: clear ? null : bg };
  }
  /* r5 fix 4: the card used to ask for the photo address (2 requests) and the picture only when the results screen was drawn, so our drawing
     showed first and the photo came a moment later. Now the address and the picture are asked for as soon as the engine answer has few parts
     left (warmPhotos, called from post); the card then finds them ready, and a photo that is still late fades in over our drawing. */
  var IMGU = {};                            /* variant id -> promise of the photo address (null = the product has no photo); a failed ask is forgotten */
  var IMGV = {};                            /* variant id -> the photo address once it is known (null = no photo), so a card can use it at once */
  var PRE = {};                             /* photo address -> Image already loaded with CORS, handed to the first card that wants it */
  function photoUrl(vid) {
    if (IMGU[vid]) return IMGU[vid];
    var ac = window.AbortController ? new AbortController() : null;
    var tm = setTimeout(function () { if (ac) ac.abort(); }, 10000);
    var opt = function (o) { if (ac) o.signal = ac.signal; return o; };
    var pr = fetch(ROOT + "/variants/" + encodeURIComponent(vid), opt({ method: "HEAD", credentials: "same-origin" }))      /* -> /products/<handle>?variant= */
      .then(function (r) { var m = /\/products\/([^/?#]+)/.exec(r.url || ""); if (!m) throw new Error("handle"); return fetch(ROOT + "/products/" + m[1] + ".js", opt({})); })
      .then(function (r) { if (!r.ok) throw new Error("product"); return r.json(); })
      .then(function (j) {
        clearTimeout(tm);
        var u = j && (j.featured_image || (j.images || [])[0]);
        u = u ? (/^\/\//.test(u) ? "https:" + u : u) : null;
        u = u ? u + (u.indexOf("?") < 0 ? "?" : "&") + "width=480" : null;
        IMGV[vid] = u;
        return u;
      });
    pr.catch(function () { clearTimeout(tm); if (IMGU[vid] === pr) delete IMGU[vid]; });      /* not cached: the next ask tries again */
    IMGU[vid] = pr;
    return pr;
  }
  function warmPhotos(r) {                  /* called with every engine answer: the first 3 parts, once few parts are left */
    var rs = r && r.results;
    if (!rs || !rs.length || rs.length > 6) return;
    rs.slice(0, 3).forEach(function (p) {
      if (IMG[p.variant_id] === null) return;
      photoUrl(p.variant_id).then(function (u) {
        if (!u || PRE[u]) return;
        var im = new Image();
        im.crossOrigin = "anonymous"; im.decoding = "async";
        im.onerror = function () { delete PRE[u]; };
        PRE[u] = im; im.src = u;
      }).catch(function () { /* the card asks again when it is drawn */ });
    });
  }
  function photo(vid, holder, cat) {        /* our drawing first; the product photo (cropped to the part) when it loads; our drawing again if it fails */
    var sync = true;                        /* true while this call is still running = the photo was ready, no fade */
    var icon = function (st) {
      holder.innerHTML = partIcon(cat || "cable");
      holder.classList.add("rrc__pic--icon"); holder.classList.remove("rrc__pic--photo", "rrc__pic--wait");
      holder.setAttribute("data-rrc-photo", st);
    };
    var show = function (im, c) {
      holder.classList.remove("rrc__pic--wait", "rrc__pic--icon");
      holder.textContent = ""; holder.classList.add("rrc__pic--photo");
      if (!sync) holder.classList.add("rrc__pic--fade");
      im.className = "rrc__pimg"; im.alt = ""; im.setAttribute("data-rrc-img", "");
      if (c && !c.empty && window.CSS && CSS.supports && CSS.supports("aspect-ratio", "1")) {   /* old browsers: the whole photo */
        var w = el("span", "rrc__crop");
        w.style.aspectRatio = c.ar.toFixed(4);
        if (c.bg) w.style.backgroundColor = "rgb(" + c.bg.join(",") + ")";
        im.style.width = (100 / c.w).toFixed(3) + "%"; im.style.height = (100 / c.h).toFixed(3) + "%";
        im.style.left = (-100 * c.x0 / c.w).toFixed(3) + "%"; im.style.top = (-100 * c.y0 / c.h).toFixed(3) + "%";
        w.appendChild(im); holder.appendChild(w);
        holder.setAttribute("data-rrc-photo", "crop");
        holder.setAttribute("data-rrc-fill", c.fill.toFixed(2));
      } else {
        holder.appendChild(im);
        holder.setAttribute("data-rrc-photo", "photo");
      }
    };
    var done = function (im, u, cors) {
      var c = cors ? trim(im) : null;
      if (c && c.empty) { IMG[vid] = null; icon("none"); return; }
      IMG[vid] = { u: u, c: c };
      show(im, c);
    };
    var load = function (u, cors) {
      var pre = cors ? PRE[u] : null;
      if (pre && pre.complete && pre.naturalWidth) { delete PRE[u]; done(pre, u, cors); return; }      /* loaded ahead of time */
      var im = new Image();
      if (cors) im.crossOrigin = "anonymous";
      im.decoding = "async";
      im.onload = function () {
        if (!im.naturalWidth) { im.onerror(); return; }
        done(im, u, cors);
      };
      im.onerror = function () { im.onload = im.onerror = null; if (cors) load(u, false); else { IMG[vid] = null; icon("fail"); } };
      im.src = u;
    };
    holder.innerHTML = partIcon(cat || "cable");            /* while it loads: our drawing (faded), not an empty grey frame */
    holder.setAttribute("data-rrc-photo", "wait");
    if (IMG[vid] === null) { icon("none"); return; }
    var known = IMG[vid] ? IMG[vid].u : IMGV[vid];
    if (known) { load(known, true); sync = false; return; }
    if (known === null) { IMG[vid] = null; icon("none"); return; }
    photoUrl(vid).then(function (u) {
      if (!u) { IMG[vid] = null; icon("none"); return; }
      load(u, true);
    }).catch(function () { icon("fail"); });
    sync = false;
  }
  root.rrcPhoto = photo;                    /* r4: the image check (tools/img_check_r4.py) runs this same code for every part of the data pack */
  /* r4 fix 4: the engine passes a controller when volts x max amps <= 1.5 x motor power (rrdiag2.py) and max amps <= battery amps.
     The title says the controller's own rating (e.g. "48V 14A 350W"). When that rating is under the customer's motor power, the card
     says what it means: the controller limits the current, so the motor runs, with less top power. chat-11: "Rated 350 W (672 W peak). Your 500 W motor
     runs fine, with a little less top power." (the rating and the peak first, then what it means for the customer's motor). */
  function pwNote(p) {
    var m = /(\d+(?:\.\d+)?)\s*V\s+(\d+(?:\.\d+)?)\s*A\s+(\d+)\s*W\b/i.exec(p.name || ""), a = S.answers.M8;
    var mw = a ? num(a.v != null ? a.v : a.other) : null;
    if (!m || !mw || Number(m[3]) >= mw) return null;
    var v = S.answers.B3 && S.answers.B3.v != null ? num(S.answers.B3.v) : null;
    v = v || Number(m[1]);
    return U("pw_note", { pw: m[3], mw: mw, peak: Math.round(v * Number(m[2])), v: v, a: m[2] });
  }
  /* r5 fix 3: the engine writes "672 W peak (48 V x 14 A), limit 750 W" (also translated). On the card: "×", and "max allowed 750 W", so
     "limit 750 W" is not read as the power of the customer's motor. Display only; the engine text is not changed. */
  function whyPart(w) {
    var t = String(w.part);
    if (w.q !== "M8") return t;
    t = t.replace(/(\d\s*V)\s*[xX×]\s*(\d)/g, "$1\u00a0×\u00a0$2");      /* no line break between "V ×" and "14 A" on a 360 px phone */
    return t.replace(/([,，]\s*)(?:limit|límite|limite|上限)\s*(\d+(?:\.\d+)?)\s*W\b/i, function (m, sep, n) { return sep + U("max_allowed", { n: n }); });
  }
  function tireNote() {                     /* fix 7: tire width is OPTIONAL for motors (must_optional.json): a note, never a filter */
    var a = S.answers.B5;
    if (!S.resp || S.resp.part !== "motor" || !a || a.idk) return null;
    return U("tire_note", { w: chipText("B5").split(": ").slice(1).join(": ") });
  }
  function partCard(p, top) {
    var c = el("article", "rrc__part" + (top ? " rrc__part--top" : ""));
    c.setAttribute("data-rrc-part", p.variant_id);
    var ph = el("span", "rrc__pic rrc__pic--part rrc__pic--wait" + (top ? "" : " rrc__pic--thumb"));
    c.appendChild(ph);
    photo(p.variant_id, ph, S.resp.part);
    var head = el("div", "rrc__phead");
    head.appendChild(el("h3", null, p.name, "data"));
    head.appendChild(el("p", "rrc__price", money(p.price), "data"));
    c.appendChild(head);
    if (p.tell) {                             /* chat-13: cards with the same name say how they differ (engine results[].tell, maker specs only) */
      var tl = el("p", "rrc__tell", p.tell, "data");
      tl.setAttribute("data-rrc-tell", "");
      c.appendChild(tl);
    }
    if (top) c.appendChild(el("p", "rrc__badge", "✔ " + U("fits_badge"), "label"));
    var rows = whyRows(p.why || []), okN = rows.filter(function (w) { return w.ok; }).length, motor = S.resp.part === "motor";
    var d = el("details", "rrc__why");
    d.open = !!top;                           /* r2 fix 6: the first card shows every check row at once; the others say "N of N checks pass" */
    var sm = el("summary", null, null);
    sm.appendChild(el("span", null, U("why"), "btn"));
    var cnt = el("span", "rrc__whycount", "✓ " + U("checks_ok", { n: okN, m: rows.length }), "label");
    cnt.setAttribute("data-rrc-checks", okN + "/" + rows.length);
    sm.appendChild(cnt);
    d.appendChild(sm);
    var ul = el("ul", "rrc__whylist"), more = [];
    rows.forEach(function (w) {
      var li = el("li");
      li.setAttribute("data-ok", w.ok ? "1" : "0");
      if (w.q) li.setAttribute("data-rrc-why", w.q);
      li.appendChild(el("span", "rrc__tick", w.ok ? "✓" : "?"));
      li.appendChild(el("span", null, w.param + ": " + w.yours + " · " + whyPart(w), "data"));
      var pn = w.q === "M8" && !motor ? pwNote(p) : null;
      if (pn) {                               /* r4 fix 4: the title is the controller's rated power; say why a lower rating still fits */
        var pe = el("span", "rrc__whynote", pn, "data");
        pe.setAttribute("data-rrc-pwnote", "");
        li.appendChild(pe);
      }
      if (w.q === "M3" && /\b138\b/.test(w.part) && /\b135\b/.test(w.yours)) {      /* r2 fix 3: why a 138 mm motor fits a 135 mm frame */
        var on = el("span", "rrc__whynote", U("old_note"), "data");
        on.setAttribute("data-rrc-oldnote", "");
        li.appendChild(on);
      }
      ul.appendChild(li);
    });
    if (motor) {                              /* r2 fix 2: axle = recorded question (catalog has no axle data): a photo check row, not a ✓ */
      var ax = S.answers.M4, li2 = el("li", "rrc__whychk");
      li2.setAttribute("data-ok", "check");
      li2.setAttribute("data-rrc-why", "M4");
      li2.appendChild(pic(PIC.photo(), "rrc__tick rrc__tick--photo"));
      li2.appendChild(el("span", null, L(QC.M4[2]) + ": " + (ax ? (ax.idk ? U("unsure_chip") : ax.other != null ? ax.other : L(optLabel("M4", ax.v) || ax.v)) : U("skipped")) +
        " · " + U("axle_check"), "data"));
      ul.appendChild(li2);
    }
    d.appendChild(ul);
    c.appendChild(d);
    var lines = [], tn = tireNote();          /* fix 6: at most 2 notes on the card; the rest behind "Show all" */
    if (tn) lines.push({ t: tn, opt: "B5" });
    (p.hints || []).concat(p.notes || []).forEach(function (x) { lines.push({ t: x }); });
    lines.forEach(function (x, i) {
      var n = el("p", "rrc__small", x.t, x.opt ? "label" : "data");
      n.setAttribute("data-rrc-noteline", "");
      if (x.opt) n.setAttribute("data-rrc-optnote", x.opt);
      if (i >= 2) { n.hidden = true; more.push(n); }
      c.appendChild(n);
    });
    if (more.length) {                        /* notes only (r2: check rows are never hidden) */
      var mb = btn(U("show_all"), "rrc__link rrc__whymore", "data-rrc-whymore", function () {
        more.forEach(function (x) { x.hidden = false; });
        mb.parentNode.removeChild(mb);
      });
      c.appendChild(mb);
    }
    if (!motor && p.check_before_ship && p.check_before_ship.length) {   /* fix 6: one line; motors: the axle row above says it (r2) */
      var sc = el("p", "rrc__small rrc__ship", U("check_ship") + ": " + p.check_before_ship.join(", ") + ".", "data");
      sc.setAttribute("data-rrc-shipcheck", "");
      c.appendChild(sc);
    }
    var act = el("div", "rrc__actions");
    if (p.can_add_to_cart) {
      var add = btn(U("add_cart"), "rrc__btn", "data-rrc-add");
      add.setAttribute("data-rrc-add", p.variant_id);
      add.addEventListener("click", function () { addToCart(p, add); });
      act.appendChild(add);
    } else {
      var ask = btn(U("check_fit"), "rrc__btn", "data-rrc-ask");
      ask.setAttribute("data-rrc-ask", p.variant_id);
      ask.addEventListener("click", function () { S.view = "handoff"; S.mode = "fit"; S.part = p.name; save(); render(); });
      act.appendChild(ask);
      act.appendChild(viewLink(p));
      var fl = el("p", "rrc__small rrc__fitline", U("fit_line"), "label");      /* r2 fix 7: what the button does */
      fl.setAttribute("data-rrc-fitline", "");
      act.appendChild(fl);
    }
    if (p.can_add_to_cart) act.appendChild(viewLink(p));
    c.appendChild(act);
    return c;
  }
  /* chat-10 (retest item 5): the product page in a new tab (the answers stay here). /variants/<id> redirects to the product page, so this
     page holds no product handle (handles can name a supplier brand; public pages name none). */
  function viewLink(p) {
    var a = el("a", "rrc__link rrc__view", U("view_part"), "btn");
    a.href = ROOT + "/variants/" + encodeURIComponent(p.variant_id);
    a.target = "_blank"; a.rel = "noopener";
    a.setAttribute("data-rrc-view", p.variant_id);
    return a;
  }
  /* r2 fix 6: the pin count row and the shape row of one plug name the same part text -> one row "Motor plug: 9 pins, kit-brand round" */
  var PLUG_PAIR = { M6a: "M6b", M6b: "M6a", D4: "D5", D5: "D4", W3a: "W3b", W3b: "W3a", T4a: "T4", T4: "T4a" };
  var PIN_Q = { M6a: 1, D4: 1, W3b: 1, T4: 1 };
  function whyRows(why) {
    var by = {}, used = {}, out = [];
    why.forEach(function (w) { if (w.q) by[w.q] = w; });
    why.forEach(function (w) {
      if (w.q && used[w.q]) return;
      var m = w.q && PLUG_PAIR[w.q] && by[PLUG_PAIR[w.q]];
      if (m && m.part === w.part) {
        used[m.q] = 1;
        var pin = PIN_Q[w.q] ? w : m, shape = pin === w ? m : w;
        out.push({ q: shape.q, param: shape.param, yours: pin.yours + ", " + shape.yours, part: w.part, ok: w.ok && m.ok });
      } else out.push(w);
    });
    return out;
  }
  /* chat-7 (F1024-1831yl): the delivery time, told once, on the final result screen. The engine sends numbers only (resp.eta, calendar days);
     the slowest part sets the overall time; every part gets its own rough time. No question, card, product page or list shows days.
     chat-13 (F1030-1152lf): eta.need "one" = the cards are choices and the customer buys one, so the top line gives the fastest card (eta.fastest),
     or the one shared time when every card has the same time (then the list adds nothing and is left out); a name shows once per time row. */
  function dayText(lo, hi) { return lo === hi ? U("eta_t_one", { n: hi }) : U("eta_t_range", { a: lo, b: hi }); }
  function etaBlock(r) {
    var e = r.eta;
    if (!e || !e.overall || !e.items || !e.items.length) return null;
    var o = e.overall, many = e.items.length > 1, box = el("section", "rrc__eta");
    var one = many && e.need === "one" && e.fastest && e.fastest.min_days != null;
    box.setAttribute("data-rrc-eta", "");
    box.appendChild(el("h3", "rrc__eta-title", U("eta_title"), "title"));
    var by = {}, keys = [];
    e.items.forEach(function (it) {
      var p = null;
      r.results.forEach(function (x) { if (x.variant_id === it.variant_id) p = x; });
      if (!p) return;
      var k = it.min_days == null ? "u" : it.min_days + "-" + it.max_days;
      if (!by[k]) { by[k] = { lo: it.min_days, hi: it.max_days, names: [] }; keys.push(k); }
      if (by[k].names.indexOf(p.name) < 0) by[k].names.push(p.name);
    });
    var line, shown = o, same = keys.length === 1 && !o.unknown;
    if (!o.known) line = U("eta_none");
    else if (one) {
      shown = e.fastest;
      line = U((same ? "eta_c_same_" : "eta_c_") + (shown.min_days === shown.max_days ? "one" : "range"),
               { n: shown.max_days, a: shown.min_days, b: shown.max_days });
    }
    else if (o.unknown) line = U(o.unknown === 1 ? "eta_least_one" : "eta_least_many", { n: o.max_days, u: o.unknown });
    else if (o.min_days === o.max_days) line = U(many ? "eta_a_one" : "eta_p_one", { n: o.max_days });
    else line = U(many ? "eta_a_range" : "eta_p_range", { a: o.min_days, b: o.max_days });
    var all = el("p", "rrc__eta-all", line, "label");
    all.setAttribute("data-rrc-eta-overall", o.known ? shown.min_days + "-" + shown.max_days : "unknown");
    if (one) all.setAttribute("data-rrc-eta-need", "one");
    box.appendChild(all);
    if (one && same) return box;
    keys.sort(function (x, y) { return x === "u" ? 1 : y === "u" ? -1 : by[x].hi - by[y].hi || by[x].lo - by[y].lo; });
    var ul = el("ul", "rrc__eta-list");
    keys.forEach(function (k) {
      var g = by[k], li = el("li", "rrc__eta-row");
      li.setAttribute("data-rrc-eta-group", k === "u" ? "unknown" : k);
      li.appendChild(el("span", "rrc__eta-t", k === "u" ? U("eta_t_unk") : dayText(g.lo, g.hi), "label"));
      var shown = g.names.slice(0, 3), rest = g.names.length - shown.length;
      li.appendChild(el("span", "rrc__eta-n", shown.join(" · "), "data"));   /* names can hold commas: separate them with a dot */
      if (rest > 0) li.appendChild(el("span", "rrc__eta-m", U("eta_more", { n: rest }), "label"));
      ul.appendChild(li);
    });
    box.appendChild(ul);
    return box;
  }
  function renderResults() {
    var r = S.resp, box = screenEl("S8a");
    box.appendChild(el("h2", "rrc__title", r.results.length === 1 ? U("res_one") : U("res_many"), "title"));
    box.appendChild(partCard(r.results[0], true));
    var eb = etaBlock(r);
    if (eb) box.appendChild(eb);
    box.appendChild(el("p", "rrc__sell", U("sell"), "sell"));
    /* r3 fix 1: the engine tip asks for optional answers; show it only while an optional question is still open (none at the results) */
    if (r.tip && qsList().some(function (q) { return q.optional && q.state === "pending"; })) hint(box, r.tip);
    if (r.results.length > 1) {
      var d = el("details", "rrc__more");
      d.open = r.results.length <= 3;
      var sm = el("summary", null, null);
      sm.appendChild(el("span", null, U("more_parts") + " (" + (r.results.length - 1) + ")", "label"));
      d.appendChild(sm);
      r.results.slice(1).forEach(function (p) { d.appendChild(partCard(p, false)); });
      box.appendChild(d);
    }
    var g = el("div", "rrc__actions");
    g.appendChild(btn(U("change"), "rrc__btn rrc__btn--ghost", "data-rrc-change", function () { S.view = null; save(); render(); }));
    g.appendChild(btn(U("start_again"), "rrc__link", "data-rrc-again", restart));
    box.appendChild(g);
  }
  function addToCart(p, b) {
    b.disabled = true;
    fetch("/cart/add.js", { method: "POST", headers: { "content-type": "application/json", accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(p.variant_id), quantity: 1, properties: { _source: "diag-chat" } }] }) })
      .then(function (r) { if (!r.ok) throw new Error("cart"); return r.json(); })
      .then(function () { b.firstChild.textContent = U("added"); var a = el("a", "rrc__link", U("go_cart"), "btn"); a.href = ROOT + "/cart"; b.parentNode.appendChild(a); })
      .catch(function () { b.disabled = false; b.firstChild.textContent = U("try_again"); });
  }
  /* S8b: hand-off to a person (gate closed, zero parts, a fit check, or #send-photos) */
  var SLOTS = [["slot_bike", "ebike"], ["slot_plug", "plug"], ["slot_display", "display"], ["slot_dropout", "drop"]];
  /* chat-8 (retest item 2): photos that fit the part. Brake lever: the lever, its plug, the controller label (NO / NC), the bar with a ruler;
     mechanical parts: where it sits on the bike, the old part, the size marks on it, the part next to a ruler. */
  var SLOTS_LEVER = [["slot_lever", "lever"], ["slot_lplug", "lplug"], ["slot_ctl", "ctl"], ["slot_bar", "bar"]];
  var SLOTS_MECH = [["slot_onbike", "ebike"], ["slot_old", "old"], ["slot_marks", "marks"], ["slot_ruler", "ruler"]];
  function partNow() { var p = S.answers.P0; return p && p.v ? p.v : null; }
  /* F1103-1916ga item 4: "Get help" (no part yet, or an electric part) asks for the broken part, its plug, the labels and the whole bike */
  var SLOTS_HELP = [["slot_part", "old"], ["slot_plug", "plug"], ["slot_labels", "lbl"], ["slot_bike", "ebike"]];
  function slotsFor(mode) { var p = partNow(); return p === "brake_lever" ? SLOTS_LEVER : MECHP[p] ? SLOTS_MECH : mode === "help" ? SLOTS_HELP : SLOTS; }
  /* F1103-1916ga item 1: the 3 answers "Get help" needs first; "Not sure" counts. Only the ones still open when the screen opens. */
  var REQ3 = ["P0", "B3", "B6"];
  var REQ_PARTS = ["motor", "controller", "display", "throttle", "cable", "brake_lever", "pas_sensor", "charger", "battery"];
  var REQ_VOLTS = ["24", "36", "48", "52", "60", "72"];
  function reqHas(q) { var a = S.answers[q]; return !!(a && (a.idk || a.v != null || (a.other != null && String(a.other).trim()))); }
  function reqDone() { return (S.reqQs || []).every(reqHas); }
  function setReq(q, a) {
    if (a) S.answers[q] = a; else delete S.answers[q];
    S.skipped = S.skipped.filter(function (x) { return x !== q; });
    if (q === "P0") branchGuard();
    save();
  }
  function slotPic(k) {
    if (k === "lever") return partIcon("brake_lever");
    if (k === "lplug") return face("round", 2);
    if (k === "ctl") return label("NC", "ctl");
    if (k === "lbl") return label("48", "ctl");                    /* F1103-1916ga: a battery / controller label, number only */
    if (k === "bar") return bar("");
    if (k === "old") return partIcon(partNow() || "@mech");
    if (k === "marks") return label("27.2", "ctl");
    if (k === "ruler") return tape("");
    return k === "ebike" ? bike("") : k === "plug" ? face("round", 5) : k === "display" ? screen("on") : tape("");
  }
  function renderHandoff(mode) {
    var r = S.resp, box = screenEl("S8b");
    box.setAttribute("data-rrc-mode", mode);
    if (mode === "source") box.setAttribute("data-rrc-zero", "");
    box.appendChild(el("h2", "rrc__title", mode === "source" ? U("source_t") : mode === "fit" ? U("fit_t") : U("help_t"), "title"));
    if (mode === "source" && r && r.stop && r.stop.q) {
      var sv = el("p", "rrc__value", L(QC[r.stop.q] ? QC[r.stop.q][2] : r.stop.q) + ": " + (S.answers[r.stop.q] ? chipText(r.stop.q).split(": ").slice(1).join(": ") : r.stop.answer), "data");
      sv.setAttribute("data-rrc-stop", r.stop.q);
      box.appendChild(sv);
    }
    if (mode === "fit" && S.part) box.appendChild(el("p", "rrc__value", S.part, "data"));
    if (mode === "help" && r && S.answers.B1) {
      var miss = r.questions.filter(function (q) { return q.required && q.state !== "answered"; });
      if (miss.length) {
        var mw = el("p", "rrc__miss");
        mw.appendChild(el("span", null, U(idkOnly(r) ? "we_check" : "still_need") + ": ", "label"));     /* chat-10 */
        mw.appendChild(el("span", null, miss.map(function (q) { return L(QC[q.id] ? QC[q.id][2] : q.id); }).join(", "), "data"));
        mw.setAttribute("data-rrc-missing", miss.map(function (q) { return q.id; }).join(" "));
        box.appendChild(mw);
        if (miss.some(function (q) { return q.id === "D3"; })) protoHelp(box, true);     /* r2 fix 5 */
      }
    }
    if (mode === "help") {                                  /* F1103-1916ga item 1 */
      if (S.reqQs == null) S.reqQs = REQ3.filter(function (q) { return !reqHas(q); });
      if (S.reqQs.length) reqBlock(box, function () { sync(); });
    }
    answersList(box, mode === "source" && r && r.stop ? r.stop.q : null);
    hint(box, S.err === "send" ? U("err_send") : S.err === "photo" ? U("err_photo") : S.err === "email" ? U("err_email") :
      S.err === "req" ? U("err_req") : mode === "source" ? U("source_hint") : U("help_hint"));
    if (mode === "help") photoTips(box);                    /* F1103-1916ga item 4 */
    var form = el("form", "rrc__form");
    form.setAttribute("data-rrc-form", "");
    form.noValidate = true;
    var grid = el("div", "rrc__slots");
    var SL = slotsFor(mode);
    grid.setAttribute("data-rrc-slotset", SL === SLOTS_LEVER ? "lever" : SL === SLOTS_MECH ? "mech" : SL === SLOTS_HELP ? "help" : "bike");
    SL.forEach(function (s, i) {
      var lab = el("label", "rrc__slot");
      lab.setAttribute("data-rrc-slot", String(i));
      lab.appendChild(pic(slotPic(s[1])));
      lab.appendChild(el("span", null, U(s[0]), "label"));
      var fi = el("input", "rrc__file");
      fi.type = "file"; fi.accept = "image/jpeg,image/png,image/webp";
      fi.setAttribute("data-rrc-slotfile", String(i));
      fi.addEventListener("change", function () {
        var f = fi.files && fi.files[0];
        if (!f) return;
        if (!TYPES[f.type] || f.size > MAX_BYTES) { S.err = "photo"; render(); return; }
        S.photos = S.photos.filter(function (p) { return p.slot !== i; });
        S.photos.push({ file: f, slot: i, q: s[1] });
        S.err = null; render();
      });
      lab.appendChild(fi);
      var have = S.photos.filter(function (p) { return p.slot === i; })[0];
      if (have) { lab.classList.add("rrc__slot--on"); var im = el("img", "rrc__thumb"); try { im.src = URL.createObjectURL(have.file); } catch (e) { /* no preview */ } im.alt = ""; lab.appendChild(im); }
      grid.appendChild(lab);
    });
    form.appendChild(grid);
    var extra = S.photos.filter(function (p) { return p.slot == null; });
    if (extra.length) {
      var ex = el("div", "rrc__extra");
      ex.appendChild(el("span", null, U("chat_photos") + ": " + extra.length, "label"));
      ex.setAttribute("data-rrc-chatphotos", String(extra.length));
      form.appendChild(ex);
    }
    var em = el("label", "rrc__field");
    em.appendChild(el("span", null, U("email"), "label"));
    var ei = el("input", "rrc__text");
    ei.type = "email"; ei.required = true; ei.autocomplete = "email"; ei.maxLength = 254;
    ei.setAttribute("data-rrc-f", "email");
    ei.value = S.email || "";
    ei.addEventListener("input", function () { S.email = ei.value; sync(); });
    em.appendChild(ei);
    form.appendChild(em);
    var nt = el("textarea", "rrc__note");
    nt.rows = 2; nt.maxLength = 2000; nt.placeholder = U("note_ph");
    nt.setAttribute("aria-label", U("note_ph"));
    nt.setAttribute("data-rrc-f", "message");
    nt.value = S.message || "";
    nt.addEventListener("input", function () { S.message = nt.value; });
    form.appendChild(nt);
    var hp = el("input", "rrc__hp");
    hp.type = "text"; hp.tabIndex = -1; hp.autocomplete = "off";
    hp.setAttribute("aria-hidden", "true");
    hp.setAttribute("data-rrc-f", "company");
    form.appendChild(hp);
    var cl = el("label", "rrc__consent");
    var cb = el("input");
    cb.type = "checkbox"; cb.required = true;
    cb.setAttribute("data-rrc-f", "consent");
    cb.checked = !!S.consent;
    cb.addEventListener("change", function () { S.consent = cb.checked; sync(); });
    cl.appendChild(cb);
    cl.appendChild(el("span", null, U("consent"), "consent"));
    form.appendChild(cl);
    var g = el("div", "rrc__actions");
    var sb = el("button", "rrc__btn");
    sb.type = "submit";
    sb.setAttribute("data-rrc-submit", "");
    sb.appendChild(el("span", null, U("send_req"), "btn"));
    g.appendChild(sb);
    var full = el("a", "rrc__link", U("full_form"), "btn");
    full.href = ROOT + "/pages/diagnosis-request";
    full.setAttribute("data-rrc-fullform", "");
    g.appendChild(full);
    if (mode === "help") full.hidden = !reqDone();          /* F1103-1916ga item 1: no way round the 3 answers */
    g.appendChild(btn(U("back"), "rrc__link", "data-rrc-back", function () {
      S.err = null;
      if (mode === "fit") S.view = "results";
      else if (mode === "source" && S.resp && S.resp.stop && S.resp.stop.q) { S.view = null; S.cur = S.resp.stop.q; S.edit = true; }
      else { S.view = null; if (!S.answers.B1) S.stage = "start"; }
      S.reqQs = null;
      save(); render();
    }));
    form.appendChild(g);
    function sync() {
      sb.disabled = S.sending || !(ei.value.trim() && ei.checkValidity() && cb.checked) || (mode === "help" && !reqDone());
      if (mode === "help") full.hidden = !reqDone();
    }
    sync();
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (sb.disabled) { S.err = mode === "help" && !reqDone() ? "req" : "email"; render(); return; }
      submit(mode, ei.value.trim());
    });
    box.appendChild(form);
  }
  /* F1103-1916ga item 1: part, battery voltage and bike, each with "Not sure"; selects re-render (photo slots follow the part),
     typing the bike only re-checks the send button */
  function reqBlock(box, onChange) {
    var w = el("div", "rrc__req");
    w.setAttribute("data-rrc-req", S.reqQs.join(" "));
    w.appendChild(el("p", "rrc__req-t", U("rq_t"), "label"));
    w.appendChild(el("p", "rrc__req-h", U("rq_hint"), "label"));
    var sel = function (q, opts) {
      var lab = el("label", "rrc__field");
      lab.appendChild(el("span", null, L(QC[q][2]), "label"));
      var se = el("select", "rrc__select");
      se.setAttribute("data-rrc-req-q", q);
      se.appendChild(new Option(U("rq_pick"), ""));
      opts.forEach(function (o) { se.appendChild(new Option(o[1], o[0])); });
      se.appendChild(new Option(U("not_sure"), "idk"));
      var a = S.answers[q];
      se.value = a ? (a.idk ? "idk" : String(a.v != null ? a.v : a.other)) : "";
      se.addEventListener("change", function () {
        var v = se.value;
        setReq(q, !v ? null : v === "idk" ? { idk: true } : q === "B3" && ["36", "48", "52"].indexOf(v) < 0 ? { other: v } : { v: v });
        S.err = null; render();
      });
      lab.appendChild(se);
      w.appendChild(lab);
    };
    if (S.reqQs.indexOf("P0") >= 0) sel("P0", REQ_PARTS.map(function (v) { return [v, L(OPT.P0[v])]; }));
    if (S.reqQs.indexOf("B3") >= 0) sel("B3", REQ_VOLTS.map(function (v) { return [v, L(OPT.B3[v])]; }));
    if (S.reqQs.indexOf("B6") >= 0) {
      var lab = el("label", "rrc__field");
      lab.appendChild(el("span", null, L(QC.B6[2]), "label"));
      var ti = el("input", "rrc__text");
      ti.type = "text"; ti.maxLength = 80; ti.placeholder = U("rq_bike_ph");
      ti.setAttribute("data-rrc-req-q", "B6");
      var a6 = S.answers.B6;
      ti.value = a6 && a6.other != null ? a6.other : "";
      ti.disabled = !!(a6 && a6.idk);
      ti.addEventListener("input", function () { var t = ti.value.trim(); setReq("B6", t ? { other: t } : null); onChange(); });
      lab.appendChild(ti);
      w.appendChild(lab);
      var nl = el("label", "rrc__consent");
      var nc = el("input");
      nc.type = "checkbox"; nc.checked = !!(a6 && a6.idk);
      nc.setAttribute("data-rrc-req-idk", "B6");
      nc.addEventListener("change", function () { setReq("B6", nc.checked ? { idk: true } : null); S.err = null; render(); });
      nl.appendChild(nc);
      nl.appendChild(el("span", null, U("not_sure"), "label"));
      w.appendChild(nl);
    }
    box.appendChild(w);
  }
  function photoTips(box) {
    var w = el("div", "rrc__tips");
    w.setAttribute("data-rrc-phototips", "");
    w.appendChild(el("p", "rrc__tips-t", U("ph_tips_t"), "label"));
    var ul = el("ul", "rrc__tips-l");
    ["ph_tip1", "ph_tip2", "ph_tip3", "ph_tip4"].forEach(function (k) { ul.appendChild(el("li", null, U(k), "label")); });
    w.appendChild(ul);
    box.appendChild(w);
  }
  /* r2 fix 4 (AT16): every answer goes with the request (body().answers); here the customer sees them all in a fold-out list,
     the answer that stopped the search first and marked. Tap "Back" to change one. */
  function answersList(box, stopQ) {
    var items = qsList().filter(function (q) { return q.state !== "pending" && !(q.state === "skipped" && !S.answers[q.id]); })
      .sort(function (x, y) { return (y.id === stopQ) - (x.id === stopQ); });
    if (!items.length && S.code == null) return;
    var d = el("details", "rrc__answers");
    d.open = true;                            /* r4 fix 2: every answer shows at once (round 1 behaviour); the arrow folds the list */
    d.setAttribute("data-rrc-answers", String(items.length + (S.code != null ? 1 : 0)));
    var sm = el("summary", null, null);
    sm.appendChild(el("span", null, U("ans_n", { n: items.length + (S.code != null ? 1 : 0) }), "label"));
    d.appendChild(sm);
    var ul = el("ul", "rrc__chips rrc__chips--sum");
    var codeLi = function () {
      var cl = el("li", "rrc__chip rrc__chip--static", L(UI.code_chip[0]) + ": " + (S.code || U("no_code")), "data");
      cl.setAttribute("data-rrc-ans", "code");
      ul.appendChild(cl);
    };
    if (S.code != null && !(items.length && items[0].id === stopQ)) codeLi();
    items.forEach(function (q, i) {
      var stop = q.id === stopQ;
      var li = el("li", "rrc__chip rrc__chip--static" + (stop ? " rrc__chip--stop" : ""), (stop ? "▶ " : "") + chipText(q.id), "data");
      li.setAttribute("data-rrc-ans", q.id);
      ul.appendChild(li);
      if (i === 0 && stop && S.code != null) codeLi();       /* the stopping answer first, then the error code, then the rest */
    });
    d.appendChild(ul);
    box.appendChild(d);
  }
  function submit(mode, email) {
    S.sending = true; S.err = null;
    var hintEl = $(".rrc__hint");
    if (hintEl) hintEl.textContent = U("sending");
    var sbtn = $("[data-rrc-submit]"); if (sbtn) sbtn.disabled = true;
    var files = S.photos.map(function (p) { return p.file; }).slice(0, 6);
    var b = body(true);
    var msg = [S.message || "", S.code ? "Error code: " + S.code : "", mode === "fit" && S.part ? "Fit check: " + S.part : "",
               "From: chat diagnosis (" + mode + ")"].filter(Boolean).join("\n");
    var send = function (urls) {
      var req = { answers: b.answers, skipped: S.skipped, cur: (S.resp && (S.resp.next || (S.resp.stop && S.resp.stop.q))) || null, email: email,
                  consent: true, message: msg.slice(0, 2000), photos: urls, company: ($('[data-rrc-f="company"]') || {}).value || "", locale: LANG || "en" };
      return fetch(API + "/diag2/request", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(req) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (x) {
          if (!x.ok || !x.j || !x.j.ok) throw new Error("send");
          root.setAttribute("data-rrc-sent", x.j.ref);
          var box = $("[data-rrc-screen]");
          var t = box.querySelector(".rrc__title"); if (t) t.textContent = U("sent", { ref: x.j.ref });
          /* F1104-1232hv (newcomer walk R15): no hidden store contact form any more - it never got through (the store contact form needs a
             CAPTCHA token, F1103-2002mh); the feed puts the store notice in the inbox. The report page opens at once (it waited up to 4 s). */
          try { window.localStorage.removeItem(CKEY); } catch (e) { /* ignore */ }
          window.location.href = ROOT + "/pages/diagnosis-report?t=" + encodeURIComponent(x.j.token);
        });
    };
    var chain = !files.length ? send([]) :
      fetch(API + "/diag2/upload", { method: "POST", headers: { "content-type": "application/json" },
        body: JSON.stringify({ files: files.map(function (f) { return { name: f.name, type: f.type, size: f.size }; }) }) })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (!j || !j.ok) throw new Error("upload");
          return Promise.all(j.targets.map(function (t, i) {
            return fetch(t.url, { method: "PUT", headers: { "Content-Type": t.content_type }, body: files[i] })
              .then(function (r) { if (!r.ok) throw new Error("photo"); return t.resource_url; });
          }));
        })
        .then(send);
    chain.catch(function () { S.sending = false; S.err = "send"; render(); });
  }
  function renderError() {
    var box = screenEl("err");
    hint(box, U("err_net"));
    box.appendChild(btn(U("try_again"), "rrc__btn", "data-rrc-retry", function () { S.err = null; post(); }));
  }

  /* S0 (fix 5): saved answers after a reload or a language change -> "Continue" or "Start again" first */
  function renderResume() {
    var box = screenEl("S0", "resume");
    bot(box, U("resume_q"));
    var ul = el("ul", "rrc__chips rrc__chips--sum");
    qsList().forEach(function (q) {
      if (q.state === "pending" || (q.state === "skipped" && !S.answers[q.id])) return;
      ul.appendChild(el("li", "rrc__chip rrc__chip--static", chipText(q.id), "data"));
    });
    if (ul.childNodes.length) box.appendChild(ul);
    var g = el("div", "rrc__actions");
    g.appendChild(btn(U("resume"), "rrc__btn", "data-rrc-resume", function () { S.resume = false; render(); }));
    g.appendChild(btn(U("start_again"), "rrc__btn rrc__btn--ghost", "data-rrc-again", restart));
    box.appendChild(g);
  }
  function againLink(box) {               /* fix 5: "Start again" on every screen */
    if (!box || box.querySelector("[data-rrc-again]")) return;
    var g = el("div", "rrc__actions rrc__actions--again");
    g.appendChild(btn(U("start_again"), "rrc__link", "data-rrc-again", restart));
    box.appendChild(g);
  }

  /* ---------------------------------------------------------------- router */
  /* rrphase2 q4 A (2026-10-23 cc31): the API adds safety_notice when the bike the customer typed (question B6) matches an official
     stop-use battery warning (truth database kb/safety_notices.json). Every word comes from the API (translated there); battery_labels
     are the model numbers exactly as printed on the battery. Shown at the top of every screen after that answer. */
  function safetyBox(sn) {
    var b = el("div", "rrc__safety", null, "safety");
    b.setAttribute("role", "alert");
    b.appendChild(el("strong", null, sn.title));
    if (sn.text) b.appendChild(el("p", null, sn.text));
    if (sn.battery_labels) { var p = el("p", "rrc__safetylabels", sn.labels_intro ? sn.labels_intro + " " : ""); p.appendChild(el("b", null, sn.battery_labels)); b.appendChild(p); }
    if (sn.source) b.appendChild(el("p", "rrc__safetysrc", sn.source));
    return b;
  }
  function render() {
    route();
    var box = $("[data-rrc-screen]"), at = box.getAttribute("data-rrc-screen");
    if (S.resp && S.resp.safety_notice && at !== "load" && at !== "err") box.insertBefore(safetyBox(S.resp.safety_notice), box.firstChild);
    if (at !== "load" && at !== "err") againLink(box);
    counter();                            /* after the screen: the counter words depend on the screen (fix 2a) */
    /* F1104-1232hv (newcomer walk R19): Skip / Back sit at the bottom of a long screen; the next screen used to open with its question
       above the window. A new screen whose top is hidden scrolls back to just under the sticky counter bar. */
    var sk = at + "|" + (box.getAttribute("data-rrc-qid") || "");
    if (S.lastScreen && sk !== S.lastScreen && at !== "load") {
      var bh = ($("[data-rrc-bar]") || {}).offsetHeight || 66, top = box.getBoundingClientRect().top;
      if (top < bh) window.scrollBy(0, top - bh - 12);
    }
    if (at !== "load") S.lastScreen = sk;
  }
  function route() {
    if (S.err === "net") { renderError(); return; }
    if (S.resume && S.answers.B1) { if (!S.resp) { bot(screenEl("load"), U("loading"), "counter"); return; } renderResume(); return; }
    if (S.pend.length) { renderConfirm(); return; }
    if (S.photo) { renderPhoto(); return; }
    if (S.stage === "start" || (!S.answers.B1 && S.view !== "handoff")) { S.stage = "start"; renderStart(); return; }
    if (!S.resp) { var b0 = screenEl("load"); bot(b0, U("loading"), "counter"); return; }
    if (S.stage === "code") { renderCode(); return; }
    if (S.stage === "check") { renderCheck(); return; }
    if (S.stage === "fixed") { renderFixed(); return; }
    var r = S.resp;
    if (partFirst() && S.answers.P0) {     /* chat-10 (retest item 1): the code question after an electric part; none for a mechanical part */
      if (mechNow()) { if (S.code != null || S.codeDone) dropCode(); }
      else if (!S.codeDone && S.view !== "handoff" && !(S.cur === "P0" && S.edit)) { S.stage = "code"; save(); renderCode(); return; }
    }
    if (S.view === "handoff") { renderHandoff(S.mode || "help"); return; }
    if (S.cur && S.edit && findQ(S.cur)) { renderQuestion(findQ(S.cur)); return; }
    if (r.status === "source") { renderHandoff("source"); return; }
    if (r.next && findQ(r.next)) { S.cur = r.next; renderQuestion(findQ(r.next)); return; }
    if (S.view === "results" && gateOpen(r)) { renderResults(); return; }
    renderSummary();
  }
  function restart() {
    S.answers = {}; S.notes = {}; S.skipped = []; S.cur = null; S.stage = "start"; S.code = null; S.check = 0; S.pend = []; S.photos = [];
    S.view = null; S.mode = null; S.part = null; S.edit = false; S.photo = null; S.err = null; S.consent = false; S.message = "";
    S.carry = {}; S.carryDone = {}; S.branch = ""; S.resume = false; S.typed = null; S.noteOpen = false; S.otherOpen = null; S.ret = null; S.resetAsk = false;
    S.p0m = null; S.codeDone = false;
    S.resp = null;                        /* chat-10 (retest item 4): the first screen shows at once; the counter says "Loading" until the engine answers */
    try { window.localStorage.removeItem(KEY); window.localStorage.removeItem(CKEY); } catch (e) { /* ignore */ }
    closeDrawer(); render(); post();
  }

  /* section words outside the screens */
  if (DICT) {
    Array.prototype.forEach.call(root.querySelectorAll("[data-rrc-t]"), function (n) { var en = n.textContent.replace(/\s+/g, " ").trim(); if (DICT[en]) n.textContent = DICT[en]; });
    var lg = document.querySelector("[data-rrc-legal]");
    if (lg && DICT[UI.legal[0]]) lg.textContent = DICT[UI.legal[0]];
  }
  function barMode() {                         /* sticky in the tool; fixed once the tool ends (bar height measured; padding keeps the layout still) */
    var bar = $("[data-rrc-bar]"), h = bar.offsetHeight || 66;
    var pad = parseFloat(getComputedStyle(root).paddingBottom) || 0;          /* sticky stops at the content box: count the bottom padding */
    var on = root.getBoundingClientRect().bottom < h + pad + 4;
    root.classList.toggle("rrc--barfixed", on);
    root.style.paddingTop = on ? h + "px" : "";
  }
  window.addEventListener("scroll", barMode, { passive: true });
  window.addEventListener("resize", barMode);
  $("[data-rrc-counter]").addEventListener("click", openDrawer);
  $("[data-rrc-close]").addEventListener("click", closeDrawer);
  $("[data-rrc-close]").setAttribute("aria-label", U("close"));
  $("[data-rrc-restart]").addEventListener("click", restart);
  $("[data-rrc-drawer]").addEventListener("click", function (e) { if (e.target === $("[data-rrc-drawer]")) closeDrawer(); });
  load();
  /* F1104-1232hv (cc27, newcomer walk R1): home page cards and buttons link here with ?sym=<B1 value>. A symptom that differs from the
     saved chat starts a fresh chat at that symptom (same resets as restart(), no extra screen); the same symptom keeps "Continue / Start
     again". The parameter is taken out of the address, so a reload or a language change does not reset again. */
  (function () {
    var m = /[?&]sym=([a-z_]+)/.exec(window.location.search), v = m ? m[1] : "";
    if (!/^(motor_off|display_off|cuts_out|no_charge|broken|idk)$/.test(v) || window.location.hash === "#send-photos") return;
    var cur = S.answers.B1 ? (S.answers.B1.v || "idk") : "";
    if (cur !== v) {
      S.answers = {}; S.notes = {}; S.skipped = []; S.cur = null; S.code = null; S.check = 0; S.pend = []; S.photos = [];
      S.carry = {}; S.carryDone = {}; S.branch = ""; S.resume = false; S.codeDone = false; S.resp = null;
      S.answers.B1 = v === "idk" ? { idk: true } : { v: v };
      S.stage = symStage();
      save();
    }
    try {
      var q = window.location.search.replace(/([?&])sym=[^&#]*&?/, "$1").replace(/[?&]$/, "");
      window.history.replaceState(window.history.state, "", window.location.pathname + q + window.location.hash);
    } catch (e) { /* ignore */ }
  })();
  if (window.location.hash === "#send-photos") { S.stage = "flow"; S.view = "handoff"; S.mode = "help"; S.resume = false; }
  post();
})();
